import React, { useState, useEffect } from 'react';
import { Plus, Users, DollarSign, Trash2, Download, FileText, UserCheck, Repeat, Search, TrendingUp, Calendar, ArrowLeftRight, AlertCircle, CheckCircle, Edit, Mail, Phone, CreditCard, Shield, UserPlus, UserMinus, Calculator, Split, BarChart3, PieChart, Activity, Target, Filter, SortAsc, SortDesc, Clock, Eye, Banknote, Receipt, User, MapPin, ChevronDown, ChevronUp, MessageSquare } from 'lucide-react';
import { supabase } from './supabaseClient';
import * as sync from './supabaseHelpers';

const MonarchTradeGroup = () => {
  // État pour l'authentification
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [loginData, setLoginData] = useState({ username: '', password: '' });
  const [loginError, setLoginError] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [rememberMe, setRememberMe] = useState(false);
  const [isLoggingIn, setIsLoggingIn] = useState(false);

  // Utilisateurs autorisés
  const authorizedUsers = ['Monarch1', 'Monarch2', 'Monarch3'];
  const validPassword = '@MonarchTradeGroup2025';

  // Vérifier la session au chargement
  useEffect(() => {
    const savedSession = localStorage.getItem('monarchSession');
    if (savedSession) {
      const sessionData = JSON.parse(savedSession);
      const sessionAge = Date.now() - sessionData.timestamp;
      // Session valide pendant 24 heures
      if (sessionAge < 24 * 60 * 60 * 1000) {
        setIsAuthenticated(true);
      } else {
        localStorage.removeItem('monarchSession');
      }
    }
  }, []);

  const [membres, setMembres] = useState([]);
  
  const [employes, setEmployes] = useState([]);

  const [depenses, setDepenses] = useState([]);
  const [entrees, setEntrees] = useState([]);
  const [factures, setFactures] = useState([]);
  const [salaires, setSalaires] = useState([]);
  const [depensesRecurrentes, setDepensesRecurrentes] = useState([
    { id: 1, description: 'Loyer Bureau', montant: 1500, categorie: 'logement', frequence: 'mensuel', actif: true, prochainePaie: '2025-08-01' },
    { id: 2, description: 'Assurance Véhicules', montant: 350, categorie: 'transport-assurance', frequence: 'mensuel', actif: true, prochainePaie: '2025-08-05' }
  ]);

  const [ongletActif, setOngletActif] = useState('depenses');
  const [filtreCategorie, setFiltreCategorie] = useState('toutes');
  const [recherche, setRecherche] = useState('');
  const [triActif, setTriActif] = useState({ champ: 'date', ordre: 'desc' });
  const [filtreAvance, setFiltreAvance] = useState({
    dateDebut: '',
    dateFin: '',
    montantMin: '',
    montantMax: '',
    devise: 'toutes',
    payePar: 'tous'
  });
  const [affichageAvance, setAffichageAvance] = useState(false);
  const [affichageModal, setAffichageModal] = useState({ 
    membre: false, 
    depense: false, 
    entree: false,
    facture: false, 
    salaire: false, 
    employe: false,
    recurrente: false,
    credit: false,
    remboursement: false
  });

  const [nouveauMembre, setNouveauMembre] = useState({ nom: '', email: '', couleur: '#10B981', role: 'member', telephone: '', iban: '' });
  const [membreAModifier, setMembreAModifier] = useState(null);
  const [nouvelEmploye, setNouvelEmploye] = useState({ nom: '', poste: '', salaire: '', iban: '', email: '' });
  const [depenseAModifier, setDepenseAModifier] = useState(null);
  const [nouvelleDepense, setNouvelleDepense] = useState({
    description: '',
    montant: '',
    payePar: 1,
    typeRepartition: 'egal',
    participants: [1, 2],
    repartitionPersonnalisee: {},
    categorie: 'restaurant',
    devise: 'EUR',
    methodesPaiement: 'especes'
  });

  const [nouvelleEntree, setNouvelleEntree] = useState({
    description: '',
    montant: '',
    payePar: 1,
    typeRepartition: 'egal',
    participants: [1, 2],
    repartitionPersonnalisee: {},
    categorie: 'vente',
    devise: 'EUR',
    methodesPaiement: 'virement'
  });

  const [nouvelleFacture, setNouvelleFacture] = useState({
    numero: '',
    fournisseur: '',
    montant: '',
    dateEmission: '',
    dateEcheance: '',
    statut: 'en-attente',
    type: 'entrant',
    categorie: 'bureau',
    description: ''
  });

  const [nouveauSalaire, setNouveauSalaire] = useState({
    employeId: 1,
    montant: '',
    mois: new Date().toISOString().slice(0, 7),
    bonus: 0,
    deductions: 0,
    statut: 'en-attente'
  });

  const [nouvelleRecurrente, setNouvelleRecurrente] = useState({
    description: '',
    montant: '',
    categorie: 'bureau',
    frequence: 'mensuel',
    prochainePaie: '',
    actif: true
  });

  // États pour la gestion des crédits
  const [credits, setCredits] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [remboursementsCredits, setRemboursementsCredits] = useState([]);
  const [creditAModifier, setCreditAModifier] = useState(null);
  const [creditExpanded, setCreditExpanded] = useState(null);
  const [isExpanding, setIsExpanding] = useState(false);
  const [nouveauCredit, setNouveauCredit] = useState({
    numeroCredit: '',
    nomClient: '',
    prenomClient: '',
    emailClient: '',
    telephoneClient: '',
    adresseClient: '',
    ibanClient: '',
    montantCredit: '',
    tauxInteret: '',
    dureeCredit: '',
    dateDemande: '',
    dateDebutRemboursement: '',
    montantMensuel: '',
    statut: 'en_attente',
    membresRembourseurs: [],
    repartitionRemboursement: {},
    banque: '',
    estActif: true,
    notes: []
  });
  const [nouveauRemboursement, setNouveauRemboursement] = useState({
    creditId: '',
    montant: '',
    datePaiement: '',
    payePar: '',
    methodesPaiement: 'virement',
    reference: '',
    statut: 'paye'
  });
  
  const [nouvelleNote, setNouvelleNote] = useState('');

  // États pour le système de facturation belge
  const [clientsBelges, setClientsBelges] = useState([]);
  const [produitsBelges, setProduitsBelges] = useState([]);
  const [facturesBelges, setFacturesBelges] = useState([]);
  const [nouveauClientBelge, setNouveauClientBelge] = useState({
    nom: '',
    prenom: '',
    entreprise: '',
    numeroTVA: '',
    adresse: '',
    codePostal: '',
    ville: '',
    pays: 'Belgique',
    telephone: '',
    email: '',
    langue: 'fr',
    iban: '',
    notes: ''
  });
  const [nouveauProduitBelge, setNouveauProduitBelge] = useState({
    nom: '',
    description: '',
    prix: '',
    unite: 'pièce',
    tauxTVA: '21',
    categorie: 'produit',
    code: '',
    stock: '',
    prixAchat: ''
  });
  const [nouvelleFactureBelge, setNouvelleFactureBelge] = useState({
    numero: '',
    clientId: '',
    dateEmission: '',
    dateEcheance: '',
    items: [],
    remise: 0,
    acompte: 0,
    notes: '',
    conditionsPaiement: 'virement',
    langue: 'fr',
    statut: 'brouillon'
  });
  const [affichageModalBelge, setAffichageModalBelge] = useState({
    client: false,
    produit: false,
    facture: false,
    previewFacture: false
  });

  // Taux TVA belges officiels
  const tauxTVABelges = {
    '0': { taux: 0, nom: 'Exonéré' },
    '6': { taux: 6, nom: 'Réduit (6%)' },
    '12': { taux: 12, nom: 'Intermédiaire (12%)' },
    '21': { taux: 21, nom: 'Normal (21%)' }
  };

  // Unités de mesure
  const unitesMesure = [
    'pièce', 'kg', 'g', 'l', 'ml', 'm', 'cm', 'mm', 'm²', 'm³', 
    'heure', 'jour', 'mois', 'année', 'forfait', 'lot'
  ];

  // Catégories de produits/services
  const categoriesProduits = {
    'produit': { nom: 'Produit', icone: '📦' },
    'service': { nom: 'Service', icone: '🔧' },
    'consultation': { nom: 'Consultation', icone: '💼' },
    'formation': { nom: 'Formation', icone: '📚' },
    'location': { nom: 'Location', icone: '🏠' },
    'transport': { nom: 'Transport', icone: '🚛' },
    'logiciel': { nom: 'Logiciel', icone: '💻' },
    'autre': { nom: 'Autre', icone: '📋' }
  };

  // Catégories étendues pour MONARCH TRADE GROUP
  const categories = {
    // Commerce & Business
    'cigarettes-electroniques': { nom: 'Cigarettes Électroniques', icone: '💨', couleur: '#8B5CF6' },
    'alcool': { nom: 'Alcool & Spiritueux', icone: '🍷', couleur: '#EC4899' },
    'restaurant': { nom: 'Restaurant & Repas', icone: '🍽️', couleur: '#F59E0B' },
    'vetements': { nom: 'Vêtements & Mode', icone: '👔', couleur: '#06B6D4' },
    'crypto': { nom: 'Investissement Crypto', icone: '₿', couleur: '#F97316' },
    
    // Transport & Logistique
    'transport-location': { nom: 'Location Véhicules', icone: '🚗', couleur: '#3B82F6' },
    'transport-leasing': { nom: 'Leasing Véhicules', icone: '🏎️', couleur: '#1E40AF' },
    'transport-essence': { nom: 'Carburant & Essence', icone: '⛽', couleur: '#DC2626' },
    'transport-marchandise': { nom: 'Transport Marchandise', icone: '🚛', couleur: '#059669' },
    'transport-kilometrique': { nom: 'Frais Kilométriques', icone: '📍', couleur: '#7C3AED' },
    'transport-camionnette': { nom: 'Factures Camionnettes', icone: '🚐', couleur: '#0891B2' },
    'transport-assurance': { nom: 'Assurance Véhicules', icone: '🛡️', couleur: '#059669' },
    'transport-entretien': { nom: 'Entretien Véhicules', icone: '🔧', couleur: '#EA580C' },
    
    // Bureau & Administration
    'bureau': { nom: 'Fournitures Bureau', icone: '🏢', couleur: '#6B7280' },
    'marketing': { nom: 'Marketing & Pub', icone: '📈', couleur: '#10B981' },
    'logement': { nom: 'Loyer & Charges', icone: '🏠', couleur: '#84CC16' },
    'equipement': { nom: 'Équipement Tech', icone: '💻', couleur: '#6366F1' },
    'formation': { nom: 'Formation & Livres', icone: '📚', couleur: '#8B5CF6' },
    'juridique': { nom: 'Frais Juridiques', icone: '⚖️', couleur: '#374151' },
    'bancaire': { nom: 'Frais Bancaires', icone: '🏦', couleur: '#DC2626' },
    'assurance': { nom: 'Assurances', icone: '🛡️', couleur: '#059669' },
    'salaires': { nom: 'Salaires & Charges', icone: '👥', couleur: '#7C2D12' },
    'autres': { nom: 'Autres Dépenses', icone: '📋', couleur: '#6B7280' }
  };

  const categoriesEntrees = {
    // Revenus Commerce & Business
    'vente': { nom: 'Ventes Produits', icone: '💰', couleur: '#10B981' },
    'service': { nom: 'Prestations Services', icone: '🔧', couleur: '#3B82F6' },
    'commission': { nom: 'Commissions', icone: '📊', couleur: '#8B5CF6' },
    'partenariat': { nom: 'Revenus Partenariats', icone: '🤝', couleur: '#06B6D4' },
    'investissement': { nom: 'Retour Investissement', icone: '📈', couleur: '#059669' },
    'subvention': { nom: 'Subventions & Aides', icone: '🏛️', couleur: '#F59E0B' },
    'remboursement': { nom: 'Remboursements Reçus', icone: '↩️', couleur: '#84CC16' },
    'location': { nom: 'Revenus Locatifs', icone: '🏠', couleur: '#EC4899' },
    'formation': { nom: 'Revenus Formation', icone: '📚', couleur: '#7C3AED' },
    'autres-revenus': { nom: 'Autres Revenus', icone: '💵', couleur: '#6B7280' }
  };

  const devises = ['EUR', 'USD', 'BTC', 'ETH', 'ADA', 'DOT', 'SOL', 'AVAX'];
  // eslint-disable-next-line no-unused-vars
  const methodesPaiement = ['especes', 'carte', 'virement', 'crypto', 'cheque', 'paypal'];
  // eslint-disable-next-line no-unused-vars
  const frequences = ['hebdomadaire', 'mensuel', 'trimestriel', 'annuel'];
  // eslint-disable-next-line no-unused-vars
  const statutsFacture = ['en-attente', 'payee', 'retard', 'annulee'];
  // eslint-disable-next-line no-unused-vars
  const statutsSalaire = ['en-attente', 'paye', 'retard'];
  // eslint-disable-next-line no-unused-vars
  const statutsCredit = ['en_attente', 'approuve', 'actif', 'termine', 'retard', 'annule'];

  const couleursMembres = ['#3B82F6', '#EF4444', '#10B981', '#F59E0B', '#8B5CF6', '#EC4899', '#06B6D4'];
  
  // État pour la migration
  const [showMigrationButton, setShowMigrationButton] = useState(false);
  
  // État pour la facturation belge
  const [sousOngletFacturation, setSousOngletFacturation] = useState('dashboard');

  // Chargement des données depuis Supabase
  useEffect(() => {
    const loadDataFromSupabase = async () => {
      try {
        // Charger toutes les données depuis Supabase
        const [
          { data: membresData },
          { data: employesData },
          { data: depensesData },
          { data: entreesData },
          { data: facturesData },
          { data: salairesData },
          { data: depensesRecurrentesData },
          { data: creditsData },
          { data: remboursementsCreditsData },
          { data: clientsBelgesData },
          { data: produitsBelgesData },
          { data: facturesBelgesData }
        ] = await Promise.all([
          supabase.from('membres').select('*').order('id'),
          supabase.from('employes').select('*').order('id'),
          supabase.from('depenses').select('*').order('id'),
          supabase.from('entrees').select('*').order('id'),
          supabase.from('factures').select('*').order('id'),
          supabase.from('salaires').select('*').order('id'),
          supabase.from('depenses_recurrentes').select('*').order('id'),
          supabase.from('credits').select('*').order('id'),
          supabase.from('remboursements_credits').select('*').order('id'),
          supabase.from('clients_belges').select('*').order('id'),
          supabase.from('produits_belges').select('*').order('id'),
          supabase.from('factures_belges').select('*').order('id')
        ]);

        // Mettre à jour les états avec les données de Supabase
        if (membresData && membresData.length > 0) setMembres(membresData);
        else {
          // Initialiser avec les données par défaut si aucun membre n'existe
          setMembres([
            { id: 1, nom: 'Directeur', email: 'directeur@monarchtrade.com', couleur: '#3B82F6', role: 'admin' },
            { id: 2, nom: 'Associé', email: 'associe@monarchtrade.com', couleur: '#EF4444', role: 'partner' }
          ]);
        }
        
        if (employesData) setEmployes(employesData);
        if (depensesData) setDepenses(depensesData);
        if (entreesData) setEntrees(entreesData);
        if (facturesData) setFactures(facturesData);
        if (salairesData) setSalaires(salairesData);
        if (depensesRecurrentesData) setDepensesRecurrentes(depensesRecurrentesData);
        if (creditsData) setCredits(creditsData);
        if (remboursementsCreditsData) setRemboursementsCredits(remboursementsCreditsData);
        if (clientsBelgesData) setClientsBelges(clientsBelgesData);
        if (produitsBelgesData) setProduitsBelges(produitsBelgesData);
        if (facturesBelgesData) setFacturesBelges(facturesBelgesData);

      } catch (error) {
        console.error('Erreur lors du chargement depuis Supabase:', error);
        
        // Fallback vers localStorage si Supabase échoue
        const savedData = localStorage.getItem('monarchTradeGroup');
        if (savedData) {
          try {
            const data = JSON.parse(savedData);
            if (data.membres) setMembres(data.membres);
            if (data.employes) setEmployes(data.employes);
            if (data.depenses) setDepenses(data.depenses);
            if (data.entrees) setEntrees(data.entrees);
            if (data.factures) setFactures(data.factures);
            if (data.salaires) setSalaires(data.salaires);
            if (data.depensesRecurrentes) setDepensesRecurrentes(data.depensesRecurrentes);
            if (data.credits) setCredits(data.credits);
            if (data.remboursementsCredits) setRemboursementsCredits(data.remboursementsCredits);
            if (data.clientsBelges) setClientsBelges(data.clientsBelges);
            if (data.produitsBelges) setProduitsBelges(data.produitsBelges);
            if (data.facturesBelges) setFacturesBelges(data.facturesBelges);
            
            // Montrer le bouton de migration s'il y a des données locales
            setShowMigrationButton(true);
          } catch (error) {
            console.error('Erreur lors du chargement des données locales:', error);
          }
        }
      }
      
      setIsLoading(false);
    };

    loadDataFromSupabase();
  }, []);

  // Sauvegarde automatique dans localStorage (désactivé - utilise Supabase maintenant)
  // useEffect(() => {
  //   if (!isLoading) {
  //     const data = {
  //       membres,
  //       employes,
  //       depenses,
  //       entrees,
  //       factures,
  //       salaires,
  //       depensesRecurrentes,
  //       credits,
  //       remboursementsCredits,
  //       clientsBelges,
  //       produitsBelges,
  //       facturesBelges
  //     };
  //     localStorage.setItem('monarchTradeGroup', JSON.stringify(data));
  //   }
  // }, [membres, employes, depenses, entrees, factures, salaires, depensesRecurrentes, credits, remboursementsCredits, clientsBelges, produitsBelges, facturesBelges, isLoading]);

  // Gestion de la touche Escape pour fermer les modales
  useEffect(() => {
    const handleEscape = (event) => {
      if (event.key === 'Escape') {
        const isModalOpen = Object.values(affichageModal).some(modal => modal === true);
        if (isModalOpen) {
          fermerToutesLesModales();
        }
      }
    };

    const isModalOpen = Object.values(affichageModal).some(modal => modal === true);
    
    if (isModalOpen) {
      document.addEventListener('keydown', handleEscape);
    }

    return () => {
      document.removeEventListener('keydown', handleEscape);
    };
  }, [affichageModal]);

  // Fonction utilitaire pour fermer toutes les modales
  const fermerToutesLesModales = () => {
    setAffichageModal({
      membre: false,
      depense: false,
      entree: false,
      facture: false,
      salaire: false,
      recurrente: false,
      employe: false,
      credit: false,
      remboursement: false
    });
    
    setAffichageModalBelge({
      client: false,
      produit: false,
      facture: false,
      previewFacture: false
    });
    
    // Réinitialiser les états de modification
    setMembreAModifier(null);
    setCreditAModifier(null);
    setDepenseAModifier(null);
  };

  // Composant réutilisable pour l'overlay des modales - VERSION SIMPLIFIÉE
  const ModalOverlay = ({ children, onClose }) => (
    <div 
      className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50"
      onClick={(e) => {
        if (e.target === e.currentTarget) {
          onClose ? onClose() : fermerToutesLesModales();
        }
      }}
    >
      {children}
    </div>
  );

  // Traitement des dépenses récurrentes
  const traiterDepensesRecurrentes = () => {
    const aujourdhui = new Date().toISOString().split('T')[0];
    const nouvellesDepenses = [];
    const recurrentesAMettreAJour = [];

    depensesRecurrentes.forEach(recurrente => {
      if (recurrente.actif && recurrente.prochainePaie <= aujourdhui) {
        const id = Math.max(...depenses.map(e => e.id), 0) + nouvellesDepenses.length + 1;
        const nouvelleDepense = {
          id,
          description: `${recurrente.description} (Récurrent)`,
          montant: recurrente.montant.toString(),
          payePar: membres[0]?.id || 1,
          typeRepartition: 'egal',
          participants: membres.map(m => m.id),
          categorie: recurrente.categorie,
          devise: 'EUR',
          methodesPaiement: 'virement',
          date: aujourdhui,
          heure: new Date().toLocaleTimeString(),
          recurrente: true
        };
        
        nouvellesDepenses.push(nouvelleDepense);
        
        const prochaine = new Date(recurrente.prochainePaie);
        switch (recurrente.frequence) {
          case 'hebdomadaire':
            prochaine.setDate(prochaine.getDate() + 7);
            break;
          case 'mensuel':
            prochaine.setMonth(prochaine.getMonth() + 1);
            break;
          case 'trimestriel':
            prochaine.setMonth(prochaine.getMonth() + 3);
            break;
          case 'annuel':
            prochaine.setFullYear(prochaine.getFullYear() + 1);
            break;
          default:
            // Par défaut, traiter comme mensuel
            prochaine.setMonth(prochaine.getMonth() + 1);
            break;
        }
        
        recurrentesAMettreAJour.push({
          ...recurrente,
          prochainePaie: prochaine.toISOString().split('T')[0]
        });
      }
    });

    if (nouvellesDepenses.length > 0) {
      setDepenses(prev => [...prev, ...nouvellesDepenses]);
    }
    if (recurrentesAMettreAJour.length > 0) {
      setDepensesRecurrentes(prev => 
        prev.map(r => {
          const mise_a_jour = recurrentesAMettreAJour.find(ru => ru.id === r.id);
          return mise_a_jour || r;
        })
      );
    }
  };

  useEffect(() => {
    traiterDepensesRecurrentes();
    const intervalId = setInterval(traiterDepensesRecurrentes, 3600000); // 1 heure
    return () => clearInterval(intervalId);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [depensesRecurrentes, membres, depenses]);

  // Calcul des soldes entre membres
  const calculerSoldes = () => {
    const soldes = {};
    membres.forEach(membre => {
      soldes[membre.id] = 0;
    });

    // Calcul basé sur TOUTES les dépenses (pas de filtrage pour les soldes)
    depenses.forEach(depense => {
      const montant = parseFloat(depense.montant);
      const nombreParticipants = depense.participants.length;
      
      if (depense.typeRepartition === 'egal') {
        const montantReparti = montant / nombreParticipants;
        soldes[depense.payePar] += montant;
        depense.participants.forEach(participantId => {
          soldes[participantId] -= montantReparti;
        });
      } else if (depense.typeRepartition === 'personnalise') {
        soldes[depense.payePar] += montant;
        depense.participants.forEach(participantId => {
          const montantPersonnalise = depense.repartitionPersonnalisee[participantId] || 0;
          soldes[participantId] -= montantPersonnalise;
        });
      }
    });

    return soldes;
  };

  // Calcul des remboursements optimisés
  const calculerRemboursements = () => {
    const soldes = calculerSoldes();
    const remboursements = [];
    
    // Séparer créditeurs et débiteurs
    const crediteurs = [];
    const debiteurs = [];
    
    Object.entries(soldes).forEach(([membreId, solde]) => {
      if (solde > 0.01) {
        crediteurs.push({ id: parseInt(membreId), montant: solde });
      } else if (solde < -0.01) {
        debiteurs.push({ id: parseInt(membreId), montant: Math.abs(solde) });
      }
    });
    
    // Trier par montant décroissant
    crediteurs.sort((a, b) => b.montant - a.montant);
    debiteurs.sort((a, b) => b.montant - a.montant);
    
    // Algorithme de remboursement optimisé
    let i = 0, j = 0;
    while (i < crediteurs.length && j < debiteurs.length) {
      const crediteur = crediteurs[i];
      const debiteur = debiteurs[j];
      
      const montantRembourse = Math.min(crediteur.montant, debiteur.montant);
      
      if (montantRembourse > 0.01) {
        remboursements.push({
          de: debiteur.id,
          vers: crediteur.id,
          montant: montantRembourse
        });
      }
      
      crediteur.montant -= montantRembourse;
      debiteur.montant -= montantRembourse;
      
      if (crediteur.montant < 0.01) i++;
      if (debiteur.montant < 0.01) j++;
    }
    
    return remboursements;
  };

  // Calcul des totaux
  const totalDepenses = depenses.reduce((somme, exp) => somme + parseFloat(exp.montant), 0);
  const totalEntrees = entrees.reduce((somme, ent) => somme + parseFloat(ent.montant), 0);
  const totalCredits = credits.reduce((somme, credit) => {
    return somme + parseFloat(credit.montantCredit || 0);
  }, 0);
  const totalFactures = factures.reduce((somme, fact) => somme + parseFloat(fact.montant), 0);
  const totalSalaires = salaires.reduce((somme, sal) => somme + parseFloat(sal.montantNet), 0);
  const totalGeneral = totalEntrees + totalCredits - totalDepenses - totalFactures - totalSalaires;

  // Fonction de migration des données locales vers Supabase
  const migrerDonneesVersSupabase = async () => {
    if (!window.confirm('Voulez-vous migrer toutes vos données locales vers le cloud ?')) return;
    
    try {
      const results = await sync.migrateLocalDataToSupabase();
      if (results.errors.length === 0) {
        alert(`Migration réussie ! ${results.success} éléments migrés.`);
        setShowMigrationButton(false);
        window.location.reload(); // Recharger pour obtenir les données depuis Supabase
      } else {
        alert(`Migration partielle: ${results.success} réussis, ${results.errors.length} erreurs.`);
        console.error('Erreurs de migration:', results.errors);
      }
    } catch (error) {
      alert('Erreur lors de la migration: ' + error.message);
    }
  };

  // Fonctions d'ajout
  const ajouterMembre = async () => {
    if (nouveauMembre.nom.trim()) {
      try {
        const couleur = couleursMembres[membres.length % couleursMembres.length];
        
        // Insérer dans Supabase
        const { data, error } = await supabase
          .from('membres')
          .insert([{ ...nouveauMembre, couleur }])
          .select()
          .single();
        
        if (error) throw error;
        
        // Mettre à jour l'état local
        setMembres([...membres, data]);
        setNouveauMembre({ nom: '', email: '', couleur: '#10B981', role: 'member', telephone: '', iban: '' });
        setAffichageModal({ ...affichageModal, membre: false });
      } catch (error) {
        console.error('Erreur lors de l\'ajout du membre:', error);
        alert('Erreur lors de l\'ajout du membre');
      }
    }
  };

  const modifierMembreConfirmer = () => {
    setMembres(membres.map(m => m.id === membreAModifier.id ? membreAModifier : m));
    setAffichageModal({ ...affichageModal, membre: false });
    setMembreAModifier(null);
  };

  // Fonctions pour la gestion des crédits
  const ajouterCredit = () => {
    if (nouveauCredit.numeroCredit && nouveauCredit.nomClient && nouveauCredit.montantCredit) {
      const id = Math.max(...credits.map(c => c.id), 0) + 1;
      const montantMensuel = parseFloat(nouveauCredit.montantCredit) * (1 + parseFloat(nouveauCredit.tauxInteret) / 100) / parseInt(nouveauCredit.dureeCredit);
      
      setCredits([...credits, {
        ...nouveauCredit,
        id,
        montantMensuel: montantMensuel.toFixed(2),
        dateCreation: new Date().toISOString().split('T')[0],
        membresRembourseurs: nouveauCredit.membresRembourseurs.length > 0 ? nouveauCredit.membresRembourseurs : [membres[0]?.id]
      }]);
      
      setNouveauCredit({
        numeroCredit: '',
        nomClient: '',
        prenomClient: '',
        emailClient: '',
        telephoneClient: '',
        adresseClient: '',
        ibanClient: '',
        montantCredit: '',
        tauxInteret: '',
        dureeCredit: '',
        dateDemande: '',
        dateDebutRemboursement: '',
        montantMensuel: '',
        statut: 'approuve',
        membresRembourseurs: [],
        repartitionRemboursement: {},
        banque: '',
        estActif: true,
        notes: []
      });
      
      setAffichageModal({...affichageModal, credit: false});
      setNouvelleNote('');
    }
  };

  const modifierCreditConfirmer = () => {
    const montantMensuel = parseFloat(creditAModifier.montantCredit) * (1 + parseFloat(creditAModifier.tauxInteret) / 100) / parseInt(creditAModifier.dureeCredit);
    
    setCredits(credits.map(c => c.id === creditAModifier.id ? {
      ...creditAModifier,
      montantMensuel: montantMensuel.toFixed(2)
    } : c));
    
    setCreditAModifier(null);
    setAffichageModal({...affichageModal, credit: false});
    setNouvelleNote('');
  };

  const ajouterRemboursement = () => {
    if (nouveauRemboursement.creditId && nouveauRemboursement.montant && nouveauRemboursement.payePar) {
      const id = Math.max(...remboursementsCredits.map(r => r.id), 0) + 1;
      
      setRemboursementsCredits([...remboursementsCredits, {
        ...nouveauRemboursement,
        id,
        creditId: parseInt(nouveauRemboursement.creditId),
        payePar: parseInt(nouveauRemboursement.payePar),
        dateCreation: new Date().toISOString().split('T')[0]
      }]);
      
      setNouveauRemboursement({
        creditId: '',
        montant: '',
        datePaiement: '',
        payePar: '',
        methodesPaiement: 'virement',
        reference: '',
        statut: 'paye'
      });
      
      setAffichageModal({...affichageModal, remboursement: false});
    }
  };

  const obtenirStatutCredit = (credit) => {
    const totalRembourse = remboursementsCredits
      .filter(r => r.creditId === credit.id)
      .reduce((total, r) => total + parseFloat(r.montant), 0);
    
    const montantTotal = parseFloat(credit.montantCredit) * (1 + parseFloat(credit.tauxInteret) / 100);
    
    if (totalRembourse >= montantTotal) {
      return 'termine';
    } else if (credit.dateDebutRemboursement && new Date(credit.dateDebutRemboursement) <= new Date()) {
      return 'actif';
    } else if (credit.statut === 'approuve') {
      return 'approuve';
    } else {
      return credit.statut;
    }
  };

  const obtenirProchainEcheance = (credit) => {
    if (!credit.dateDebutRemboursement) return null;
    
    const remboursementsCredit = remboursementsCredits.filter(r => r.creditId === credit.id);
    const nombreRemboursements = remboursementsCredit.length;
    
    const dateDebut = new Date(credit.dateDebutRemboursement);
    const prochaineEcheance = new Date(dateDebut);
    prochaineEcheance.setMonth(prochaineEcheance.getMonth() + nombreRemboursements);
    
    return prochaineEcheance.toISOString().split('T')[0];
  };

  const obtenirCreditsEnRetard = () => {
    const aujourdhui = new Date();
    return credits.filter(credit => {
      const prochainEcheance = obtenirProchainEcheance(credit);
      return prochainEcheance && new Date(prochainEcheance) < aujourdhui && obtenirStatutCredit(credit) === 'actif';
    });
  };

  const ajouterEmploye = () => {
    if (nouvelEmploye.nom && nouvelEmploye.poste && nouvelEmploye.salaire) {
      const id = Math.max(...employes.map(e => e.id), 0) + 1;
      setEmployes([...employes, { id, ...nouvelEmploye, salaire: parseFloat(nouvelEmploye.salaire) }]);
      setNouvelEmploye({ nom: '', poste: '', salaire: '', iban: '', email: '' });
      setAffichageModal({ ...affichageModal, employe: false });
    }
  };

  const ajouterDepense = async () => {
    if (nouvelleDepense.description.trim() && nouvelleDepense.montant && nouvelleDepense.participants.length > 0) {
      let depenseValide = true;
      
      if (nouvelleDepense.typeRepartition === 'personnalise') {
        const totalPersonnalise = nouvelleDepense.participants.reduce((somme, id) => {
          return somme + (parseFloat(nouvelleDepense.repartitionPersonnalisee[id]) || 0);
        }, 0);
        
        if (Math.abs(totalPersonnalise - parseFloat(nouvelleDepense.montant)) > 0.01) {
          alert('La somme des montants personnalisés doit égaler le montant total');
          depenseValide = false;
        }
      }
      
      if (depenseValide) {
        try {
          const nouvelleDate = new Date().toISOString().split('T')[0];
          const depenseData = {
            ...nouvelleDepense,
            montant: parseFloat(nouvelleDepense.montant),
            paye_par: nouvelleDepense.payePar,
            type_repartition: nouvelleDepense.typeRepartition,
            repartition_personnalisee: nouvelleDepense.repartitionPersonnalisee,
            methodes_paiement: nouvelleDepense.methodesPaiement,
            date: nouvelleDate
          };
          
          // Supprimer les champs qui ne correspondent pas à la BD
          delete depenseData.payePar;
          delete depenseData.typeRepartition;
          delete depenseData.repartitionPersonnalisee;
          delete depenseData.methodesPaiement;
          
          const data = await sync.syncDepenses.add(depenseData);
          setDepenses([...depenses, data]);
          
          setNouvelleDepense({
            description: '',
            montant: '',
            payePar: membres[0]?.id || 1,
            typeRepartition: 'egal',
            participants: membres.map(m => m.id),
            repartitionPersonnalisee: {},
            categorie: 'restaurant',
            devise: 'EUR',
            methodesPaiement: 'especes'
          });
          setAffichageModal({ ...affichageModal, depense: false });
        } catch (error) {
          console.error('Erreur lors de l\'ajout de la dépense:', error);
          alert('Erreur lors de l\'ajout de la dépense');
        }
      }
    }
  };

  const modifierDepenseConfirmer = () => {
    if (depenseAModifier.description.trim() && depenseAModifier.montant && depenseAModifier.participants.length > 0) {
      let depenseValide = true;
      
      if (depenseAModifier.typeRepartition === 'personnalise') {
        const totalPersonnalise = depenseAModifier.participants.reduce((somme, id) => {
          return somme + (parseFloat(depenseAModifier.repartitionPersonnalisee[id]) || 0);
        }, 0);
        
        if (Math.abs(totalPersonnalise - parseFloat(depenseAModifier.montant)) > 0.01) {
          alert('La somme des montants personnalisés doit égaler le montant total');
          depenseValide = false;
        }
      }
      
      if (depenseValide) {
        setDepenses(depenses.map(d => d.id === depenseAModifier.id ? depenseAModifier : d));
        setDepenseAModifier(null);
        setAffichageModal({ ...affichageModal, depense: false });
      }
    }
  };

  const ajouterEntree = () => {
    if (nouvelleEntree.description.trim() && nouvelleEntree.montant && nouvelleEntree.participants.length > 0) {
      let entreeValide = true;
      
      if (nouvelleEntree.typeRepartition === 'personnalise') {
        const totalPersonnalise = nouvelleEntree.participants.reduce((somme, id) => {
          return somme + (parseFloat(nouvelleEntree.repartitionPersonnalisee[id]) || 0);
        }, 0);
        
        if (Math.abs(totalPersonnalise - parseFloat(nouvelleEntree.montant)) > 0.01) {
          alert('La somme des montants personnalisés doit égaler le montant total');
          entreeValide = false;
        }
      }
      
      if (entreeValide) {
        const id = Math.max(...entrees.map(e => e.id), 0) + 1;
        const nouvelleDate = new Date().toISOString().split('T')[0];
        setEntrees([...entrees, { id, ...nouvelleEntree, date: nouvelleDate, heure: new Date().toLocaleTimeString(), recurrente: false }]);
        setNouvelleEntree({
          description: '',
          montant: '',
          payePar: membres[0]?.id || 1,
          typeRepartition: 'egal',
          participants: membres.map(m => m.id),
          repartitionPersonnalisee: {},
          categorie: 'vente',
          devise: 'EUR',
          methodesPaiement: 'virement'
        });
        setAffichageModal({ ...affichageModal, entree: false });
      }
    }
  };

  const ajouterFacture = () => {
    if (nouvelleFacture.numero && nouvelleFacture.fournisseur && nouvelleFacture.montant) {
      const id = Math.max(...factures.map(f => f.id), 0) + 1;
      setFactures([...factures, { id, ...nouvelleFacture }]);
      setNouvelleFacture({
        numero: '',
        fournisseur: '',
        montant: '',
        dateEmission: '',
        dateEcheance: '',
        statut: 'en-attente',
        type: 'entrant',
        categorie: 'bureau',
        description: ''
      });
      setAffichageModal({ ...affichageModal, facture: false });
    }
  };

  const ajouterSalaire = () => {
    if (nouveauSalaire.employeId && nouveauSalaire.montant && nouveauSalaire.mois) {
      const id = Math.max(...salaires.map(s => s.id), 0) + 1;
      const employe = employes.find(e => e.id === parseInt(nouveauSalaire.employeId));
      const montantNet = parseFloat(nouveauSalaire.montant) + parseFloat(nouveauSalaire.bonus || 0) - parseFloat(nouveauSalaire.deductions || 0);
      
      setSalaires([...salaires, { 
        id, 
        ...nouveauSalaire, 
        employeId: parseInt(nouveauSalaire.employeId),
        employeNom: employe?.nom,
        montantNet,
        datePaiement: new Date().toISOString().split('T')[0]
      }]);
      
      setNouveauSalaire({
        employeId: employes[0]?.id || 1,
        montant: '',
        mois: new Date().toISOString().slice(0, 7),
        bonus: 0,
        deductions: 0,
        statut: 'en-attente'
      });
      setAffichageModal({ ...affichageModal, salaire: false });
    }
  };

  const ajouterRecurrente = () => {
    if (nouvelleRecurrente.description && nouvelleRecurrente.montant && nouvelleRecurrente.prochainePaie) {
      const id = Math.max(...depensesRecurrentes.map(r => r.id), 0) + 1;
      setDepensesRecurrentes([...depensesRecurrentes, { id, ...nouvelleRecurrente, montant: parseFloat(nouvelleRecurrente.montant) }]);
      setNouvelleRecurrente({
        description: '',
        montant: '',
        categorie: 'bureau',
        frequence: 'mensuel',
        prochainePaie: '',
        actif: true
      });
      setAffichageModal({ ...affichageModal, recurrente: false });
    }
  };

  // ========================================
  // SYSTÈME DE FACTURATION BELGE
  // ========================================

  // Fonction pour valider un numéro TVA belge
  const validerNumeroTVABelge = (numeroTVA) => {
    // Format belge : BE 0XXX.XXX.XXX ou BE0XXXXXXXXX
    const regex = /^BE\s?0\d{3}\.?\d{3}\.?\d{3}$/;
    return regex.test(numeroTVA.toUpperCase());
  };

  // Fonction pour générer un numéro de facture unique
  const genererNumeroFacture = () => {
    const annee = new Date().getFullYear();
    const mois = String(new Date().getMonth() + 1).padStart(2, '0');
    const existantes = facturesBelges.filter(f => f.numero.startsWith(`${annee}${mois}`));
    const numero = String(existantes.length + 1).padStart(4, '0');
    return `${annee}${mois}-${numero}`;
  };

  // Fonctions CRUD pour les clients belges
  const ajouterClientBelge = async () => {
    if (nouveauClientBelge.nom && nouveauClientBelge.email) {
      try {
        const clientData = {
          ...nouveauClientBelge,
          numero_tva: nouveauClientBelge.numeroTVA,
          code_postal: nouveauClientBelge.codePostal
        };
        delete clientData.numeroTVA;
        delete clientData.codePostal;
        
        const data = await sync.syncClientsBelges.add(clientData);
        setClientsBelges([...clientsBelges, data]);
        
        setNouveauClientBelge({
          nom: '',
          prenom: '',
          entreprise: '',
          numeroTVA: '',
          adresse: '',
          codePostal: '',
          ville: '',
          pays: 'Belgique',
          telephone: '',
          email: '',
          langue: 'fr',
          iban: '',
          notes: ''
        });
        setAffichageModalBelge({ ...affichageModalBelge, client: false });
      } catch (error) {
        console.error('Erreur lors de l\'ajout du client:', error);
        alert('Erreur lors de l\'ajout du client');
      }
    }
  };

  const ajouterProduitBelge = async () => {
    if (nouveauProduitBelge.nom && nouveauProduitBelge.prix) {
      try {
        const produitData = {
          ...nouveauProduitBelge,
          prix: parseFloat(nouveauProduitBelge.prix),
          taux_tva: nouveauProduitBelge.tauxTVA,
          prix_achat: parseFloat(nouveauProduitBelge.prixAchat || 0),
          stock: parseFloat(nouveauProduitBelge.stock || 0)
        };
        delete produitData.tauxTVA;
        delete produitData.prixAchat;
        
        const data = await sync.syncProduitsBelges.add(produitData);
        setProduitsBelges([...produitsBelges, data]);
        
        setNouveauProduitBelge({
          nom: '',
          description: '',
          prix: '',
          unite: 'pièce',
          tauxTVA: '21',
          categorie: 'produit',
          code: '',
          stock: '',
          prixAchat: ''
        });
        setAffichageModalBelge({ ...affichageModalBelge, produit: false });
      } catch (error) {
        console.error('Erreur lors de l\'ajout du produit:', error);
        alert('Erreur lors de l\'ajout du produit');
      }
    }
  };

  const ajouterFactureBelge = () => {
    if (nouvelleFactureBelge.clientId && nouvelleFactureBelge.items.length > 0) {
      const id = Math.max(...facturesBelges.map(f => f.id || 0), 0) + 1;
      const numero = nouvelleFactureBelge.numero || genererNumeroFacture();
      
      // Calculer les totaux
      let sousTotal = 0;
      let totalTVA = 0;
      
      nouvelleFactureBelge.items.forEach(item => {
        const produit = produitsBelges.find(p => p.id === item.produitId);
        if (produit) {
          const montantLigne = item.quantite * item.prixUnitaire;
          sousTotal += montantLigne;
          const tva = montantLigne * (tauxTVABelges[produit.tauxTVA].taux / 100);
          totalTVA += tva;
        }
      });
      
      const remise = (sousTotal * (nouvelleFactureBelge.remise || 0)) / 100;
      const totalHT = sousTotal - remise;
      const totalTTC = totalHT + totalTVA;
      
      setFacturesBelges([...facturesBelges, { 
        id, 
        numero,
        ...nouvelleFactureBelge,
        sousTotal,
        totalTVA,
        totalHT,
        totalTTC,
        dateCreation: new Date().toISOString()
      }]);
      
      setNouvelleFactureBelge({
        numero: '',
        clientId: '',
        dateEmission: '',
        dateEcheance: '',
        items: [],
        remise: 0,
        acompte: 0,
        notes: '',
        conditionsPaiement: 'virement',
        langue: 'fr',
        statut: 'brouillon'
      });
      setAffichageModalBelge({ ...affichageModalBelge, facture: false });
    }
  };

  // Fonction pour ajouter un produit à la facture
  const ajouterProduitAFacture = (produitId, quantite = 1) => {
    const produit = produitsBelges.find(p => p.id === produitId);
    if (produit) {
      const itemExistant = nouvelleFactureBelge.items.find(item => item.produitId === produitId);
      if (itemExistant) {
        // Augmenter la quantité si le produit existe déjà
        setNouvelleFactureBelge({
          ...nouvelleFactureBelge,
          items: nouvelleFactureBelge.items.map(item =>
            item.produitId === produitId
              ? { ...item, quantite: item.quantite + quantite }
              : item
          )
        });
      } else {
        // Ajouter le nouveau produit
        setNouvelleFactureBelge({
          ...nouvelleFactureBelge,
          items: [...nouvelleFactureBelge.items, {
            produitId,
            nom: produit.nom,
            description: produit.description,
            quantite,
            unite: produit.unite,
            prixUnitaire: produit.prix,
            tauxTVA: produit.tauxTVA
          }]
        });
      }
    }
  };

  // Fonction d'export des données
  const exporterDonnees = (format = 'csv') => {
    const donnees = {
      membres,
      employes,
      depenses,
      entrees,
      factures,
      salaires,
      depensesRecurrentes,
      totaux: {
        totalDepenses: totalDepenses.toFixed(2),
        totalEntrees: totalEntrees.toFixed(2),
        totalCredits: totalCredits.toFixed(2),
        totalFactures: totalFactures.toFixed(2),
        totalSalaires: totalSalaires.toFixed(2),
        totalGeneral: totalGeneral.toFixed(2)
      }
    };

    if (format === 'json') {
      const dataStr = JSON.stringify(donnees, null, 2);
      const dataUri = 'data:application/json;charset=utf-8,'+ encodeURIComponent(dataStr);
      const exportFileDefaultName = `monarch_trade_group_${new Date().toISOString().split('T')[0]}.json`;
      
      const linkElement = document.createElement('a');
      linkElement.setAttribute('href', dataUri);
      linkElement.setAttribute('download', exportFileDefaultName);
      linkElement.click();
    } else if (format === 'csv') {
      // Export CSV des dépenses
      const csvContent = [
        ['Date', 'Description', 'Montant', 'Devise', 'Catégorie', 'Payé par', 'Méthode'],
        ...depenses.map(d => [
          d.date,
          d.description,
          d.montant,
          d.devise,
          categories[d.categorie]?.nom || d.categorie,
          obtenirNomMembre(d.payePar),
          d.methodesPaiement
        ])
      ].map(row => row.join(','));

      const csvString = csvContent.join('\n');
      const blob = new Blob([csvString], { type: 'text/csv;charset=utf-8;' });
      const link = document.createElement('a');
      const url = URL.createObjectURL(blob);
      link.setAttribute('href', url);
      link.setAttribute('download', `depenses_${new Date().toISOString().split('T')[0]}.csv`);
      link.click();
    }
  };

  // Fonction de statistiques avancées
  const obtenirStatistiques = () => {
    const stats = {
      totalTransactions: depenses.length + entrees.length + factures.length + salaires.length,
      moyenneDepense: depenses.length > 0 ? (totalDepenses / depenses.length).toFixed(2) : 0,
      moyenneEntree: entrees.length > 0 ? (totalEntrees / entrees.length).toFixed(2) : 0,
      categoriesPlusUtilisees: {},
      categoriesEntreesPlusUtilisees: {},
      tendancesMensuelles: {}
    };

    // Calcul des catégories les plus utilisées
    depenses.forEach(depense => {
      const cat = depense.categorie;
      stats.categoriesPlusUtilisees[cat] = (stats.categoriesPlusUtilisees[cat] || 0) + 1;
    });

    // Calcul des catégories d'entrées les plus utilisées
    entrees.forEach(entree => {
      const cat = entree.categorie;
      stats.categoriesEntreesPlusUtilisees[cat] = (stats.categoriesEntreesPlusUtilisees[cat] || 0) + 1;
    });

    // Calcul des tendances mensuelles
    depenses.forEach(depense => {
      const mois = depense.date?.substring(0, 7) || new Date().toISOString().substring(0, 7);
      stats.tendancesMensuelles[mois] = (stats.tendancesMensuelles[mois] || 0) - parseFloat(depense.montant);
    });

    entrees.forEach(entree => {
      const mois = entree.date?.substring(0, 7) || new Date().toISOString().substring(0, 7);
      stats.tendancesMensuelles[mois] = (stats.tendancesMensuelles[mois] || 0) + parseFloat(entree.montant);
    });

    return stats;
  };

  // Fonctions utilitaires
  const obtenirNomMembre = (id) => {
    return membres.find(m => m.id === id)?.nom || 'Inconnu';
  };

  // eslint-disable-next-line no-unused-vars
  const obtenirNomEmploye = (id) => {
    return employes.find(e => e.id === id)?.nom || 'Inconnu';
  };

  // Fonctions de rendu
  const renderContenuOnglet = () => {
    switch (ongletActif) {
      case 'entrees':
        return renderEntrees();
      case 'depenses':
        return renderDepenses();
      case 'factures':
        return renderFactures();
      case 'facturation':
        return renderFacturationBelge();
      case 'salaires':
        return renderSalaires();
      case 'recurrentes':
        return renderRecurrentes();
      case 'soldes':
        return renderSoldes();
      case 'membres':
        return renderMembres();
      case 'employes':
        return renderEmployes();
      case 'credits':
        return renderCredits();
      case 'remboursements':
        return renderRemboursements();
      case 'tableaux':
        return renderTableaux();
      default:
        return renderDepenses();
    }
  };

  const renderDepenses = () => {
    // Fonction de tri et filtrage avancé
    const appliquerFiltres = () => {
      let depensesFiltrees = depenses.filter(depense => {
        const matchCategorie = filtreCategorie === 'toutes' || depense.categorie === filtreCategorie;
        const matchRecherche = depense.description.toLowerCase().includes(recherche.toLowerCase());
        
        // Filtres avancés
        const matchDate = (!filtreAvance.dateDebut || depense.date >= filtreAvance.dateDebut) &&
                         (!filtreAvance.dateFin || depense.date <= filtreAvance.dateFin);
        const matchMontant = (!filtreAvance.montantMin || parseFloat(depense.montant) >= parseFloat(filtreAvance.montantMin)) &&
                            (!filtreAvance.montantMax || parseFloat(depense.montant) <= parseFloat(filtreAvance.montantMax));
        const matchDevise = filtreAvance.devise === 'toutes' || depense.devise === filtreAvance.devise;
        const matchPayeur = filtreAvance.payePar === 'tous' || depense.payePar === parseInt(filtreAvance.payePar);
        
        return matchCategorie && matchRecherche && matchDate && matchMontant && matchDevise && matchPayeur;
      });

      // Tri
      depensesFiltrees.sort((a, b) => {
        let valeurA, valeurB;
        
        switch (triActif.champ) {
          case 'date':
            valeurA = new Date(a.date);
            valeurB = new Date(b.date);
            break;
          case 'montant':
            valeurA = parseFloat(a.montant);
            valeurB = parseFloat(b.montant);
            break;
          case 'description':
            valeurA = a.description.toLowerCase();
            valeurB = b.description.toLowerCase();
            break;
          case 'categorie':
            valeurA = categories[a.categorie]?.nom || '';
            valeurB = categories[b.categorie]?.nom || '';
            break;
          default:
            return 0;
        }
        
        if (triActif.ordre === 'asc') {
          return valeurA > valeurB ? 1 : valeurA < valeurB ? -1 : 0;
        } else {
          return valeurA < valeurB ? 1 : valeurA > valeurB ? -1 : 0;
        }
      });

      return depensesFiltrees;
    };

    const depensesFiltrees = appliquerFiltres();

    return (
      <div className="space-y-4">
        {/* Contrôles de tri et filtrage avancés */}
        <div className="bg-white p-4 rounded-lg border border-gray-200">
          <div className="flex items-center justify-between mb-4">
            <h3 className="font-semibold text-gray-900 flex items-center gap-2">
              <Filter className="h-4 w-4" />
              Filtres et Tri
            </h3>
            <button
              onClick={() => setAffichageAvance(!affichageAvance)}
              className="flex items-center gap-2 px-3 py-1 text-sm bg-blue-100 text-blue-700 rounded-lg hover:bg-blue-200 transition-colors"
            >
              <Eye className="h-4 w-4" />
              {affichageAvance ? 'Masquer' : 'Afficher'} filtres avancés
            </button>
          </div>

          {/* Tri rapide */}
          <div className="grid grid-cols-2 md:grid-cols-4 gap-3 mb-4">
            {[
              { champ: 'date', nom: 'Date', icone: Calendar },
              { champ: 'montant', nom: 'Montant', icone: DollarSign },
              { champ: 'description', nom: 'Description', icone: FileText },
              { champ: 'categorie', nom: 'Catégorie', icone: Filter }
            ].map(({ champ, nom, icone: Icone }) => (
              <button
                key={champ}
                onClick={() => setTriActif({
                  champ,
                  ordre: triActif.champ === champ && triActif.ordre === 'asc' ? 'desc' : 'asc'
                })}
                className={`flex items-center justify-center gap-2 p-2 rounded-lg border transition-colors ${
                  triActif.champ === champ
                    ? 'border-blue-500 bg-blue-50 text-blue-700'
                    : 'border-gray-300 bg-white text-gray-700 hover:bg-gray-50'
                }`}
              >
                <Icone className="h-4 w-4" />
                <span className="text-sm font-medium">{nom}</span>
                {triActif.champ === champ && (
                  triActif.ordre === 'asc' ? 
                    <SortAsc className="h-4 w-4" /> : 
                    <SortDesc className="h-4 w-4" />
                )}
              </button>
            ))}
          </div>

          {/* Filtres avancés */}
          {affichageAvance && (
            <div className="border-t pt-4">
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">Date début</label>
                  <input
                    type="date"
                    value={filtreAvance.dateDebut}
                    onChange={(e) => setFiltreAvance({...filtreAvance, dateDebut: e.target.value})}
                    className="w-full p-2 border border-gray-300 rounded-lg text-sm"
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">Date fin</label>
                  <input
                    type="date"
                    value={filtreAvance.dateFin}
                    onChange={(e) => setFiltreAvance({...filtreAvance, dateFin: e.target.value})}
                    className="w-full p-2 border border-gray-300 rounded-lg text-sm"
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">Devise</label>
                  <select
                    value={filtreAvance.devise}
                    onChange={(e) => setFiltreAvance({...filtreAvance, devise: e.target.value})}
                    className="w-full p-2 border border-gray-300 rounded-lg text-sm"
                  >
                    <option value="toutes">Toutes les devises</option>
                    {devises.map(devise => (
                      <option key={devise} value={devise}>{devise}</option>
                    ))}
                  </select>
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">Montant min</label>
                  <input
                    type="number"
                    step="0.01"
                    placeholder="0.00"
                    value={filtreAvance.montantMin}
                    onChange={(e) => setFiltreAvance({...filtreAvance, montantMin: e.target.value})}
                    className="w-full p-2 border border-gray-300 rounded-lg text-sm"
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">Montant max</label>
                  <input
                    type="number"
                    step="0.01"
                    placeholder="999.99"
                    value={filtreAvance.montantMax}
                    onChange={(e) => setFiltreAvance({...filtreAvance, montantMax: e.target.value})}
                    className="w-full p-2 border border-gray-300 rounded-lg text-sm"
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">Payé par</label>
                  <select
                    value={filtreAvance.payePar}
                    onChange={(e) => setFiltreAvance({...filtreAvance, payePar: e.target.value})}
                    className="w-full p-2 border border-gray-300 rounded-lg text-sm"
                  >
                    <option value="tous">Tous les membres</option>
                    {membres.map(membre => (
                      <option key={membre.id} value={membre.id}>{membre.nom}</option>
                    ))}
                  </select>
                </div>
              </div>
              
              <div className="mt-4 flex gap-2">
                <button
                  onClick={() => setFiltreAvance({
                    dateDebut: '',
                    dateFin: '',
                    montantMin: '',
                    montantMax: '',
                    devise: 'toutes',
                    payePar: 'tous'
                  })}
                  className="px-4 py-2 text-sm bg-gray-100 text-gray-700 rounded-lg hover:bg-gray-200 transition-colors"
                >
                  Réinitialiser filtres
                </button>
                <div className="flex-1 flex items-center justify-end gap-2 text-sm text-gray-600">
                  <Clock className="h-4 w-4" />
                  <span>{depensesFiltrees.length} résultat{depensesFiltrees.length > 1 ? 's' : ''}</span>
                </div>
              </div>
            </div>
          )}
        </div>

        {/* Liste des dépenses */}
        <div className="space-y-3 max-h-[500px] overflow-y-auto">
          {depensesFiltrees.length === 0 ? (
            <div className="text-center py-12">
              <Search className="h-12 w-12 text-gray-400 mx-auto mb-4" />
              <p className="text-gray-500">Aucune dépense trouvée</p>
              {(filtreCategorie !== 'toutes' || recherche || Object.values(filtreAvance).some(val => val && val !== 'toutes' && val !== 'tous')) && (
                <p className="text-sm text-gray-400 mt-2">Essayez de modifier vos filtres</p>
              )}
            </div>
          ) : (
            depensesFiltrees.map(depense => (
              <div key={depense.id} className={`p-4 border rounded-lg hover:shadow-md transition-shadow ${depense.recurrente ? 'border-blue-300 bg-blue-50' : 'border-gray-200 bg-white'}`}>
                <div className="flex items-start justify-between">
                  <div className="flex-1">
                    <div className="flex items-center gap-3 mb-2">
                      <span className="text-xl">{categories[depense.categorie]?.icone}</span>
                      <div>
                        <p className="font-medium text-gray-900 flex items-center gap-2">
                          {depense.description}
                          {depense.recurrente && <Repeat className="h-4 w-4 text-blue-600" />}
                        </p>
                        <div className="flex items-center gap-4 text-sm text-gray-500">
                          <span>Par {obtenirNomMembre(depense.payePar)}</span>
                          <span>•</span>
                          <span>{depense.date}</span>
                          {depense.heure && (
                            <>
                              <span>•</span>
                              <span>{depense.heure}</span>
                            </>
                          )}
                          <span>•</span>
                          <span className="capitalize">{depense.methodesPaiement}</span>
                        </div>
                        {depense.typeRepartition === 'personnalise' && (
                          <div className="mt-1 text-xs text-blue-600">
                            📊 Répartition personnalisée
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                  <div className="flex items-center gap-3">
                    <span className="font-bold text-lg text-gray-900">
                      {depense.montant} {depense.devise}
                    </span>
                    <button
                      onClick={() => {
                        setDepenseAModifier(depense);
                        setAffichageModal({ ...affichageModal, depense: true });
                      }}
                      className="text-blue-600 hover:text-blue-800 p-1 rounded hover:bg-blue-50 transition-colors"
                      title="Modifier cette dépense"
                    >
                      <Edit className="h-4 w-4" />
                    </button>
                    <button
                      onClick={() => setDepenses(depenses.filter(d => d.id !== depense.id))}
                      className="text-red-600 hover:text-red-800 p-1 rounded hover:bg-red-50 transition-colors"
                      title="Supprimer cette dépense"
                    >
                      <Trash2 className="h-4 w-4" />
                    </button>
                  </div>
                </div>
              </div>
            ))
          )}
        </div>
      </div>
    );
  };

  const renderEntrees = () => {
    // Filtrage des entrées
    const entreesFiltrees = entrees.filter(entree => {
      const matchCategorie = filtreCategorie === 'toutes' || entree.categorie === filtreCategorie;
      const matchRecherche = !recherche || 
        entree.description.toLowerCase().includes(recherche.toLowerCase()) ||
        obtenirNomMembre(entree.payePar).toLowerCase().includes(recherche.toLowerCase()) ||
        entree.devise.toLowerCase().includes(recherche.toLowerCase());
      
      // Filtres avancés
      const matchDate = (!filtreAvance.dateDebut || entree.date >= filtreAvance.dateDebut) &&
                       (!filtreAvance.dateFin || entree.date <= filtreAvance.dateFin);
      const matchMontant = (!filtreAvance.montantMin || parseFloat(entree.montant) >= parseFloat(filtreAvance.montantMin)) &&
                          (!filtreAvance.montantMax || parseFloat(entree.montant) <= parseFloat(filtreAvance.montantMax));
      const matchDevise = filtreAvance.devise === 'toutes' || entree.devise === filtreAvance.devise;
      const matchPayePar = filtreAvance.payePar === 'tous' || entree.payePar.toString() === filtreAvance.payePar;
      
      return matchCategorie && matchRecherche && matchDate && matchMontant && matchDevise && matchPayePar;
    });

    // Tri des entrées
    const entreesSortees = [...entreesFiltrees].sort((a, b) => {
      let valeurA, valeurB;
      
      switch (triActif.champ) {
        case 'date':
          valeurA = new Date(a.date || '1970-01-01');
          valeurB = new Date(b.date || '1970-01-01');
          break;
        case 'montant':
          valeurA = parseFloat(a.montant);
          valeurB = parseFloat(b.montant);
          break;
        case 'payeur':
          valeurA = obtenirNomMembre(a.payePar).toLowerCase();
          valeurB = obtenirNomMembre(b.payePar).toLowerCase();
          break;
        default:
          return 0;
      }
      
      if (triActif.ordre === 'asc') {
        return valeurA > valeurB ? 1 : -1;
      } else {
        return valeurA < valeurB ? 1 : -1;
      }
    });

    return (
      <div className="space-y-6">
        {/* Filtres et tri */}
        <div className="bg-white rounded-xl p-6 border border-gray-200 shadow-sm">
          <div className="flex flex-col lg:flex-row gap-4 items-center justify-between mb-4">
            <div className="flex items-center gap-4 flex-1">
              <div className="relative flex-1 max-w-md">
                <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 h-4 w-4 text-gray-400" />
                <input
                  type="text"
                  placeholder="Rechercher par description, membre ou devise..."
                  value={recherche}
                  onChange={(e) => setRecherche(e.target.value)}
                  className="pl-10 pr-4 py-2 w-full border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-green-500"
                />
              </div>
              
              <select
                value={filtreCategorie}
                onChange={(e) => setFiltreCategorie(e.target.value)}
                className="px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-green-500"
              >
                <option value="toutes">Toutes catégories</option>
                {Object.entries(categoriesEntrees).map(([cle, cat]) => (
                  <option key={cle} value={cle}>{cat.icone} {cat.nom}</option>
                ))}
              </select>
              
              <button
                onClick={() => setAffichageAvance(!affichageAvance)}
                className={`flex items-center gap-2 px-4 py-2 rounded-lg border transition-colors ${
                  affichageAvance 
                    ? 'border-green-500 bg-green-50 text-green-700' 
                    : 'border-gray-300 bg-white text-gray-700 hover:bg-gray-50'
                }`}
              >
                <Filter className="h-4 w-4" />
                <span className="hidden sm:inline">Filtres avancés</span>
              </button>
            </div>
          </div>

          {/* Boutons de tri */}
          <div className="flex gap-2 mb-4">
            {[
              { champ: 'date', nom: 'Date', icone: Calendar },
              { champ: 'montant', nom: 'Montant', icone: DollarSign },
              { champ: 'payeur', nom: 'Reçu par', icone: User }
            ].map(({ champ, nom, icone: Icone }) => (
              <button
                key={champ}
                onClick={() => setTriActif({
                  champ,
                  ordre: triActif.champ === champ && triActif.ordre === 'asc' ? 'desc' : 'asc'
                })}
                className={`flex items-center justify-center gap-2 p-2 rounded-lg border transition-colors ${
                  triActif.champ === champ
                    ? 'border-green-500 bg-green-50 text-green-700'
                    : 'border-gray-300 bg-white text-gray-700 hover:bg-gray-50'
                }`}
              >
                <Icone className="h-4 w-4" />
                <span className="text-sm font-medium">{nom}</span>
                {triActif.champ === champ && (
                  triActif.ordre === 'asc' ? 
                    <SortAsc className="h-4 w-4" /> : 
                    <SortDesc className="h-4 w-4" />
                )}
              </button>
            ))}
          </div>

          {/* Filtres avancés */}
          {affichageAvance && (
            <div className="border-t pt-4">
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">Date début</label>
                  <input
                    type="date"
                    value={filtreAvance.dateDebut}
                    onChange={(e) => setFiltreAvance({...filtreAvance, dateDebut: e.target.value})}
                    className="w-full p-2 border border-gray-300 rounded-lg text-sm"
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">Date fin</label>
                  <input
                    type="date"
                    value={filtreAvance.dateFin}
                    onChange={(e) => setFiltreAvance({...filtreAvance, dateFin: e.target.value})}
                    className="w-full p-2 border border-gray-300 rounded-lg text-sm"
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">Devise</label>
                  <select
                    value={filtreAvance.devise}
                    onChange={(e) => setFiltreAvance({...filtreAvance, devise: e.target.value})}
                    className="w-full p-2 border border-gray-300 rounded-lg text-sm"
                  >
                    <option value="toutes">Toutes devises</option>
                    {devises.map(devise => (
                      <option key={devise} value={devise}>{devise}</option>
                    ))}
                  </select>
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">Montant min</label>
                  <input
                    type="number"
                    step="0.01"
                    value={filtreAvance.montantMin}
                    onChange={(e) => setFiltreAvance({...filtreAvance, montantMin: e.target.value})}
                    className="w-full p-2 border border-gray-300 rounded-lg text-sm"
                    placeholder="0.00"
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">Montant max</label>
                  <input
                    type="number"
                    step="0.01"
                    value={filtreAvance.montantMax}
                    onChange={(e) => setFiltreAvance({...filtreAvance, montantMax: e.target.value})}
                    className="w-full p-2 border border-gray-300 rounded-lg text-sm"
                    placeholder="0.00"
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">Reçu par</label>
                  <select
                    value={filtreAvance.payePar}
                    onChange={(e) => setFiltreAvance({...filtreAvance, payePar: e.target.value})}
                    className="w-full p-2 border border-gray-300 rounded-lg text-sm"
                  >
                    <option value="tous">Tous les membres</option>
                    {membres.map(membre => (
                      <option key={membre.id} value={membre.id}>{membre.nom}</option>
                    ))}
                  </select>
                </div>
              </div>
              
              <div className="mt-4 flex gap-2">
                <button
                  onClick={() => setFiltreAvance({
                    dateDebut: '',
                    dateFin: '',
                    montantMin: '',
                    montantMax: '',
                    devise: 'toutes',
                    payePar: 'tous'
                  })}
                  className="px-4 py-2 text-sm bg-gray-100 text-gray-700 rounded-lg hover:bg-gray-200 transition-colors"
                >
                  Réinitialiser filtres
                </button>
                <div className="flex-1 flex items-center justify-end gap-2 text-sm text-gray-600">
                  <Clock className="h-4 w-4" />
                  <span>{entreesSortees.length} résultat{entreesSortees.length > 1 ? 's' : ''}</span>
                </div>
              </div>
            </div>
          )}
        </div>

        {/* Liste des entrées */}
        <div className="space-y-3 max-h-[500px] overflow-y-auto">
          {entreesSortees.length === 0 ? (
            <div className="text-center py-12">
              <TrendingUp className="h-12 w-12 text-gray-400 mx-auto mb-4" />
              <p className="text-gray-500">Aucune entrée trouvée</p>
              {(filtreCategorie !== 'toutes' || recherche || Object.values(filtreAvance).some(val => val && val !== 'toutes' && val !== 'tous')) && (
                <p className="text-sm text-gray-400 mt-2">Essayez de modifier vos filtres</p>
              )}
            </div>
          ) : (
            entreesSortees.map(entree => (
              <div key={entree.id} className={`p-4 border rounded-lg hover:shadow-md transition-shadow bg-green-50 border-green-200`}>
                <div className="flex items-start justify-between">
                  <div className="flex-1">
                    <div className="flex items-center gap-3 mb-2">
                      <span className="text-xl">{categoriesEntrees[entree.categorie]?.icone}</span>
                      <div>
                        <p className="font-medium text-gray-900 flex items-center gap-2">
                          {entree.description}
                        </p>
                        <div className="flex items-center gap-4 text-sm text-gray-500">
                          <span>Reçu par {obtenirNomMembre(entree.payePar)}</span>
                          <span>•</span>
                          <span>{entree.date}</span>
                          {entree.heure && (
                            <>
                              <span>•</span>
                              <span>{entree.heure}</span>
                            </>
                          )}
                          <span>•</span>
                          <span className="capitalize">{entree.methodesPaiement}</span>
                        </div>
                        {entree.typeRepartition === 'personnalise' && (
                          <div className="mt-1 text-xs text-green-600">
                            📊 Répartition personnalisée
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                  <div className="flex items-center gap-3">
                    <span className="font-bold text-lg text-green-900">
                      +{entree.montant} {entree.devise}
                    </span>
                    <button
                      onClick={() => setEntrees(entrees.filter(e => e.id !== entree.id))}
                      className="text-red-600 hover:text-red-800 p-1 rounded hover:bg-red-50 transition-colors"
                      title="Supprimer cette entrée"
                    >
                      <Trash2 className="h-4 w-4" />
                    </button>
                  </div>
                </div>
              </div>
            ))
          )}
        </div>
      </div>
    );
  };

  const renderFactures = () => (
    <div className="space-y-3 max-h-[600px] overflow-y-auto">
      {factures.length === 0 ? (
        <div className="text-center py-12">
          <p className="text-gray-500">Aucune facture enregistrée</p>
        </div>
      ) : (
        factures.map(facture => (
          <div key={facture.id} className="p-4 border border-gray-200 rounded-lg hover:bg-gray-50">
            <div className="flex items-start justify-between">
              <div className="flex-1">
                <div className="flex items-center gap-3 mb-2">
                  <FileText className="h-5 w-5 text-blue-600" />
                  <div>
                    <p className="font-medium text-gray-900">
                      Facture {facture.numero} - {facture.fournisseur}
                    </p>
                    <p className="text-sm text-gray-600">{facture.description}</p>
                    <div className="flex items-center gap-4 text-sm text-gray-500 mt-1">
                      <span>Émission: {facture.dateEmission}</span>
                      <span>•</span>
                      <span>Échéance: {facture.dateEcheance}</span>
                      <span>•</span>
                      <span className="capitalize">{facture.type}</span>
                    </div>
                  </div>
                </div>
              </div>
              <div className="flex items-center gap-3">
                <span className={`px-2 py-1 rounded-full text-xs font-medium ${
                  facture.statut === 'payee' ? 'bg-green-100 text-green-800' :
                  facture.statut === 'retard' ? 'bg-red-100 text-red-800' :
                  'bg-yellow-100 text-yellow-800'
                }`}>
                  {facture.statut}
                </span>
                <span className="font-bold text-lg text-gray-900">{facture.montant}€</span>
                <button
                  onClick={() => setFactures(factures.filter(f => f.id !== facture.id))}
                  className="text-red-600 hover:text-red-800 p-1"
                >
                  <Trash2 className="h-4 w-4" />
                </button>
              </div>
            </div>
          </div>
        ))
      )}
    </div>
  );

  const renderSalaires = () => (
    <div className="space-y-3 max-h-[600px] overflow-y-auto">
      {salaires.length === 0 ? (
        <div className="text-center py-12">
          <p className="text-gray-500">Aucun salaire enregistré</p>
        </div>
      ) : (
        salaires.map(salaire => (
          <div key={salaire.id} className="p-4 border border-gray-200 rounded-lg hover:bg-gray-50">
            <div className="flex items-start justify-between">
              <div className="flex-1">
                <div className="flex items-center gap-3 mb-2">
                  <UserCheck className="h-5 w-5 text-green-600" />
                  <div>
                    <p className="font-medium text-gray-900">
                      {salaire.employeNom} - {salaire.mois}
                    </p>
                    <div className="text-sm text-gray-600 space-y-1">
                      <p>Salaire de base: {salaire.montant}€</p>
                      {salaire.bonus > 0 && <p>Bonus: +{salaire.bonus}€</p>}
                      {salaire.deductions > 0 && <p>Déductions: -{salaire.deductions}€</p>}
                      <p>Payé le: {salaire.datePaiement}</p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="flex items-center gap-3">
                <span className={`px-2 py-1 rounded-full text-xs font-medium ${
                  salaire.statut === 'paye' ? 'bg-green-100 text-green-800' :
                  salaire.statut === 'retard' ? 'bg-red-100 text-red-800' :
                  'bg-yellow-100 text-yellow-800'
                }`}>
                  {salaire.statut}
                </span>
                <span className="font-bold text-lg text-gray-900">{salaire.montantNet}€</span>
                <button
                  onClick={() => setSalaires(salaires.filter(s => s.id !== salaire.id))}
                  className="text-red-600 hover:text-red-800 p-1"
                >
                  <Trash2 className="h-4 w-4" />
                </button>
              </div>
            </div>
          </div>
        ))
      )}
    </div>
  );

  const renderRecurrentes = () => (
    <div className="space-y-3 max-h-[600px] overflow-y-auto">
      {depensesRecurrentes.length === 0 ? (
        <div className="text-center py-12">
          <p className="text-gray-500">Aucune dépense récurrente</p>
        </div>
      ) : (
        depensesRecurrentes.map(recurrente => (
          <div key={recurrente.id} className={`p-4 border rounded-lg ${recurrente.actif ? 'border-green-200 bg-green-50' : 'border-gray-200 bg-gray-50'}`}>
            <div className="flex items-start justify-between">
              <div className="flex-1">
                <div className="flex items-center gap-3 mb-2">
                  <Repeat className="h-5 w-5 text-purple-600" />
                  <div>
                    <p className="font-medium text-gray-900">{recurrente.description}</p>
                    <div className="text-sm text-gray-600">
                      <p>Fréquence: {recurrente.frequence}</p>
                      <p>Prochaine: {recurrente.prochainePaie}</p>
                      <p>Catégorie: {categories[recurrente.categorie]?.nom}</p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="flex items-center gap-3">
                <span className={`px-2 py-1 rounded-full text-xs font-medium ${
                  recurrente.actif ? 'bg-green-100 text-green-800' : 'bg-gray-100 text-gray-800'
                }`}>
                  {recurrente.actif ? 'Actif' : 'Inactif'}
                </span>
                <span className="font-bold text-lg text-gray-900">{recurrente.montant}€</span>
                <button
                  onClick={() => setDepensesRecurrentes(depensesRecurrentes.filter(r => r.id !== recurrente.id))}
                  className="text-red-600 hover:text-red-800 p-1"
                >
                  <Trash2 className="h-4 w-4" />
                </button>
              </div>
            </div>
          </div>
        ))
      )}
    </div>
  );

  const renderSoldes = () => {
    const soldes = calculerSoldes();
    const remboursements = calculerRemboursements();
    const aDesRemboursements = remboursements.length > 0;

    return (
      <div className="space-y-6 max-h-[600px] overflow-y-auto">
        {depenses.length === 0 ? (
          <div className="text-center py-12">
            <ArrowLeftRight className="h-12 w-12 text-gray-400 mx-auto mb-4" />
            <p className="text-gray-500">Aucune dépense enregistrée</p>
            <p className="text-sm text-gray-400 mt-2">Ajoutez des dépenses pour voir les soldes</p>
          </div>
        ) : (
          <>
            {/* Section Soldes par Membre */}
            <div>
              <h3 className="text-lg font-semibold mb-4 flex items-center gap-2">
                <Users className="h-5 w-5 text-blue-600" />
                Soldes par Membre
              </h3>
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
                {membres.map(membre => {
                  const solde = soldes[membre.id] || 0;
                  const estCrediteur = solde > 0.01;
                  const estDebiteur = solde < -0.01;
                  const estEquilibre = Math.abs(solde) <= 0.01;

                  return (
                    <div 
                      key={membre.id} 
                      className={`p-4 rounded-lg border-2 ${
                        estCrediteur ? 'border-green-200 bg-green-50' :
                        estDebiteur ? 'border-red-200 bg-red-50' :
                        'border-gray-200 bg-gray-50'
                      }`}
                    >
                      <div className="flex items-center gap-3 mb-2">
                        <div 
                          className="w-8 h-8 rounded-full flex items-center justify-center text-white text-sm font-semibold"
                          style={{ backgroundColor: membre.couleur }}
                        >
                          {membre.nom.charAt(0)}
                        </div>
                        <div>
                          <p className="font-medium text-gray-900">{membre.nom}</p>
                          <p className="text-xs text-gray-500">{membre.role}</p>
                        </div>
                      </div>
                      
                      <div className="flex items-center justify-between">
                        <div className="flex items-center gap-2">
                          {estCrediteur && <CheckCircle className="h-4 w-4 text-green-600" />}
                          {estDebiteur && <AlertCircle className="h-4 w-4 text-red-600" />}
                          {estEquilibre && <CheckCircle className="h-4 w-4 text-gray-600" />}
                          
                          <span className="text-sm text-gray-600">
                            {estCrediteur ? 'À recevoir' : estDebiteur ? 'À payer' : 'Équilibré'}
                          </span>
                        </div>
                        
                        <span className={`font-bold text-lg ${
                          estCrediteur ? 'text-green-700' :
                          estDebiteur ? 'text-red-700' :
                          'text-gray-700'
                        }`}>
                          {estCrediteur ? '+' : ''}{solde.toFixed(2)}€
                        </span>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>

            {/* Section Remboursements Suggérés */}
            {aDesRemboursements && (
              <div>
                <h3 className="text-lg font-semibold mb-4 flex items-center gap-2">
                  <ArrowLeftRight className="h-5 w-5 text-purple-600" />
                  Remboursements Suggérés
                </h3>
                <div className="space-y-3">
                  {remboursements.map((remboursement, index) => {
                    const payeur = membres.find(m => m.id === remboursement.de);
                    const receveur = membres.find(m => m.id === remboursement.vers);
                    
                    return (
                      <div key={index} className="p-4 bg-purple-50 border border-purple-200 rounded-lg">
                        <div className="flex items-center justify-between">
                          <div className="flex items-center gap-4">
                            <div className="flex items-center gap-2">
                              <div 
                                className="w-6 h-6 rounded-full flex items-center justify-center text-white text-xs font-semibold"
                                style={{ backgroundColor: payeur?.couleur }}
                              >
                                {payeur?.nom.charAt(0)}
                              </div>
                              <span className="font-medium text-gray-900">{payeur?.nom}</span>
                            </div>
                            
                            <ArrowLeftRight className="h-4 w-4 text-purple-600" />
                            
                            <div className="flex items-center gap-2">
                              <div 
                                className="w-6 h-6 rounded-full flex items-center justify-center text-white text-xs font-semibold"
                                style={{ backgroundColor: receveur?.couleur }}
                              >
                                {receveur?.nom.charAt(0)}
                              </div>
                              <span className="font-medium text-gray-900">{receveur?.nom}</span>
                            </div>
                          </div>
                          
                          <div className="text-right">
                            <span className="font-bold text-lg text-purple-700">
                              {remboursement.montant.toFixed(2)}€
                            </span>
                            <p className="text-xs text-gray-500 mt-1">Remboursement</p>
                          </div>
                        </div>
                      </div>
                    );
                  })}
                </div>
                
                <div className="mt-4 p-3 bg-blue-50 border border-blue-200 rounded-lg">
                  <div className="flex items-center gap-2 text-blue-800">
                    <CheckCircle className="h-4 w-4" />
                    <span className="text-sm font-medium">
                      {remboursements.length} remboursement{remboursements.length > 1 ? 's' : ''} pour équilibrer tous les comptes
                    </span>
                  </div>
                </div>
              </div>
            )}

            {!aDesRemboursements && depenses.length > 0 && (
              <div className="text-center py-8">
                <CheckCircle className="h-12 w-12 text-green-500 mx-auto mb-4" />
                <p className="text-lg font-medium text-gray-900">Tous les comptes sont équilibrés !</p>
                <p className="text-sm text-gray-500 mt-2">Aucun remboursement nécessaire</p>
              </div>
            )}
          </>
        )}
      </div>
    );
  };

  const renderMembres = () => {
    const soldes = calculerSoldes();
    
    // Statistiques par membre
    const getStatistiquesMembre = (membreId) => {
      const depensesPayees = depenses.filter(d => d.payePar === membreId);
      const depensesParticipees = depenses.filter(d => d.participants.includes(membreId));
      const montantPaye = depensesPayees.reduce((sum, d) => sum + parseFloat(d.montant), 0);
      const montantDu = depensesParticipees.reduce((sum, d) => {
        if (d.typeRepartition === 'egal') {
          return sum + parseFloat(d.montant) / d.participants.length;
        } else {
          return sum + (d.repartitionPersonnalisee[membreId] || 0);
        }
      }, 0);
      
      return {
        depensesPayees: depensesPayees.length,
        depensesParticipees: depensesParticipees.length,
        montantPaye: montantPaye,
        montantDu: montantDu,
        solde: soldes[membreId] || 0
      };
    };

    const supprimerMembre = (membreId) => {
      // Vérifier si le membre peut être supprimé
      const aDesDepenses = depenses.some(d => d.payePar === membreId || d.participants.includes(membreId));
      if (aDesDepenses) {
        alert('Impossible de supprimer ce membre car il a des dépenses associées.');
        return;
      }
      
      if (membres.length <= 1) {
        alert('Impossible de supprimer le dernier membre.');
        return;
      }
      
      if (window.confirm('Êtes-vous sûr de vouloir supprimer ce membre ?')) {
        setMembres(membres.filter(m => m.id !== membreId));
      }
    };

         const modifierMembre = (membre) => {
       setMembreAModifier(membre);
       setAffichageModal({ ...affichageModal, membre: true });
     };

    return (
      <div className="space-y-6 max-h-[600px] overflow-y-auto">
        {/* Header avec bouton d'ajout */}
        <div className="flex justify-between items-center">
          <h3 className="text-lg font-semibold flex items-center gap-2">
            <Users className="h-5 w-5 text-blue-600" />
            Gestion des Membres ({membres.length})
          </h3>
                     <button
             onClick={() => {
               setMembreAModifier(null);
               setAffichageModal({ ...affichageModal, membre: true });
             }}
             className="btn-primary flex items-center gap-2"
           >
             <UserPlus className="h-4 w-4" />
             Ajouter un Membre
           </button>
        </div>

        {/* Cartes des membres */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          {membres.map(membre => {
            const stats = getStatistiquesMembre(membre.id);
            const estCrediteur = stats.solde > 0.01;
            const estDebiteur = stats.solde < -0.01;
            const estEquilibre = Math.abs(stats.solde) <= 0.01;

            return (
              <div 
                key={membre.id} 
                className={`p-5 rounded-lg border-2 transition-all duration-200 hover:shadow-lg ${
                  estCrediteur ? 'border-green-200 bg-green-50' :
                  estDebiteur ? 'border-red-200 bg-red-50' :
                  'border-gray-200 bg-gray-50'
                }`}
              >
                {/* Header membre */}
                <div className="flex items-center justify-between mb-4">
                  <div className="flex items-center gap-3">
                    <div 
                      className="w-12 h-12 rounded-full flex items-center justify-center text-white text-lg font-semibold"
                      style={{ backgroundColor: membre.couleur }}
                    >
                      {membre.nom.charAt(0)}
                    </div>
                    <div>
                      <h4 className="font-semibold text-gray-900">{membre.nom}</h4>
                      <div className="flex items-center gap-2">
                        <Shield className="h-3 w-3 text-gray-500" />
                        <span className="text-sm text-gray-600">{membre.role}</span>
                      </div>
                    </div>
                  </div>
                  
                  {/* Actions */}
                  <div className="flex items-center gap-2">
                    <button
                      onClick={() => modifierMembre(membre)}
                      className="p-2 text-blue-600 hover:bg-blue-100 rounded-lg transition-colors"
                      title="Modifier"
                    >
                      <Edit className="h-4 w-4" />
                    </button>
                    <button
                      onClick={() => supprimerMembre(membre.id)}
                      className="p-2 text-red-600 hover:bg-red-100 rounded-lg transition-colors"
                      title="Supprimer"
                    >
                      <UserMinus className="h-4 w-4" />
                    </button>
                  </div>
                </div>

                {/* Informations de contact */}
                <div className="space-y-2 mb-4">
                  <div className="flex items-center gap-2 text-sm text-gray-600">
                    <Mail className="h-3 w-3" />
                    <span>{membre.email}</span>
                  </div>
                  {membre.telephone && (
                    <div className="flex items-center gap-2 text-sm text-gray-600">
                      <Phone className="h-3 w-3" />
                      <span>{membre.telephone}</span>
                    </div>
                  )}
                  {membre.iban && (
                    <div className="flex items-center gap-2 text-sm text-gray-600">
                      <CreditCard className="h-3 w-3" />
                      <span>{membre.iban.slice(0, 8)}...</span>
                    </div>
                  )}
                </div>

                {/* Statistiques */}
                <div className="space-y-2 mb-4">
                  <div className="flex justify-between text-sm">
                    <span className="text-gray-600">Dépenses payées:</span>
                    <span className="font-medium">{stats.depensesPayees}</span>
                  </div>
                  <div className="flex justify-between text-sm">
                    <span className="text-gray-600">Participations:</span>
                    <span className="font-medium">{stats.depensesParticipees}</span>
                  </div>
                  <div className="flex justify-between text-sm">
                    <span className="text-gray-600">Montant payé:</span>
                    <span className="font-medium">{stats.montantPaye.toFixed(2)}€</span>
                  </div>
                  <div className="flex justify-between text-sm">
                    <span className="text-gray-600">Montant dû:</span>
                    <span className="font-medium">{stats.montantDu.toFixed(2)}€</span>
                  </div>
                </div>

                {/* Solde */}
                <div className="border-t pt-3">
                  <div className="flex items-center justify-between">
                    <div className="flex items-center gap-2">
                      {estCrediteur && <CheckCircle className="h-4 w-4 text-green-600" />}
                      {estDebiteur && <AlertCircle className="h-4 w-4 text-red-600" />}
                      {estEquilibre && <CheckCircle className="h-4 w-4 text-gray-600" />}
                      
                      <span className="text-sm font-medium text-gray-600">
                        {estCrediteur ? 'À recevoir' : estDebiteur ? 'À payer' : 'Équilibré'}
                      </span>
                    </div>
                    
                    <span className={`font-bold text-lg ${
                      estCrediteur ? 'text-green-700' :
                      estDebiteur ? 'text-red-700' :
                      'text-gray-700'
                    }`}>
                      {estCrediteur ? '+' : ''}{stats.solde.toFixed(2)}€
                    </span>
                  </div>
                </div>
              </div>
            );
          })}
        </div>

        {/* Résumé global */}
        <div className="bg-blue-50 border border-blue-200 rounded-lg p-4">
          <h4 className="font-semibold text-blue-900 mb-2">Résumé Global</h4>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4 text-sm">
            <div>
              <span className="text-blue-700 font-medium">Total Membres:</span>
              <p className="text-blue-900 font-bold">{membres.length}</p>
            </div>
            <div>
              <span className="text-blue-700 font-medium">Admins:</span>
              <p className="text-blue-900 font-bold">{membres.filter(m => m.role === 'admin').length}</p>
            </div>
            <div>
              <span className="text-blue-700 font-medium">Partenaires:</span>
              <p className="text-blue-900 font-bold">{membres.filter(m => m.role === 'partner').length}</p>
            </div>
            <div>
              <span className="text-blue-700 font-medium">Membres:</span>
              <p className="text-blue-900 font-bold">{membres.filter(m => m.role === 'member').length}</p>
            </div>
          </div>
        </div>
      </div>
         );
   };

  const renderEmployes = () => (
    <div className="space-y-3 max-h-[600px] overflow-y-auto">
      {employes.length === 0 ? (
        <div className="text-center py-12">
          <UserCheck className="h-12 w-12 text-gray-400 mx-auto mb-4" />
          <p className="text-gray-500">Aucun employé enregistré</p>
        </div>
      ) : (
        employes.map(employe => (
          <div key={employe.id} className="p-4 border border-gray-200 rounded-lg hover:bg-gray-50">
            <div className="flex items-start justify-between">
              <div className="flex-1">
                <div className="flex items-center gap-3 mb-2">
                  <UserCheck className="h-5 w-5 text-blue-600" />
                  <div>
                    <p className="font-medium text-gray-900">{employe.nom}</p>
                    <p className="text-sm text-gray-600">{employe.poste}</p>
                    <div className="text-sm text-gray-500 mt-1">
                      <p>Email: {employe.email}</p>
                      <p>Salaire: {employe.salaire}€</p>
                      <p>IBAN: {employe.iban}</p>
                    </div>
                  </div>
                </div>
              </div>
              <button
                onClick={() => setEmployes(employes.filter(e => e.id !== employe.id))}
                className="text-red-600 hover:text-red-800 p-1"
              >
                <Trash2 className="h-4 w-4" />
              </button>
            </div>
          </div>
        ))
      )}
    </div>
  );

  const renderRemboursements = () => (
    <div className="space-y-3 max-h-[600px] overflow-y-auto">
      {remboursementsCredits.length === 0 ? (
        <div className="text-center py-12">
          <Receipt className="h-12 w-12 text-gray-400 mx-auto mb-4" />
          <p className="text-gray-500">Aucun remboursement enregistré</p>
        </div>
      ) : (
        remboursementsCredits.map(remboursement => {
          const credit = credits.find(c => c.id === remboursement.creditId);
          const membre = membres.find(m => m.id === remboursement.payePar);
          
          return (
            <div key={remboursement.id} className="p-4 border border-gray-200 rounded-lg hover:bg-gray-50">
              <div className="flex items-start justify-between">
                <div className="flex-1">
                  <div className="flex items-center gap-3 mb-2">
                    <Receipt className="h-5 w-5 text-green-600" />
                    <div>
                      <p className="font-medium text-gray-900">
                        Remboursement - {credit?.numeroCredit || 'Crédit supprimé'}
                      </p>
                      <p className="text-sm text-gray-600">
                        Payé par: {membre?.nom || 'Membre supprimé'}
                      </p>
                      <div className="text-sm text-gray-500 mt-1">
                        <p>Date: {remboursement.datePaiement}</p>
                        <p>Méthode: {remboursement.methodesPaiement}</p>
                        {remboursement.reference && <p>Référence: {remboursement.reference}</p>}
                      </div>
                    </div>
                  </div>
                </div>
                <div className="flex items-center gap-3">
                  <span className="font-bold text-lg text-gray-900">{remboursement.montant}€</span>
                  <button
                    onClick={() => setRemboursementsCredits(remboursementsCredits.filter(r => r.id !== remboursement.id))}
                    className="text-red-600 hover:text-red-800 p-1"
                  >
                    <Trash2 className="h-4 w-4" />
                  </button>
                </div>
              </div>
            </div>
          );
        })
      )}
    </div>
  );

   const renderCredits = () => {
     const creditsEnRetard = obtenirCreditsEnRetard();

     return (
       <div className="space-y-6 max-h-[600px] overflow-y-auto">
         <div className="flex items-center justify-between mb-6">
           <div className="flex items-center gap-2">
             <Banknote className="h-6 w-6 text-green-600" />
             <h2 className="text-2xl font-bold text-gray-900">Gestion des Crédits</h2>
           </div>
           <div className="flex gap-2">
             <button
               onClick={() => setAffichageModal({...affichageModal, credit: true})}
               className="btn-primary flex items-center gap-2"
             >
               <Plus className="h-4 w-4" />
               Nouveau Crédit
             </button>
             <button
               onClick={() => setAffichageModal({...affichageModal, remboursement: true})}
               className="bg-blue-600 text-white px-4 py-2 rounded-lg hover:bg-blue-700 transition-colors flex items-center gap-2"
             >
               <Receipt className="h-4 w-4" />
               Enregistrer Remboursement
             </button>
           </div>
         </div>

         {/* Alertes pour crédits en retard */}
         {creditsEnRetard.length > 0 && (
           <div className="bg-red-50 border border-red-200 rounded-lg p-4 mb-6">
             <div className="flex items-center gap-2 mb-2">
               <AlertCircle className="h-5 w-5 text-red-600" />
               <h3 className="text-sm font-medium text-red-800">
                 Crédits en Retard ({creditsEnRetard.length})
               </h3>
             </div>
             <div className="space-y-2">
               {creditsEnRetard.map(credit => (
                 <div key={credit.id} className="flex items-center justify-between bg-white p-3 rounded border">
                   <div>
                     <p className="font-medium text-gray-900">
                       {credit.numeroCredit} - {credit.nomClient} {credit.prenomClient}
                     </p>
                     <p className="text-sm text-gray-500">
                       Prochaine échéance: {obtenirProchainEcheance(credit)} • {credit.montantMensuel}€/mois
                     </p>
                   </div>
                   <span className="bg-red-100 text-red-800 px-2 py-1 rounded-full text-xs font-medium">
                     En retard
                   </span>
                 </div>
               ))}
             </div>
           </div>
         )}

         {/* Liste des crédits */}
         <div className="space-y-4">
           {credits.length === 0 ? (
             <div className="text-center py-12">
               <Banknote className="h-12 w-12 text-gray-400 mx-auto mb-4" />
               <p className="text-gray-500">Aucun crédit enregistré</p>
             </div>
           ) : (
             <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
               {credits.map(credit => {
                 const statutActuel = obtenirStatutCredit(credit);
                 const totalRembourse = remboursementsCredits
                   .filter(r => r.creditId === credit.id)
                   .reduce((total, r) => total + parseFloat(r.montant), 0);
                 const montantTotal = parseFloat(credit.montantCredit) * (1 + parseFloat(credit.tauxInteret) / 100);
                 const progressionPourcentage = (totalRembourse / montantTotal) * 100;
                 const estEtendu = creditExpanded === credit.id;
                 
                 const toggleExpansion = async () => {
                   setIsExpanding(true);
                   
                   if (estEtendu) {
                     // Fermer la carte étendue
                     setCreditExpanded(null);
                   } else {
                     // Ouvrir cette carte et fermer les autres
                     setCreditExpanded(credit.id);
                     
                     // Petit délai pour laisser la transition s'effectuer puis scroll vers l'élément
                     setTimeout(() => {
                       const element = document.getElementById(`credit-${credit.id}`);
                       if (element) {
                         element.scrollIntoView({ 
                           behavior: 'smooth', 
                           block: 'center',
                           inline: 'nearest'
                         });
                       }
                     }, 300);
                   }
                   
                   setTimeout(() => setIsExpanding(false), 500);
                 };
                 
                 const ajouterNoteDirecte = (e) => {
                   if (e.key === 'Enter' && e.target.value.trim()) {
                     const nouvelleNote = {
                       date: new Date().toISOString(),
                       contenu: e.target.value.trim()
                     };
                     const creditMisAJour = {
                       ...credit,
                       notes: [...(credit.notes || []), nouvelleNote]
                     };
                     setCredits(credits.map(c => c.id === credit.id ? creditMisAJour : c));
                     e.target.value = '';
                   }
                 };
                 
                 return (
                   <div 
                     key={credit.id} 
                     id={`credit-${credit.id}`}
                     className={`bg-white rounded-lg border border-gray-200 shadow-sm transition-all duration-500 ease-out ${
                       estEtendu 
                         ? 'md:col-span-2 shadow-xl border-blue-300 ring-2 ring-blue-100 z-10 relative' 
                         : 'hover:shadow-md'
                     } ${isExpanding && estEtendu ? 'animate-pulse' : ''}`}
                   >
                     {/* En-tête de la carte - toujours visible */}
                     <div className="p-6">
                       <div className="flex items-start justify-between mb-4">
                         <div className="flex items-center gap-3">
                           <CreditCard className="h-5 w-5 text-green-600" />
                           <div>
                             <h3 className="font-semibold text-gray-900">{credit.numeroCredit}</h3>
                             <p className="text-sm text-gray-600">{credit.nomClient} {credit.prenomClient}</p>
                           </div>
                         </div>
                         <button
                           onClick={toggleExpansion}
                           className="p-1 hover:bg-gray-100 rounded transition-colors"
                         >
                           {estEtendu ? <ChevronUp className="h-4 w-4" /> : <ChevronDown className="h-4 w-4" />}
                         </button>
                       </div>
                       
                       <div className="space-y-3">
                         <div className="flex justify-between items-center">
                           <span className="text-sm text-gray-600">Montant:</span>
                           <span className="font-medium text-lg">{credit.montantCredit}€</span>
                         </div>
                         
                         <div className="flex justify-between items-center">
                           <span className="text-sm text-gray-600">Banque:</span>
                           <span className="font-medium">{credit.banque || 'Non spécifiée'}</span>
                         </div>
                         
                         <div className="flex gap-2">
                           <span className={`px-2 py-1 rounded-full text-xs font-medium ${
                             credit.estActif ? 'bg-green-100 text-green-800' : 'bg-red-100 text-red-800'
                           }`}>
                             {credit.estActif ? 'Actif' : 'Inactif'}
                           </span>
                           <span className={`px-2 py-1 rounded-full text-xs font-medium ${
                             statutActuel === 'termine' ? 'bg-green-100 text-green-800' :
                             statutActuel === 'actif' ? 'bg-blue-100 text-blue-800' :
                             statutActuel === 'retard' ? 'bg-red-100 text-red-800' :
                             statutActuel === 'approuve' ? 'bg-yellow-100 text-yellow-800' :
                             'bg-gray-100 text-gray-800'
                           }`}>
                             {statutActuel === 'en_attente' ? 'En attente' :
                              statutActuel === 'approuve' ? 'Approuvé' :
                              statutActuel === 'actif' ? 'Actif' :
                              statutActuel === 'termine' ? 'Terminé' :
                              statutActuel === 'retard' ? 'En retard' : statutActuel}
                           </span>
                         </div>
                       </div>
                     </div>
                     
                     {/* Contenu étendu - affiché seulement si étendu */}
                     {estEtendu && (
                       <div className="border-t border-gray-200 animate-fade-in-scale">
                         <div className="p-6 space-y-4 max-h-[50vh] overflow-y-auto overscroll-contain scroll-smooth">
                         {/* Informations client détaillées */}
                         <div>
                           <h4 className="font-medium text-gray-900 mb-3 flex items-center gap-2">
                             <User className="h-4 w-4" />
                             Informations Client
                           </h4>
                           <div className="space-y-2 text-sm">
                             <div className="flex items-center gap-2">
                               <Mail className="h-3 w-3 text-gray-400" />
                               <span>{credit.emailClient}</span>
                             </div>
                             <div className="flex items-center gap-2">
                               <Phone className="h-3 w-3 text-gray-400" />
                               <span>{credit.telephoneClient}</span>
                             </div>
                             <div className="flex items-center gap-2">
                               <MapPin className="h-3 w-3 text-gray-400" />
                               <span>{credit.adresseClient}</span>
                             </div>
                             <div className="flex items-center gap-2">
                               <CreditCard className="h-3 w-3 text-gray-400" />
                               <span>{credit.ibanClient || 'Non renseigné'}</span>
                             </div>
                           </div>
                         </div>
                         
                         {/* Détails du crédit */}
                         <div>
                           <h4 className="font-medium text-gray-900 mb-3">Détails du Crédit</h4>
                           <div className="grid grid-cols-2 gap-3 text-sm">
                             <div>
                               <span className="text-gray-600">Taux d'intérêt:</span>
                               <p className="font-medium">{credit.tauxInteret}%</p>
                             </div>
                             <div>
                               <span className="text-gray-600">Durée:</span>
                               <p className="font-medium">{credit.dureeCredit} mois</p>
                             </div>
                             <div>
                               <span className="text-gray-600">Mensualité:</span>
                               <p className="font-medium">{credit.montantMensuel}€</p>
                             </div>
                             <div>
                               <span className="text-gray-600">Montant total:</span>
                               <p className="font-medium">{montantTotal.toFixed(2)}€</p>
                             </div>
                           </div>
                         </div>
                         
                         {/* Barre de progression */}
                         <div>
                           <h4 className="font-medium text-gray-900 mb-3">Progression du Remboursement</h4>
                           <div className="space-y-2">
                             <div className="flex items-center justify-between text-sm text-gray-600">
                               <span>{progressionPourcentage.toFixed(1)}%</span>
                               <span>{totalRembourse.toFixed(2)}€ / {montantTotal.toFixed(2)}€</span>
                             </div>
                             <div className="w-full bg-gray-200 rounded-full h-3">
                               <div
                                 className="bg-green-600 h-3 rounded-full transition-all duration-300"
                                 style={{ width: `${Math.min(progressionPourcentage, 100)}%` }}
                               ></div>
                             </div>
                           </div>
                         </div>
                         
                         {/* Section Notes */}
                         <div>
                           <h4 className="font-medium text-gray-900 mb-3 flex items-center gap-2">
                             <MessageSquare className="h-4 w-4" />
                             Notes ({(credit.notes || []).length})
                           </h4>
                           
                           {/* Affichage des notes existantes */}
                           <div className="max-h-32 overflow-y-auto space-y-2 mb-3">
                             {(credit.notes || [])
                               .sort((a, b) => new Date(b.date) - new Date(a.date))
                               .map((note, index) => (
                               <div key={index} className="bg-gray-50 p-2 rounded text-sm">
                                 <div className="text-xs text-gray-500 mb-1">
                                   {new Date(note.date).toLocaleDateString('fr-FR', {
                                     day: '2-digit',
                                     month: '2-digit',
                                     year: 'numeric',
                                     hour: '2-digit',
                                     minute: '2-digit'
                                   })}
                                 </div>
                                 <p className="text-gray-700">{note.contenu}</p>
                               </div>
                             ))}
                             {(credit.notes || []).length === 0 && (
                               <p className="text-gray-500 text-sm italic">Aucune note</p>
                             )}
                           </div>
                           
                           {/* Ajout rapide de note */}
                           <input
                             type="text"
                             placeholder="Ajouter une note (Entrée pour sauvegarder)..."
                             onKeyPress={ajouterNoteDirecte}
                             className="w-full p-2 text-sm border border-gray-300 rounded focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                           />
                         </div>
                         
                         {/* Actions */}
                         <div className="flex gap-3 pt-4 border-t">
                           <button
                             onClick={() => {
                               setCreditAModifier(credit);
                               setAffichageModal({...affichageModal, credit: true});
                             }}
                             className="flex-1 flex items-center justify-center gap-2 bg-blue-600 text-white py-2 px-4 rounded hover:bg-blue-700 transition-colors"
                           >
                             <Edit className="h-4 w-4" />
                             Modifier
                           </button>
                           <button
                             onClick={() => {
                               if (window.confirm('Êtes-vous sûr de vouloir supprimer ce crédit ?')) {
                                 setCredits(credits.filter(c => c.id !== credit.id));
                                 setRemboursementsCredits(remboursementsCredits.filter(r => r.creditId !== credit.id));
                               }
                             }}
                             className="flex-1 flex items-center justify-center gap-2 bg-red-600 text-white py-2 px-4 rounded hover:bg-red-700 transition-colors"
                           >
                             <Trash2 className="h-4 w-4" />
                             Supprimer
                           </button>
                         </div>
                       </div>
                       </div>
                     )}
                   </div>
                 );
               })}
            </div>
          )}
        </div>
      </div>
    );
  };

   const renderTableaux = () => {
    const stats = obtenirStatistiques();
    const soldes = calculerSoldes();
    
    // Données pour les graphiques
    const depensesParCategorie = {};
    const depensesParMois = {};
    const depensesParMembre = {};
    
    // Calcul des données
    depenses.forEach(depense => {
      const categorie = depense.categorie;
      const mois = depense.date?.substring(0, 7) || new Date().toISOString().substring(0, 7);
      const montant = parseFloat(depense.montant) || 0;
      
      depensesParCategorie[categorie] = (depensesParCategorie[categorie] || 0) + montant;
      depensesParMois[mois] = (depensesParMois[mois] || 0) + montant;
      
      const nomMembre = obtenirNomMembre(depense.payePar);
      depensesParMembre[nomMembre] = (depensesParMembre[nomMembre] || 0) + montant;
    });
    
    // Composant graphique en barres
    const GraphiqueBarres = ({ donnees, titre, couleur = '#3B82F6' }) => {
      const maxValeur = Math.max(...Object.values(donnees), 1);
      
      return (
        <div className="bg-white p-6 rounded-lg border border-gray-200 shadow-sm">
          <h3 className="text-lg font-semibold mb-4 flex items-center gap-2">
            <BarChart3 className="h-5 w-5" style={{ color: couleur }} />
            {titre}
          </h3>
          <div className="space-y-3">
            {Object.entries(donnees).slice(0, 10).map(([cle, valeur]) => (
              <div key={cle} className="flex items-center gap-3">
                <div className="w-24 text-sm font-medium text-gray-700 truncate">
                  {categories[cle]?.nom || cle}
                </div>
                <div className="flex-1 flex items-center gap-2">
                  <div className="flex-1 bg-gray-200 rounded-full h-3 overflow-hidden">
                    <div
                      className="h-full rounded-full transition-all duration-700 ease-out"
                      style={{
                        width: `${(valeur / maxValeur) * 100}%`,
                        backgroundColor: couleur
                      }}
                    />
                  </div>
                  <span className="text-sm font-semibold text-gray-900 w-16 text-right">
                    {valeur.toFixed(0)}€
                  </span>
                </div>
              </div>
            ))}
          </div>
        </div>
      );
    };
    
    // Composant graphique en secteurs (simple)
    const GraphiqueSecteurs = ({ donnees, titre }) => {
      const total = Object.values(donnees).reduce((sum, val) => sum + val, 0);
      const couleurs = ['#3B82F6', '#EF4444', '#10B981', '#F59E0B', '#8B5CF6', '#EC4899', '#06B6D4', '#84CC16'];
      
      return (
        <div className="bg-white p-6 rounded-lg border border-gray-200 shadow-sm">
          <h3 className="text-lg font-semibold mb-4 flex items-center gap-2">
            <PieChart className="h-5 w-5 text-purple-600" />
            {titre}
          </h3>
          <div className="flex items-center gap-6">
            <div className="relative w-32 h-32">
              <div className="w-full h-full rounded-full bg-gray-200 flex items-center justify-center">
                <div className="w-24 h-24 bg-white rounded-full flex items-center justify-center">
                  <span className="text-sm font-medium text-gray-600">
                    {Object.keys(donnees).length}
                  </span>
                </div>
              </div>
            </div>
            <div className="flex-1 space-y-2">
              {Object.entries(donnees).slice(0, 6).map(([cle, valeur], index) => {
                const pourcentage = ((valeur / total) * 100).toFixed(1);
                const couleur = couleurs[index % couleurs.length];
                
                return (
                  <div key={cle} className="flex items-center gap-3">
                    <div
                      className="w-3 h-3 rounded-full"
                      style={{ backgroundColor: couleur }}
                    />
                    <span className="text-sm text-gray-700 flex-1">
                      {categories[cle]?.nom || cle}
                    </span>
                    <span className="text-sm font-medium text-gray-900">
                      {pourcentage}%
                    </span>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      );
    };
    
    // Composant métriques KPI
    const MetriqueKPI = ({ icone: Icone, titre, valeur, sousValeur, couleur, tendance }) => (
      <div className="bg-white p-6 rounded-lg border border-gray-200 shadow-sm hover:shadow-md transition-shadow">
        <div className="flex items-center justify-between mb-4">
          <div className="flex items-center gap-3">
            <div className={`p-3 rounded-lg`} style={{ backgroundColor: `${couleur}20` }}>
              <Icone className="h-6 w-6" style={{ color: couleur }} />
            </div>
            <div>
              <h3 className="text-sm font-medium text-gray-600">{titre}</h3>
              <p className="text-2xl font-bold text-gray-900">{valeur}</p>
            </div>
          </div>
          {tendance && (
            <div className={`flex items-center gap-1 px-2 py-1 rounded-full text-xs font-medium ${
              tendance > 0 ? 'bg-green-100 text-green-800' : 'bg-red-100 text-red-800'
            }`}>
              <Activity className="h-3 w-3" />
              {tendance > 0 ? '+' : ''}{tendance.toFixed(1)}%
            </div>
          )}
        </div>
        {sousValeur && (
          <p className="text-sm text-gray-500">{sousValeur}</p>
        )}
      </div>
    );
    
    return (
      <div className="space-y-6 max-h-[600px] overflow-y-auto">
        <div className="flex items-center gap-2 mb-6">
          <BarChart3 className="h-6 w-6 text-blue-600" />
          <h2 className="text-2xl font-bold text-gray-900">Tableaux de Bord</h2>
        </div>
        
        {/* Métriques KPI */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
          <MetriqueKPI
            icone={DollarSign}
            titre="Total Dépenses"
            valeur={`${totalDepenses.toFixed(0)}€`}
            sousValeur={`${depenses.length} transactions`}
            couleur="#3B82F6"
            tendance={5.2}
          />
          <MetriqueKPI
            icone={FileText}
            titre="Total Factures"
            valeur={`${totalFactures.toFixed(0)}€`}
            sousValeur={`${factures.length} factures`}
            couleur="#EF4444"
            tendance={-2.1}
          />
          <MetriqueKPI
            icone={UserCheck}
            titre="Total Salaires"
            valeur={`${totalSalaires.toFixed(0)}€`}
            sousValeur={`${salaires.length} paiements`}
            couleur="#10B981"
            tendance={3.8}
          />
          <MetriqueKPI
            icone={Target}
            titre="Moyenne Dépense"
            valeur={`${stats.moyenneDepense}€`}
            sousValeur="Par transaction"
            couleur="#F59E0B"
          />
        </div>
        
        {/* Graphiques principaux */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
          {Object.keys(depensesParCategorie).length > 0 && (
            <GraphiqueBarres
              donnees={depensesParCategorie}
              titre="Dépenses par Catégorie"
              couleur="#3B82F6"
            />
          )}
          
          {Object.keys(depensesParMembre).length > 0 && (
            <GraphiqueSecteurs
              donnees={depensesParMembre}
              titre="Répartition par Membre"
            />
          )}
        </div>
        
        {/* Graphiques secondaires */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
          {Object.keys(depensesParMois).length > 0 && (
            <GraphiqueBarres
              donnees={depensesParMois}
              titre="Évolution Mensuelle"
              couleur="#10B981"
            />
          )}
          
          {/* Graphique des soldes */}
          <div className="bg-white p-6 rounded-lg border border-gray-200 shadow-sm">
            <h3 className="text-lg font-semibold mb-4 flex items-center gap-2">
              <ArrowLeftRight className="h-5 w-5 text-purple-600" />
              Soldes des Membres
            </h3>
            <div className="space-y-3">
              {membres.map(membre => {
                const solde = soldes[membre.id] || 0;
                const estCrediteur = solde > 0.01;
                const estDebiteur = solde < -0.01;
                const maxSolde = Math.max(...Object.values(soldes).map(Math.abs), 1);
                
                return (
                  <div key={membre.id} className="flex items-center gap-3">
                    <div 
                      className="w-8 h-8 rounded-full flex items-center justify-center text-white text-sm font-semibold"
                      style={{ backgroundColor: membre.couleur }}
                    >
                      {membre.nom.charAt(0)}
                    </div>
                    <div className="flex-1 flex items-center gap-2">
                      <span className="w-20 text-sm font-medium text-gray-700">
                        {membre.nom}
                      </span>
                      <div className="flex-1 flex items-center">
                        <div className="flex-1 bg-gray-200 rounded-full h-3 overflow-hidden">
                          <div
                            className={`h-full rounded-full transition-all duration-700 ease-out ${
                              estCrediteur ? 'bg-green-500' : estDebiteur ? 'bg-red-500' : 'bg-gray-400'
                            }`}
                            style={{
                              width: `${(Math.abs(solde) / maxSolde) * 100}%`,
                              marginLeft: estDebiteur ? 'auto' : '0'
                            }}
                          />
                        </div>
                        <span className={`text-sm font-semibold w-16 text-right ${
                          estCrediteur ? 'text-green-700' : estDebiteur ? 'text-red-700' : 'text-gray-700'
                        }`}>
                          {estCrediteur ? '+' : ''}{solde.toFixed(0)}€
                        </span>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
        
        {/* Résumé des tendances */}
        <div className="bg-gradient-to-r from-blue-50 to-purple-50 p-6 rounded-lg border border-blue-200">
          <h3 className="text-lg font-semibold mb-4 flex items-center gap-2">
            <TrendingUp className="h-5 w-5 text-blue-600" />
            Analyse des Tendances
          </h3>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
            <div className="text-center">
              <div className="text-2xl font-bold text-blue-600">{stats.totalTransactions}</div>
              <div className="text-sm text-gray-600">Transactions Totales</div>
            </div>
            <div className="text-center">
              <div className="text-2xl font-bold text-purple-600">
                {Object.keys(depensesParCategorie).length}
              </div>
              <div className="text-sm text-gray-600">Catégories Utilisées</div>
            </div>
            <div className="text-center">
              <div className="text-2xl font-bold text-green-600">{membres.length}</div>
              <div className="text-sm text-gray-600">Membres Actifs</div>
            </div>
          </div>
        </div>
      </div>
    );
  };

  // ========================================
  // INTERFACE DE FACTURATION BELGE
  // ========================================

  const renderFacturationBelge = () => {
    const renderDashboardFacturation = () => (
      <div className="space-y-6">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {/* Statistiques rapides */}
          <div className="bg-gradient-to-r from-blue-500 to-blue-600 text-white p-6 rounded-xl">
            <div className="flex items-center justify-between">
              <div>
                <p className="text-blue-100">Clients</p>
                <p className="text-2xl font-bold">{clientsBelges.length}</p>
              </div>
              <Users className="h-8 w-8 text-blue-200" />
            </div>
          </div>
          
          <div className="bg-gradient-to-r from-green-500 to-green-600 text-white p-6 rounded-xl">
            <div className="flex items-center justify-between">
              <div>
                <p className="text-green-100">Produits/Services</p>
                <p className="text-2xl font-bold">{produitsBelges.length}</p>
              </div>
              <Receipt className="h-8 w-8 text-green-200" />
            </div>
          </div>
          
          <div className="bg-gradient-to-r from-purple-500 to-purple-600 text-white p-6 rounded-xl">
            <div className="flex items-center justify-between">
              <div>
                <p className="text-purple-100">Factures</p>
                <p className="text-2xl font-bold">{facturesBelges.length}</p>
              </div>
              <FileText className="h-8 w-8 text-purple-200" />
            </div>
          </div>
        </div>

        {/* Actions rapides */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
          <button
            onClick={() => setAffichageModalBelge({ ...affichageModalBelge, client: true })}
            className="p-6 bg-white border-2 border-dashed border-gray-300 rounded-xl hover:border-blue-400 hover:bg-blue-50 transition-colors group"
          >
            <div className="text-center">
              <UserPlus className="h-12 w-12 text-gray-400 group-hover:text-blue-500 mx-auto mb-3" />
              <h3 className="font-semibold text-gray-900">Nouveau Client</h3>
              <p className="text-sm text-gray-500">Ajouter un client belge</p>
            </div>
          </button>
          
          <button
            onClick={() => setAffichageModalBelge({ ...affichageModalBelge, produit: true })}
            className="p-6 bg-white border-2 border-dashed border-gray-300 rounded-xl hover:border-green-400 hover:bg-green-50 transition-colors group"
          >
            <div className="text-center">
              <Plus className="h-12 w-12 text-gray-400 group-hover:text-green-500 mx-auto mb-3" />
              <h3 className="font-semibold text-gray-900">Nouveau Produit</h3>
              <p className="text-sm text-gray-500">Ajouter un produit/service</p>
            </div>
          </button>
          
          <button
            onClick={() => setAffichageModalBelge({ ...affichageModalBelge, facture: true })}
            className="p-6 bg-white border-2 border-dashed border-gray-300 rounded-xl hover:border-purple-400 hover:bg-purple-50 transition-colors group"
          >
            <div className="text-center">
              <FileText className="h-12 w-12 text-gray-400 group-hover:text-purple-500 mx-auto mb-3" />
              <h3 className="font-semibold text-gray-900">Nouvelle Facture</h3>
              <p className="text-sm text-gray-500">Créer une facture belge</p>
            </div>
          </button>
        </div>
      </div>
    );

    const renderClientsTab = () => (
      <div className="space-y-4">
        <div className="flex justify-between items-center">
          <h3 className="text-lg font-semibold">Clients Belges ({clientsBelges.length})</h3>
          <button
            onClick={() => setAffichageModalBelge({ ...affichageModalBelge, client: true })}
            className="bg-blue-600 text-white px-4 py-2 rounded-lg hover:bg-blue-700 flex items-center gap-2"
          >
            <UserPlus className="h-4 w-4" />
            Nouveau Client
          </button>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          {clientsBelges.map(client => (
            <div key={client.id} className="bg-white p-4 rounded-lg border hover:shadow-md transition-shadow">
              <div className="flex justify-between items-start mb-3">
                <div>
                  <h4 className="font-semibold text-gray-900">
                    {client.prenom} {client.nom}
                  </h4>
                  {client.entreprise && (
                    <p className="text-sm text-gray-600">{client.entreprise}</p>
                  )}
                </div>
                <button
                  onClick={() => setClientsBelges(clientsBelges.filter(c => c.id !== client.id))}
                  className="text-red-500 hover:text-red-700"
                >
                  <Trash2 className="h-4 w-4" />
                </button>
              </div>
              
              <div className="space-y-1 text-sm text-gray-600">
                <div className="flex items-center gap-2">
                  <Mail className="h-3 w-3" />
                  {client.email}
                </div>
                {client.telephone && (
                  <div className="flex items-center gap-2">
                    <Phone className="h-3 w-3" />
                    {client.telephone}
                  </div>
                )}
                {client.numeroTVA && (
                  <div className="flex items-center gap-2">
                    <FileText className="h-3 w-3" />
                    TVA: {client.numeroTVA}
                  </div>
                )}
                <div className="flex items-center gap-2">
                  <MapPin className="h-3 w-3" />
                  {client.ville}, {client.pays}
                </div>
              </div>
            </div>
          ))}
          
          {clientsBelges.length === 0 && (
            <div className="col-span-full text-center py-12">
              <Users className="h-12 w-12 text-gray-400 mx-auto mb-4" />
              <p className="text-gray-500">Aucun client enregistré</p>
            </div>
          )}
        </div>
      </div>
    );

    const renderProduitsTab = () => (
      <div className="space-y-4">
        <div className="flex justify-between items-center">
          <h3 className="text-lg font-semibold">Catalogue Produits/Services ({produitsBelges.length})</h3>
          <button
            onClick={() => setAffichageModalBelge({ ...affichageModalBelge, produit: true })}
            className="bg-green-600 text-white px-4 py-2 rounded-lg hover:bg-green-700 flex items-center gap-2"
          >
            <Plus className="h-4 w-4" />
            Nouveau Produit/Service
          </button>
        </div>
        
        <div className="overflow-x-auto">
          <table className="w-full bg-white rounded-lg border">
            <thead className="bg-gray-50">
              <tr>
                <th className="text-left p-4 font-semibold">Nom</th>
                <th className="text-left p-4 font-semibold">Catégorie</th>
                <th className="text-left p-4 font-semibold">Prix HT</th>
                <th className="text-left p-4 font-semibold">TVA</th>
                <th className="text-left p-4 font-semibold">Prix TTC</th>
                <th className="text-left p-4 font-semibold">Unité</th>
                <th className="text-left p-4 font-semibold">Actions</th>
              </tr>
            </thead>
            <tbody>
              {produitsBelges.map(produit => {
                const tva = tauxTVABelges[produit.tauxTVA];
                const prixTTC = produit.prix * (1 + tva.taux / 100);
                return (
                  <tr key={produit.id} className="border-t hover:bg-gray-50">
                    <td className="p-4">
                      <div>
                        <div className="font-medium">{produit.nom}</div>
                        {produit.description && (
                          <div className="text-sm text-gray-500">{produit.description}</div>
                        )}
                      </div>
                    </td>
                    <td className="p-4">
                      <span className="inline-flex items-center gap-1 px-2 py-1 bg-gray-100 rounded">
                        <span>{categoriesProduits[produit.categorie]?.icone}</span>
                        <span className="text-sm">{categoriesProduits[produit.categorie]?.nom}</span>
                      </span>
                    </td>
                    <td className="p-4 font-medium">{produit.prix.toFixed(2)}€</td>
                    <td className="p-4">
                      <span className="inline-flex items-center px-2 py-1 bg-blue-100 text-blue-800 rounded text-sm">
                        {tva.taux}%
                      </span>
                    </td>
                    <td className="p-4 font-medium">{prixTTC.toFixed(2)}€</td>
                    <td className="p-4">{produit.unite}</td>
                    <td className="p-4">
                      <button
                        onClick={() => setProduitsBelges(produitsBelges.filter(p => p.id !== produit.id))}
                        className="text-red-500 hover:text-red-700"
                      >
                        <Trash2 className="h-4 w-4" />
                      </button>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
          
          {produitsBelges.length === 0 && (
            <div className="text-center py-12">
              <Receipt className="h-12 w-12 text-gray-400 mx-auto mb-4" />
              <p className="text-gray-500">Aucun produit ou service enregistré</p>
            </div>
          )}
        </div>
      </div>
    );

    const renderFacturesTab = () => (
      <div className="space-y-4">
        <div className="flex justify-between items-center">
          <h3 className="text-lg font-semibold">Factures Belges ({facturesBelges.length})</h3>
          <button
            onClick={() => setAffichageModalBelge({ ...affichageModalBelge, facture: true })}
            className="bg-purple-600 text-white px-4 py-2 rounded-lg hover:bg-purple-700 flex items-center gap-2"
          >
            <FileText className="h-4 w-4" />
            Nouvelle Facture
          </button>
        </div>
        
        <div className="overflow-x-auto">
          <table className="w-full bg-white rounded-lg border">
            <thead className="bg-gray-50">
              <tr>
                <th className="text-left p-4 font-semibold">N° Facture</th>
                <th className="text-left p-4 font-semibold">Client</th>
                <th className="text-left p-4 font-semibold">Date</th>
                <th className="text-left p-4 font-semibold">Total HT</th>
                <th className="text-left p-4 font-semibold">TVA</th>
                <th className="text-left p-4 font-semibold">Total TTC</th>
                <th className="text-left p-4 font-semibold">Statut</th>
                <th className="text-left p-4 font-semibold">Actions</th>
              </tr>
            </thead>
            <tbody>
              {facturesBelges.map(facture => {
                const client = clientsBelges.find(c => c.id === facture.clientId);
                return (
                  <tr key={facture.id} className="border-t hover:bg-gray-50">
                    <td className="p-4 font-medium">{facture.numero}</td>
                    <td className="p-4">
                      {client ? `${client.prenom} ${client.nom}` : 'Client supprimé'}
                      {client?.entreprise && (
                        <div className="text-sm text-gray-500">{client.entreprise}</div>
                      )}
                    </td>
                    <td className="p-4">{facture.dateEmission}</td>
                    <td className="p-4">{facture.totalHT?.toFixed(2)}€</td>
                    <td className="p-4">{facture.totalTVA?.toFixed(2)}€</td>
                    <td className="p-4 font-medium">{facture.totalTTC?.toFixed(2)}€</td>
                    <td className="p-4">
                      <span className={`inline-flex items-center px-2 py-1 rounded text-sm ${
                        facture.statut === 'brouillon' ? 'bg-gray-100 text-gray-800' :
                        facture.statut === 'envoyee' ? 'bg-blue-100 text-blue-800' :
                        facture.statut === 'payee' ? 'bg-green-100 text-green-800' :
                        'bg-red-100 text-red-800'
                      }`}>
                        {facture.statut}
                      </span>
                    </td>
                    <td className="p-4">
                      <div className="flex gap-2">
                        <button
                          onClick={() => setAffichageModalBelge({ ...affichageModalBelge, previewFacture: true })}
                          className="text-blue-500 hover:text-blue-700"
                          title="Prévisualiser"
                        >
                          <Eye className="h-4 w-4" />
                        </button>
                        <button
                          onClick={() => setFacturesBelges(facturesBelges.filter(f => f.id !== facture.id))}
                          className="text-red-500 hover:text-red-700"
                          title="Supprimer"
                        >
                          <Trash2 className="h-4 w-4" />
                        </button>
                      </div>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
          
          {facturesBelges.length === 0 && (
            <div className="text-center py-12">
              <FileText className="h-12 w-12 text-gray-400 mx-auto mb-4" />
              <p className="text-gray-500">Aucune facture créée</p>
            </div>
          )}
        </div>
      </div>
    );

    return (
      <div className="space-y-6 max-h-[600px] overflow-y-auto">
        <div className="flex items-center gap-2 mb-6">
          <Receipt className="h-6 w-6 text-purple-600" />
          <h2 className="text-2xl font-bold text-gray-900">Facturation Belge</h2>
        </div>

        {/* Navigation des sous-onglets */}
        <div className="border-b border-gray-200">
          <nav className="flex space-x-8">
            {[
              { id: 'dashboard', nom: 'Tableau de bord', icone: BarChart3 },
              { id: 'clients', nom: 'Clients', icone: Users },
              { id: 'produits', nom: 'Produits/Services', icone: Receipt },
              { id: 'factures', nom: 'Factures', icone: FileText }
            ].map(tab => {
              const Icone = tab.icone;
              return (
                <button
                  key={tab.id}
                  onClick={() => setSousOngletFacturation(tab.id)}
                  className={`py-2 px-1 border-b-2 font-medium text-sm flex items-center gap-2 ${
                    sousOngletFacturation === tab.id
                      ? 'border-purple-500 text-purple-600'
                      : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
                  }`}
                >
                  <Icone className="h-4 w-4" />
                  {tab.nom}
                </button>
              );
            })}
          </nav>
        </div>

        {/* Contenu des sous-onglets */}
        <div className="mt-6">
          {sousOngletFacturation === 'dashboard' && renderDashboardFacturation()}
          {sousOngletFacturation === 'clients' && renderClientsTab()}
          {sousOngletFacturation === 'produits' && renderProduitsTab()}
          {sousOngletFacturation === 'factures' && renderFacturesTab()}
        </div>
      </div>
    );
  };

  // Fonction de login
  const handleLogin = async (e) => {
    e.preventDefault();
    setLoginError('');
    setIsLoggingIn(true);

    // Simulation d'un délai pour l'effet de sécurité
    await new Promise(resolve => setTimeout(resolve, 1000));

    if (authorizedUsers.includes(loginData.username) && loginData.password === validPassword) {
      setIsAuthenticated(true);
      if (rememberMe) {
        localStorage.setItem('monarchSession', JSON.stringify({
          username: loginData.username,
          timestamp: Date.now()
        }));
      }
      setIsLoggingIn(false);
    } else {
      setLoginError('Identifiants invalides');
      setIsLoggingIn(false);
      // Vibration subtile sur erreur (si supporté)
      if (navigator.vibrate) {
        navigator.vibrate(200);
      }
    }
  };

  const handleLogout = () => {
    setIsAuthenticated(false);
    localStorage.removeItem('monarchSession');
    setLoginData({ username: '', password: '' });
  };

  // Page de login style Apple
  if (!isAuthenticated) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-gray-900 via-gray-800 to-black flex items-center justify-center p-4">
        <div className="w-full max-w-md">
          {/* Logo et titre */}
          <div className="text-center mb-8">
            <div className="inline-flex items-center justify-center w-20 h-20 bg-white rounded-2xl shadow-2xl mb-4">
              <Shield className="h-10 w-10 text-gray-900" />
            </div>
            <h1 className="text-3xl font-bold text-white mb-2">MONARCH TRADE GROUP</h1>
            <p className="text-gray-400">Connectez-vous pour continuer</p>
          </div>

          {/* Formulaire de connexion */}
          <form onSubmit={handleLogin} className="bg-white/10 backdrop-blur-xl rounded-3xl p-8 shadow-2xl border border-white/20">
            <div className="space-y-6">
              {/* Champ utilisateur */}
              <div>
                <label className="block text-sm font-medium text-gray-300 mb-2">
                  Nom d'utilisateur
                </label>
                <div className="relative">
                  <input
                    type="text"
                    value={loginData.username}
                    onChange={(e) => setLoginData({...loginData, username: e.target.value})}
                    className="w-full px-4 py-3 pl-12 bg-white/5 border border-white/10 rounded-2xl text-white placeholder-gray-500 focus:bg-white/10 focus:border-blue-500 focus:outline-none transition-all"
                    placeholder="Monarch1"
                    required
                    autoFocus
                  />
                  <User className="absolute left-4 top-3.5 h-5 w-5 text-gray-400" />
                </div>
              </div>

              {/* Champ mot de passe */}
              <div>
                <label className="block text-sm font-medium text-gray-300 mb-2">
                  Mot de passe
                </label>
                <div className="relative">
                  <input
                    type={showPassword ? "text" : "password"}
                    value={loginData.password}
                    onChange={(e) => setLoginData({...loginData, password: e.target.value})}
                    className="w-full px-4 py-3 pl-12 pr-12 bg-white/5 border border-white/10 rounded-2xl text-white placeholder-gray-500 focus:bg-white/10 focus:border-blue-500 focus:outline-none transition-all"
                    placeholder="••••••••••••••"
                    required
                  />
                  <Shield className="absolute left-4 top-3.5 h-5 w-5 text-gray-400" />
                  <button
                    type="button"
                    onClick={() => setShowPassword(!showPassword)}
                    className="absolute right-4 top-3.5 text-gray-400 hover:text-white transition-colors"
                  >
                    <Eye className={`h-5 w-5 ${showPassword ? 'text-blue-500' : ''}`} />
                  </button>
                </div>
              </div>

              {/* Options supplémentaires */}
              <div className="flex items-center justify-between">
                <label className="flex items-center text-sm text-gray-300">
                  <input
                    type="checkbox"
                    checked={rememberMe}
                    onChange={(e) => setRememberMe(e.target.checked)}
                    className="w-4 h-4 bg-white/5 border-white/20 rounded text-blue-500 focus:ring-blue-500 focus:ring-offset-0"
                  />
                  <span className="ml-2">Se souvenir de moi</span>
                </label>
              </div>

              {/* Message d'erreur */}
              {loginError && (
                <div className="bg-red-500/10 border border-red-500/20 rounded-xl p-3 text-red-400 text-sm flex items-center gap-2">
                  <AlertCircle className="h-4 w-4" />
                  {loginError}
                </div>
              )}

              {/* Bouton de connexion */}
              <button
                type="submit"
                disabled={isLoggingIn}
                className={`w-full py-4 rounded-2xl font-semibold text-white transition-all transform ${
                  isLoggingIn 
                    ? 'bg-gray-600 cursor-not-allowed' 
                    : 'bg-gradient-to-r from-blue-500 to-indigo-600 hover:from-blue-600 hover:to-indigo-700 active:scale-95'
                } shadow-lg`}
              >
                {isLoggingIn ? (
                  <span className="flex items-center justify-center gap-2">
                    <div className="w-5 h-5 border-2 border-white/30 border-t-white rounded-full animate-spin" />
                    Connexion...
                  </span>
                ) : (
                  'Se connecter'
                )}
              </button>
            </div>
          </form>

          {/* Footer */}
          <div className="text-center mt-8 text-gray-500 text-sm">
            <p>© 2025 Monarch Trade Group. Tous droits réservés.</p>
            <p className="mt-2 flex items-center justify-center gap-1">
              <Shield className="h-3 w-3" />
              Connexion sécurisée
            </p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-50">
      
      <div className="bg-gradient-to-r from-gray-900 to-gray-800 text-white">
        <div className="max-w-7xl mx-auto px-4 py-8">
          <div className="flex items-center justify-between">
            <div>
              <h1 className="text-4xl font-bold mb-2">MONARCH TRADE GROUP</h1>
              <p className="text-gray-300 text-lg">Gestionnaire Financier Professionnel</p>
              <p className="text-gray-400 text-sm mt-1">Solution complète de gestion des finances d'entreprise</p>
            </div>
            <div className="text-right">
              <div className="bg-white/10 rounded-lg p-4">
                <p className={`text-2xl font-bold ${totalGeneral >= 0 ? 'text-green-300' : 'text-red-300'}`}>
                  {totalGeneral >= 0 ? '+' : ''}{totalGeneral.toFixed(2)}€
                </p>
                <p className="text-sm text-gray-300">Total Général</p>
                <div className="text-xs text-gray-400 mt-1">
                  <span className="text-green-300">+{(totalEntrees + totalCredits).toFixed(2)}€</span>
                  {' '}
                  <span className="text-red-300">-{(totalDepenses + totalFactures + totalSalaires).toFixed(2)}€</span>
                </div>
              </div>
              <button
                onClick={handleLogout}
                className="mt-3 px-4 py-2 bg-red-500/20 hover:bg-red-500/30 text-red-300 rounded-lg text-sm font-medium transition-colors flex items-center gap-2 ml-auto"
              >
                <Shield className="h-4 w-4" />
                Déconnexion
              </button>
            </div>
          </div>
          
          {/* Bouton de migration si nécessaire */}
          {showMigrationButton && (
            <div className="mt-4 bg-yellow-500/20 border border-yellow-500/50 rounded-lg p-4">
              <p className="text-yellow-300 font-medium mb-2">Données locales détectées</p>
              <p className="text-yellow-200 text-sm mb-3">
                Vos données sont actuellement stockées localement. Migrez-les vers le cloud pour les partager entre utilisateurs.
              </p>
              <button
                onClick={migrerDonneesVersSupabase}
                className="bg-yellow-500 hover:bg-yellow-600 text-gray-900 font-medium px-4 py-2 rounded-lg transition-colors"
              >
                Migrer vers le Cloud
              </button>
            </div>
          )}
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-4 py-6">
        {/* Notifications et Alertes */}
        {depensesRecurrentes.filter(r => r.actif && r.prochainePaie <= new Date().toISOString().split('T')[0]).length > 0 && (
          <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-4 mb-6 notification-enter animate-bounce-in">
            <div className="flex items-center gap-2 mb-2">
              <Calendar className="h-5 w-5 text-yellow-600" />
              <h3 className="text-sm font-medium text-yellow-800">
                Dépenses Récurrentes À Traiter
              </h3>
            </div>
            <div className="space-y-2">
              {depensesRecurrentes
                .filter(r => r.actif && r.prochainePaie <= new Date().toISOString().split('T')[0])
                .map(recurrente => (
                  <div key={recurrente.id} className="flex items-center justify-between bg-white p-3 rounded border">
                    <div className="flex items-center gap-3">
                      <Repeat className="h-4 w-4 text-yellow-600" />
                      <div>
                        <p className="font-medium text-gray-900">{recurrente.description}</p>
                        <p className="text-sm text-gray-500">
                          {recurrente.montant}€ • {recurrente.frequence} • Échéance: {recurrente.prochainePaie}
                        </p>
                      </div>
                    </div>
                    <span className="bg-yellow-100 text-yellow-800 px-2 py-1 rounded-full text-xs font-medium">
                      À traiter
                    </span>
                  </div>
                ))}
            </div>
          </div>
        )}

        {factures.filter(f => f.statut === 'retard').length > 0 && (
          <div className="bg-red-50 border border-red-200 rounded-lg p-4 mb-6">
            <div className="flex items-center gap-2 mb-2">
              <FileText className="h-5 w-5 text-red-600" />
              <h3 className="text-sm font-medium text-red-800">
                Factures En Retard
              </h3>
            </div>
            <div className="space-y-2">
              {factures
                .filter(f => f.statut === 'retard')
                .map(facture => (
                  <div key={facture.id} className="flex items-center justify-between bg-white p-3 rounded border">
                    <div>
                      <p className="font-medium text-gray-900">Facture {facture.numero}</p>
                      <p className="text-sm text-gray-500">
                        {facture.fournisseur} • {facture.montant}€ • Échéance: {facture.dateEcheance}
                      </p>
                    </div>
                    <span className="bg-red-100 text-red-800 px-2 py-1 rounded-full text-xs font-medium">
                      En retard
                    </span>
                  </div>
                ))}
            </div>
          </div>
        )}
        <div className="grid grid-cols-1 md:grid-cols-5 gap-4 mb-6">
          <div className="bg-white rounded-xl p-6 border border-gray-200 hover-shadow hover-scale animate-fade-in-scale">
            <div className="flex items-center">
              <div className="p-2 bg-green-100 rounded-lg">
                <DollarSign className="h-6 w-6 text-green-600" />
              </div>
              <div className="ml-4">
                <p className="text-sm font-medium text-gray-500">Dépenses</p>
                <p className="text-xl font-bold text-gray-900">{totalDepenses.toFixed(2)}€</p>
              </div>
            </div>
          </div>
          
          <div className="bg-white rounded-xl p-6 border border-gray-200 hover-shadow hover-scale animate-fade-in-scale">
            <div className="flex items-center">
              <div className="p-2 bg-blue-100 rounded-lg">
                <FileText className="h-6 w-6 text-blue-600" />
              </div>
              <div className="ml-4">
                <p className="text-sm font-medium text-gray-500">Factures</p>
                <p className="text-xl font-bold text-gray-900">{totalFactures.toFixed(2)}€</p>
              </div>
            </div>
          </div>
          
          <div className="bg-white rounded-xl p-6 border border-gray-200 hover-shadow hover-scale animate-fade-in-scale">
            <div className="flex items-center">
              <div className="p-2 bg-purple-100 rounded-lg">
                <UserCheck className="h-6 w-6 text-purple-600" />
              </div>
              <div className="ml-4">
                <p className="text-sm font-medium text-gray-500">Salaires</p>
                <p className="text-xl font-bold text-gray-900">{totalSalaires.toFixed(2)}€</p>
              </div>
            </div>
          </div>

          <div className="bg-white rounded-xl p-6 border border-gray-200 hover-shadow hover-scale animate-fade-in-scale">
            <div className="flex items-center">
              <div className="p-2 bg-yellow-100 rounded-lg">
                <Repeat className="h-6 w-6 text-yellow-600" />
              </div>
              <div className="ml-4">
                <p className="text-sm font-medium text-gray-500">Récurrentes</p>
                <p className="text-xl font-bold text-gray-900">{depensesRecurrentes.filter(r => r.actif).length}</p>
              </div>
            </div>
          </div>

          <div className="bg-white rounded-xl p-6 border border-gray-200 hover-shadow hover-scale animate-fade-in-scale">
            <div className="flex items-center">
              <div className="p-2 bg-red-100 rounded-lg">
                <Users className="h-6 w-6 text-red-600" />
              </div>
              <div className="ml-4">
                <p className="text-sm font-medium text-gray-500">Équipe</p>
                <p className="text-xl font-bold text-gray-900">{membres.length + employes.length}</p>
                {employes.length > 0 && (
                  <button 
                    onClick={() => {
                      setEmployes([]);
                      alert(`${employes.length} employés supprimés`);
                    }}
                    className="text-xs text-red-600 underline mt-1"
                  >
                    Supprimer {employes.length} employés
                  </button>
                )}
              </div>
            </div>
          </div>
        </div>

        {/* Section Statistiques Avancées */}
        {(depenses.length > 0 || factures.length > 0 || salaires.length > 0) && (
          <div className="bg-white rounded-xl border border-gray-200 mb-6 p-6">
            <h2 className="text-lg font-semibold mb-4 flex items-center gap-2">
              <TrendingUp className="h-5 w-5 text-green-600" />
              Statistiques Avancées
            </h2>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
              <div className="bg-gradient-to-r from-blue-50 to-blue-100 p-4 rounded-lg">
                <div className="flex items-center gap-2 mb-2">
                  <Calendar className="h-4 w-4 text-blue-600" />
                  <span className="text-sm font-medium text-blue-800">Transactions</span>
                </div>
                <p className="text-2xl font-bold text-blue-900">{obtenirStatistiques().totalTransactions}</p>
                <p className="text-xs text-blue-600">Total toutes catégories</p>
              </div>
              <div className="bg-gradient-to-r from-green-50 to-green-100 p-4 rounded-lg">
                <div className="flex items-center gap-2 mb-2">
                  <TrendingUp className="h-4 w-4 text-green-600" />
                  <span className="text-sm font-medium text-green-800">Moyenne</span>
                </div>
                <p className="text-2xl font-bold text-green-900">{obtenirStatistiques().moyenneDepense}€</p>
                <p className="text-xs text-green-600">Par dépense</p>
              </div>
              <div className="bg-gradient-to-r from-purple-50 to-purple-100 p-4 rounded-lg">
                <div className="flex items-center gap-2 mb-2">
                  <Users className="h-4 w-4 text-purple-600" />
                  <span className="text-sm font-medium text-purple-800">Catégorie Top</span>
                </div>
                <p className="text-lg font-bold text-purple-900">
                  {Object.entries(obtenirStatistiques().categoriesPlusUtilisees).sort(([,a], [,b]) => b - a)[0]?.[0] ? 
                    categories[Object.entries(obtenirStatistiques().categoriesPlusUtilisees).sort(([,a], [,b]) => b - a)[0][0]]?.icone + ' ' + 
                    categories[Object.entries(obtenirStatistiques().categoriesPlusUtilisees).sort(([,a], [,b]) => b - a)[0][0]]?.nom 
                    : 'Aucune'}
                </p>
                <p className="text-xs text-purple-600">
                  {Object.entries(obtenirStatistiques().categoriesPlusUtilisees).sort(([,a], [,b]) => b - a)[0]?.[1] || 0} utilisations
                </p>
              </div>
            </div>
          </div>
        )}

        <div className="card-background rounded-3xl border border-gray-200/30 mb-8 overflow-hidden shadow-2xl">
          <div className="border-b border-gray-100 bg-white/50 backdrop-blur-sm">
            <nav className="flex space-x-2 px-6 py-2 overflow-x-auto scrollbar-hide" style={{ scrollBehavior: 'smooth', WebkitOverflowScrolling: 'touch' }}>
              {[
                { id: 'entrees', nom: 'Entrées', icone: TrendingUp },
                { id: 'depenses', nom: 'Dépenses', icone: DollarSign },
                { id: 'factures', nom: 'Factures', icone: FileText },
                { id: 'facturation', nom: 'Facturation', icone: Receipt },
                { id: 'salaires', nom: 'Salaires', icone: UserCheck },
                { id: 'recurrentes', nom: 'Récurrentes', icone: Repeat },
                { id: 'soldes', nom: 'Soldes', icone: ArrowLeftRight },
                { id: 'membres', nom: 'Membres', icone: Users },
                { id: 'employes', nom: 'Employés', icone: UserCheck },
                { id: 'credits', nom: 'Crédits', icone: Banknote },
                { id: 'remboursements', nom: 'Remboursements', icone: Receipt },
                { id: 'tableaux', nom: 'Tableaux de Bord', icone: BarChart3 }
              ].map(onglet => {
                const Icone = onglet.icone;
                return (
                  <button
                    key={onglet.id}
                    onClick={() => setOngletActif(onglet.id)}
                    className={`py-4 px-6 mx-1 rounded-2xl font-semibold text-sm flex items-center gap-3 transition-all duration-300 whitespace-nowrap flex-shrink-0 ${
                      ongletActif === onglet.id
                        ? 'bg-gradient-to-r from-blue-500 to-indigo-600 text-white shadow-lg transform scale-105'
                        : 'text-gray-600 hover:text-gray-900 hover:bg-gray-100 hover:scale-102'
                    }`}
                  >
                    <Icone className="h-5 w-5" />
                    <span>{onglet.nom}</span>
                  </button>
                );
              })}
            </nav>
          </div>

          <div className="p-6 border-b border-gray-100 bg-gradient-to-r from-slate-50 to-gray-50">
            <div className="flex flex-col md:flex-row gap-6 justify-between">
              <div className="flex flex-wrap gap-3">
                <button 
                  onClick={() => setAffichageModal({ ...affichageModal, membre: true })}
                  className="hover-scale bg-gradient-to-r from-indigo-500 to-purple-600 text-white px-6 py-3 rounded-2xl flex items-center gap-2 shadow-lg transition-all duration-300 hover:shadow-xl min-w-[140px] justify-center"
                >
                  <Plus className="h-5 w-5" />
                  <span className="font-medium">Membre</span>
                </button>
                <button 
                  onClick={() => setAffichageModal({ ...affichageModal, entree: true })}
                  className="hover-scale bg-gradient-to-r from-green-500 to-emerald-600 text-white px-6 py-3 rounded-2xl flex items-center gap-2 shadow-lg transition-all duration-300 hover:shadow-xl min-w-[140px] justify-center"
                >
                  <Plus className="h-5 w-5" />
                  <span className="font-medium">Entrée</span>
                </button>
                <button 
                  onClick={() => setAffichageModal({ ...affichageModal, depense: true })}
                  className="hover-scale bg-gradient-to-r from-red-500 to-pink-600 text-white px-6 py-3 rounded-2xl flex items-center gap-2 shadow-lg transition-all duration-300 hover:shadow-xl min-w-[140px] justify-center"
                >
                  <Plus className="h-5 w-5" />
                  <span className="font-medium">Dépense</span>
                </button>
                <button 
                  onClick={() => setAffichageModal({ ...affichageModal, facture: true })}
                  className="hover-scale bg-gradient-to-r from-blue-500 to-cyan-600 text-white px-6 py-3 rounded-2xl flex items-center gap-2 shadow-lg transition-all duration-300 hover:shadow-xl min-w-[140px] justify-center"
                >
                  <Plus className="h-5 w-5" />
                  <span className="font-medium">Facture</span>
                </button>
                <button 
                  onClick={() => setAffichageModal({ ...affichageModal, salaire: true })}
                  className="hover-scale bg-gradient-to-r from-purple-500 to-pink-600 text-white px-6 py-3 rounded-2xl flex items-center gap-2 shadow-lg transition-all duration-300 hover:shadow-xl min-w-[140px] justify-center"
                >
                  <Plus className="h-5 w-5" />
                  <span className="font-medium">Salaire</span>
                </button>
                <button 
                  onClick={() => setAffichageModal({ ...affichageModal, recurrente: true })}
                  className="hover-scale bg-gradient-to-r from-amber-500 to-orange-600 text-white px-6 py-3 rounded-2xl flex items-center gap-2 shadow-lg transition-all duration-300 hover:shadow-xl min-w-[140px] justify-center"
                >
                  <Plus className="h-5 w-5" />
                  <span className="font-medium">Récurrente</span>
                </button>
                <button 
                  onClick={() => setAffichageModal({ ...affichageModal, employe: true })}
                  className="hover-scale bg-gradient-to-r from-slate-500 to-gray-600 text-white px-6 py-3 rounded-2xl flex items-center gap-2 shadow-lg transition-all duration-300 hover:shadow-xl min-w-[140px] justify-center"
                >
                  <Plus className="h-5 w-5" />
                  <span className="font-medium">Employé</span>
                </button>
                <button 
                  onClick={() => setAffichageModal({ ...affichageModal, credit: true })}
                  className="hover-scale bg-gradient-to-r from-teal-500 to-cyan-600 text-white px-6 py-3 rounded-2xl flex items-center gap-2 shadow-lg transition-all duration-300 hover:shadow-xl min-w-[140px] justify-center"
                >
                  <Plus className="h-5 w-5" />
                  <span className="font-medium">Crédit</span>
                </button>
                <button 
                  onClick={() => setAffichageModal({ ...affichageModal, remboursement: true })}
                  className="hover-scale bg-gradient-to-r from-emerald-500 to-green-600 text-white px-6 py-3 rounded-2xl flex items-center gap-2 shadow-lg transition-all duration-300 hover:shadow-xl min-w-[140px] justify-center"
                >
                  <Plus className="h-5 w-5" />
                  <span className="font-medium">Remboursement</span>
                </button>
              </div>
              
              <div className="flex flex-wrap gap-3 items-center">
                <div className="relative">
                  <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 h-4 w-4 text-gray-400" />
                  <input
                    type="text"
                    placeholder="Rechercher..."
                    value={recherche}
                    onChange={(e) => setRecherche(e.target.value)}
                    className="pl-10 pr-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 w-48 sm:w-64"
                  />
                </div>
                <select 
                  value={filtreCategorie}
                  onChange={(e) => setFiltreCategorie(e.target.value)}
                  className="px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500"
                >
                  <option value="toutes">Toutes les catégories</option>
                  {Object.entries(categories).map(([cle, cat]) => (
                    <option key={cle} value={cle}>{cat.icone} {cat.nom}</option>
                  ))}
                </select>
                <div className="flex gap-3">
                  <button 
                    onClick={() => exporterDonnees('csv')}
                    className="hover-scale bg-gradient-to-r from-gray-800 to-gray-900 text-white px-4 py-2 rounded-xl flex items-center gap-2 text-sm font-medium shadow-lg transition-all duration-300 hover:shadow-xl min-w-[80px] justify-center"
                  >
                    <Download className="h-4 w-4" />
                    <span>CSV</span>
                  </button>
                  <button 
                    onClick={() => exporterDonnees('json')}
                    className="hover-scale bg-gradient-to-r from-blue-600 to-indigo-700 text-white px-4 py-2 rounded-xl flex items-center gap-2 text-sm font-medium shadow-lg transition-all duration-300 hover:shadow-xl min-w-[80px] justify-center"
                  >
                    <Download className="h-4 w-4" />
                    <span>JSON</span>
                  </button>
                </div>
              </div>
            </div>
          </div>

          <div className="p-8 animate-fade-in-scale">
            {renderContenuOnglet()}
          </div>
        </div>
      </div>


      {/* Modals pour tous les formulaires */}
      
      {/* Modal Ajouter/Modifier Membre */}
      {affichageModal.membre && (
        <div 
          className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50"
          onClick={(e) => {
            if (e.target === e.currentTarget) {
              fermerToutesLesModales();
            }
          }}
        >
          <div className="bg-white rounded-3xl p-8 w-full max-w-md shadow-2xl border border-gray-200/30">
            <h3 className="text-lg font-semibold mb-4 flex items-center gap-2">
              {membreAModifier ? (
                <>
                  <Edit className="h-5 w-5 text-blue-600" />
                  Modifier le Membre
                </>
              ) : (
                <>
                  <UserPlus className="h-5 w-5 text-blue-600" />
                  Ajouter un Membre
                </>
              )}
            </h3>
            <div className="space-y-4">
              <div className="relative">
                <input
                  type="text"
                  placeholder="Nom complet"
                  autoFocus
                  value={membreAModifier ? membreAModifier.nom : nouveauMembre.nom}
                  onChange={(e) => {
                    if (membreAModifier) {
                      setMembreAModifier({...membreAModifier, nom: e.target.value});
                    } else {
                      setNouveauMembre({...nouveauMembre, nom: e.target.value});
                    }
                  }}
                  className="w-full p-3 pl-10 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500"
                />
                <Users className="absolute left-3 top-1/2 transform -translate-y-1/2 h-4 w-4 text-gray-400 pointer-events-none" />
              </div>
              
              <div className="relative">
                <input
                  type="email"
                  placeholder="Email professionnel"
                  value={membreAModifier ? membreAModifier.email : nouveauMembre.email}
                  onChange={(e) => {
                    if (membreAModifier) {
                      setMembreAModifier({...membreAModifier, email: e.target.value});
                    } else {
                      setNouveauMembre({...nouveauMembre, email: e.target.value});
                    }
                  }}
                  className="w-full p-3 pl-10 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500"
                />
                <Mail className="absolute left-3 top-1/2 transform -translate-y-1/2 h-4 w-4 text-gray-400 pointer-events-none" />
              </div>

              <div className="relative">
                <input
                  type="tel"
                  placeholder="Téléphone (optionnel)"
                  value={membreAModifier ? (membreAModifier.telephone || '') : nouveauMembre.telephone}
                  onChange={(e) => {
                    if (membreAModifier) {
                      setMembreAModifier({...membreAModifier, telephone: e.target.value});
                    } else {
                      setNouveauMembre({...nouveauMembre, telephone: e.target.value});
                    }
                  }}
                  className="w-full p-3 pl-10 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500"
                />
                <Phone className="absolute left-3 top-1/2 transform -translate-y-1/2 h-4 w-4 text-gray-400 pointer-events-none" />
              </div>

              <div className="relative">
                <input
                  type="text"
                  placeholder="IBAN (optionnel)"
                  value={membreAModifier ? (membreAModifier.iban || '') : nouveauMembre.iban}
                  onChange={(e) => {
                    if (membreAModifier) {
                      setMembreAModifier({...membreAModifier, iban: e.target.value});
                    } else {
                      setNouveauMembre({...nouveauMembre, iban: e.target.value});
                    }
                  }}
                  className="w-full p-3 pl-10 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500"
                />
                <CreditCard className="absolute left-3 top-1/2 transform -translate-y-1/2 h-4 w-4 text-gray-400 pointer-events-none" />
              </div>

              <div className="relative">
                <select
                  value={membreAModifier ? membreAModifier.role : nouveauMembre.role}
                  onChange={(e) => {
                    if (membreAModifier) {
                      setMembreAModifier({...membreAModifier, role: e.target.value});
                    } else {
                      setNouveauMembre({...nouveauMembre, role: e.target.value});
                    }
                  }}
                  className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500"
                >
                  <option value="member">👤 Membre</option>
                  <option value="partner">🤝 Associé</option>
                  <option value="admin">👑 Administrateur</option>
                </select>
              </div>

              {!membreAModifier && (
                <div className="flex gap-2 items-center">
                  <span className="text-sm text-gray-600">Couleur:</span>
                  {couleursMembres.map(couleur => (
                    <button
                      key={couleur}
                      onClick={() => setNouveauMembre({...nouveauMembre, couleur})}
                      className={`w-6 h-6 rounded-full border-2 ${nouveauMembre.couleur === couleur ? 'border-gray-800' : 'border-gray-300'}`}
                      style={{ backgroundColor: couleur }}
                    />
                  ))}
                </div>
              )}

              <div className="flex gap-3 pt-4">
                <button
                  onClick={membreAModifier ? modifierMembreConfirmer : ajouterMembre}
                  className="flex-1 bg-blue-600 text-white py-3 px-4 rounded-lg hover:bg-blue-700 font-medium"
                >
                  {membreAModifier ? 'Modifier' : 'Ajouter'}
                </button>
                <button
                  onClick={fermerToutesLesModales}
                  className="flex-1 bg-gray-300 text-gray-700 py-3 px-4 rounded-lg hover:bg-gray-400 font-medium"
                >
                  Annuler
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Modal Ajouter Dépense */}
      {affichageModal.depense && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
          <div className="bg-white rounded-xl p-6 w-full max-w-lg max-h-[90vh] overflow-y-auto">
            <h3 className="text-lg font-semibold mb-4">
              {depenseAModifier ? 'Modifier la Dépense' : 'Ajouter une Dépense'}
            </h3>
            <div className="space-y-4">
              <input
                type="text"
                placeholder="Description de la dépense"
                value={depenseAModifier ? depenseAModifier.description : nouvelleDepense.description}
                onChange={(e) => {
                  if (depenseAModifier) {
                    setDepenseAModifier({...depenseAModifier, description: e.target.value});
                  } else {
                    setNouvelleDepense({...nouvelleDepense, description: e.target.value});
                  }
                }}
                className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500"
              />
              
              <div className="grid grid-cols-2 gap-3">
                <input
                  type="number"
                  step="0.01"
                  placeholder="Montant"
                  value={depenseAModifier ? depenseAModifier.montant : nouvelleDepense.montant}
                  onChange={(e) => {
                    if (depenseAModifier) {
                      setDepenseAModifier({...depenseAModifier, montant: e.target.value});
                    } else {
                      setNouvelleDepense({...nouvelleDepense, montant: e.target.value});
                    }
                  }}
                  className="p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500"
                />
                <select
                  value={depenseAModifier ? depenseAModifier.devise : nouvelleDepense.devise}
                  onChange={(e) => {
                    if (depenseAModifier) {
                      setDepenseAModifier({...depenseAModifier, devise: e.target.value});
                    } else {
                      setNouvelleDepense({...nouvelleDepense, devise: e.target.value});
                    }
                  }}
                  className="p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500"
                >
                  {devises.map(devise => (
                    <option key={devise} value={devise}>{devise}</option>
                  ))}
                </select>
              </div>

              <select
                value={depenseAModifier ? depenseAModifier.categorie : nouvelleDepense.categorie}
                onChange={(e) => {
                  if (depenseAModifier) {
                    setDepenseAModifier({...depenseAModifier, categorie: e.target.value});
                  } else {
                    setNouvelleDepense({...nouvelleDepense, categorie: e.target.value});
                  }
                }}
                className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500"
              >
                {Object.entries(categories).map(([cle, cat]) => (
                  <option key={cle} value={cle}>{cat.icone} {cat.nom}</option>
                ))}
              </select>

              <div className="grid grid-cols-2 gap-3">
                <select
                  value={depenseAModifier ? depenseAModifier.payePar : nouvelleDepense.payePar}
                  onChange={(e) => {
                    if (depenseAModifier) {
                      setDepenseAModifier({...depenseAModifier, payePar: parseInt(e.target.value)});
                    } else {
                      setNouvelleDepense({...nouvelleDepense, payePar: parseInt(e.target.value)});
                    }
                  }}
                  className="p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500"
                >
                  {membres.map(membre => (
                    <option key={membre.id} value={membre.id}>Payé par {membre.nom}</option>
                  ))}
                </select>
                
                <select
                  value={depenseAModifier ? depenseAModifier.methodesPaiement : nouvelleDepense.methodesPaiement}
                  onChange={(e) => {
                    if (depenseAModifier) {
                      setDepenseAModifier({...depenseAModifier, methodesPaiement: e.target.value});
                    } else {
                      setNouvelleDepense({...nouvelleDepense, methodesPaiement: e.target.value});
                    }
                  }}
                  className="p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500"
                >
                  <option value="especes">💵 Espèces</option>
                  <option value="carte">💳 Carte bancaire</option>
                  <option value="virement">🏦 Virement</option>
                  <option value="crypto">₿ Crypto</option>
                  <option value="cheque">📝 Chèque</option>
                  <option value="paypal">💻 PayPal</option>
                </select>
              </div>

              {/* Section Répartition Avancée */}
              <div className="border-2 border-gray-200 rounded-lg p-4 bg-gray-50">
                <div className="flex items-center gap-3 mb-4">
                  <Split className="h-5 w-5 text-green-600" />
                  <h4 className="font-semibold text-gray-900">Répartition de la Dépense</h4>
                </div>

                {/* Type de répartition */}
                <div className="mb-4">
                  <label className="block text-sm font-medium text-gray-700 mb-2">Mode de répartition</label>
                  <div className="flex gap-2">
                    <button
                      type="button"
                      onClick={() => {
                        if (depenseAModifier) {
                          setDepenseAModifier({...depenseAModifier, typeRepartition: 'egal'});
                        } else {
                          setNouvelleDepense({...nouvelleDepense, typeRepartition: 'egal'});
                        }
                      }}
                      className={`flex-1 p-3 rounded-lg border-2 text-sm font-medium transition-colors ${
                        (depenseAModifier ? depenseAModifier.typeRepartition : nouvelleDepense.typeRepartition) === 'egal' 
                          ? 'border-green-500 bg-green-50 text-green-800' 
                          : 'border-gray-300 bg-white text-gray-700 hover:bg-gray-50'
                      }`}
                    >
                      <div className="flex items-center justify-center gap-2">
                        <Split className="h-4 w-4" />
                        Égal
                      </div>
                    </button>
                    <button
                      type="button"
                      onClick={() => {
                        if (depenseAModifier) {
                          setDepenseAModifier({...depenseAModifier, typeRepartition: 'personnalise'});
                        } else {
                          setNouvelleDepense({...nouvelleDepense, typeRepartition: 'personnalise'});
                        }
                      }}
                      className={`flex-1 p-3 rounded-lg border-2 text-sm font-medium transition-colors ${
                        (depenseAModifier ? depenseAModifier.typeRepartition : nouvelleDepense.typeRepartition) === 'personnalise' 
                          ? 'border-blue-500 bg-blue-50 text-blue-800' 
                          : 'border-gray-300 bg-white text-gray-700 hover:bg-gray-50'
                      }`}
                    >
                      <div className="flex items-center justify-center gap-2">
                        <Calculator className="h-4 w-4" />
                        Personnalisé
                      </div>
                    </button>
                  </div>
                </div>

                {/* Participants avec répartition */}
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-3">
                    Participants et montants
                    {(depenseAModifier ? depenseAModifier.typeRepartition : nouvelleDepense.typeRepartition) === 'egal' && (depenseAModifier ? depenseAModifier.participants : nouvelleDepense.participants).length > 0 && (
                      <span className="ml-2 text-xs text-gray-500">
                        ({(parseFloat(depenseAModifier ? depenseAModifier.montant : nouvelleDepense.montant) / (depenseAModifier ? depenseAModifier.participants : nouvelleDepense.participants).length || 0).toFixed(2)}€ chacun)
                      </span>
                    )}
                  </label>
                  
                  <div className="space-y-2">
                    {membres.map(membre => {
                      const currentExpense = depenseAModifier || nouvelleDepense;
                      const isParticipant = currentExpense.participants.includes(membre.id);
                      const montantPersonnalise = currentExpense.repartitionPersonnalisee[membre.id] || 0;
                      const montantEgal = currentExpense.participants.length > 0 
                        ? parseFloat(currentExpense.montant) / currentExpense.participants.length 
                        : 0;
                      
                      return (
                        <div key={membre.id} className={`p-3 rounded-lg border-2 transition-colors ${
                          isParticipant 
                            ? 'border-green-200 bg-green-50' 
                            : 'border-gray-200 bg-white'
                        }`}>
                          <div className="flex items-center gap-3">
                            <input
                              type="checkbox"
                              checked={isParticipant}
                              onChange={(e) => {
                                if (e.target.checked) {
                                  if (depenseAModifier) {
                                    setDepenseAModifier({
                                      ...depenseAModifier,
                                      participants: [...depenseAModifier.participants, membre.id]
                                    });
                                  } else {
                                    setNouvelleDepense({
                                      ...nouvelleDepense,
                                      participants: [...nouvelleDepense.participants, membre.id]
                                    });
                                  }
                                } else {
                                  if (depenseAModifier) {
                                    setDepenseAModifier({
                                      ...depenseAModifier,
                                      participants: depenseAModifier.participants.filter(id => id !== membre.id),
                                      repartitionPersonnalisee: {
                                        ...depenseAModifier.repartitionPersonnalisee,
                                        [membre.id]: 0
                                      }
                                    });
                                  } else {
                                    setNouvelleDepense({
                                      ...nouvelleDepense,
                                      participants: nouvelleDepense.participants.filter(id => id !== membre.id),
                                      repartitionPersonnalisee: {
                                        ...nouvelleDepense.repartitionPersonnalisee,
                                        [membre.id]: 0
                                      }
                                    });
                                  }
                                }
                              }}
                              className="w-4 h-4 text-green-600"
                            />
                            <div 
                              className="w-8 h-8 rounded-full flex items-center justify-center text-white text-sm font-semibold"
                              style={{ backgroundColor: membre.couleur }}
                            >
                              {membre.nom.charAt(0)}
                            </div>
                            <span className="flex-1 font-medium text-gray-900">{membre.nom}</span>
                            
                            {/* Montant pour ce participant */}
                            <div className="flex items-center gap-2">
                              {currentExpense.typeRepartition === 'egal' && isParticipant && (
                                <span className="text-sm font-medium text-green-700">
                                  {montantEgal.toFixed(2)}€
                                </span>
                              )}
                              
                              {currentExpense.typeRepartition === 'personnalise' && isParticipant && (
                                <div className="flex items-center gap-2">
                                  <input
                                    type="number"
                                    step="0.01"
                                    placeholder="0.00"
                                    value={montantPersonnalise}
                                    onChange={(e) => {
                                      const nouveauMontant = parseFloat(e.target.value) || 0;
                                      if (depenseAModifier) {
                                        setDepenseAModifier({
                                          ...depenseAModifier,
                                          repartitionPersonnalisee: {
                                            ...depenseAModifier.repartitionPersonnalisee,
                                            [membre.id]: nouveauMontant
                                          }
                                        });
                                      } else {
                                        setNouvelleDepense({
                                          ...nouvelleDepense,
                                          repartitionPersonnalisee: {
                                            ...nouvelleDepense.repartitionPersonnalisee,
                                            [membre.id]: nouveauMontant
                                          }
                                        });
                                      }
                                    }}
                                    className="w-20 p-2 border border-gray-300 rounded text-sm"
                                  />
                                  <span className="text-sm text-gray-600">€</span>
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                </div>

                {/* Validation de la répartition personnalisée */}
                {(depenseAModifier ? depenseAModifier.typeRepartition : nouvelleDepense.typeRepartition) === 'personnalise' && (depenseAModifier ? depenseAModifier.participants : nouvelleDepense.participants).length > 0 && (
                  <div className="mt-4 p-3 rounded-lg bg-blue-50 border border-blue-200">
                    <div className="flex items-center gap-2">
                      <Calculator className="h-4 w-4 text-blue-600" />
                      <span className="text-sm font-medium text-blue-900">Vérification des montants</span>
                    </div>
                    <div className="mt-2 text-sm">
                      {(() => {
                        const currentData = depenseAModifier || nouvelleDepense;
                        const montantTotal = parseFloat(currentData.montant) || 0;
                        const montantReparti = currentData.participants.reduce((sum, id) => 
                          sum + (parseFloat(currentData.repartitionPersonnalisee[id]) || 0), 0
                        );
                        const difference = montantTotal - montantReparti;
                        
                        if (Math.abs(difference) < 0.01) {
                          return (
                            <div className="flex items-center gap-2 text-green-700">
                              <CheckCircle className="h-4 w-4" />
                              <span>Répartition correcte: {montantReparti.toFixed(2)}€ / {montantTotal.toFixed(2)}€</span>
                            </div>
                          );
                        } else {
                          return (
                            <div className="flex items-center gap-2 text-red-700">
                              <AlertCircle className="h-4 w-4" />
                              <span>
                                Différence: {Math.abs(difference).toFixed(2)}€ 
                                ({difference > 0 ? 'manquant' : 'excédent'})
                              </span>
                            </div>
                          );
                        }
                      })()}
                    </div>
                  </div>
                )}

                {/* Actions rapides pour la répartition personnalisée */}
                {(depenseAModifier ? depenseAModifier.typeRepartition : nouvelleDepense.typeRepartition) === 'personnalise' && (depenseAModifier ? depenseAModifier.participants : nouvelleDepense.participants).length > 0 && (
                  <div className="mt-3 flex gap-2">
                    <button
                      type="button"
                      onClick={() => {
                        const currentData = depenseAModifier || nouvelleDepense;
                        const montantEgal = parseFloat(currentData.montant) / currentData.participants.length;
                        const nouvelleRepartition = {};
                        currentData.participants.forEach(id => {
                          nouvelleRepartition[id] = montantEgal;
                        });
                        if (depenseAModifier) {
                          setDepenseAModifier({
                            ...depenseAModifier,
                            repartitionPersonnalisee: nouvelleRepartition
                          });
                        } else {
                          setNouvelleDepense({
                            ...nouvelleDepense,
                            repartitionPersonnalisee: nouvelleRepartition
                          });
                        }
                      }}
                      className="flex-1 p-2 text-xs bg-blue-100 text-blue-700 rounded-lg hover:bg-blue-200 transition-colors"
                    >
                      <div className="flex items-center justify-center gap-1">
                        <Split className="h-3 w-3" />
                        Répartir également
                      </div>
                    </button>
                    <button
                      type="button"
                      onClick={() => {
                        const currentData = depenseAModifier || nouvelleDepense;
                        const nouvelleRepartition = {};
                        currentData.participants.forEach(id => {
                          nouvelleRepartition[id] = 0;
                        });
                        if (depenseAModifier) {
                          setDepenseAModifier({
                            ...depenseAModifier,
                            repartitionPersonnalisee: nouvelleRepartition
                          });
                        } else {
                          setNouvelleDepense({
                            ...nouvelleDepense,
                            repartitionPersonnalisee: nouvelleRepartition
                          });
                        }
                      }}
                      className="flex-1 p-2 text-xs bg-gray-100 text-gray-700 rounded-lg hover:bg-gray-200 transition-colors"
                    >
                      <div className="flex items-center justify-center gap-1">
                        <Trash2 className="h-3 w-3" />
                        Remettre à zéro
                      </div>
                    </button>
                  </div>
                )}
              </div>

              <div className="flex gap-3 pt-4">
                <button
                  onClick={depenseAModifier ? modifierDepenseConfirmer : ajouterDepense}
                  className="flex-1 bg-green-600 text-white py-3 px-4 rounded-lg hover:bg-green-700 font-medium"
                >
                  {depenseAModifier ? 'Modifier la Dépense' : 'Ajouter la Dépense'}
                </button>
                <button
                  onClick={() => {
                    setDepenseAModifier(null);
                    setAffichageModal({ ...affichageModal, depense: false });
                  }}
                  className="flex-1 bg-gray-300 text-gray-700 py-3 px-4 rounded-lg hover:bg-gray-400 font-medium"
                >
                  Annuler
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Modal Facture */}
      {affichageModal.facture && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
          <div className="bg-white rounded-xl p-6 w-full max-w-lg max-h-[90vh] overflow-y-auto">
            <h3 className="text-lg font-semibold mb-4">Ajouter une Facture</h3>
            <div className="space-y-4">
              <div className="grid grid-cols-2 gap-3">
                <input
                  type="text"
                  placeholder="Numéro de facture"
                  value={nouvelleFacture.numero}
                  onChange={(e) => setNouvelleFacture({...nouvelleFacture, numero: e.target.value})}
                  className="p-3 border border-gray-300 rounded-lg"
                />
                <select
                  value={nouvelleFacture.type}
                  onChange={(e) => setNouvelleFacture({...nouvelleFacture, type: e.target.value})}
                  className="p-3 border border-gray-300 rounded-lg"
                >
                  <option value="entrant">📥 Facture reçue</option>
                  <option value="sortant">📤 Facture émise</option>
                </select>
              </div>
              
              <input
                type="text"
                placeholder="Fournisseur/Client"
                value={nouvelleFacture.fournisseur}
                onChange={(e) => setNouvelleFacture({...nouvelleFacture, fournisseur: e.target.value})}
                className="w-full p-3 border border-gray-300 rounded-lg"
              />
              
              <input
                type="text"
                placeholder="Description"
                value={nouvelleFacture.description}
                onChange={(e) => setNouvelleFacture({...nouvelleFacture, description: e.target.value})}
                className="w-full p-3 border border-gray-300 rounded-lg"
              />
              
              <div className="grid grid-cols-2 gap-3">
                <input
                  type="number"
                  step="0.01"
                  placeholder="Montant"
                  value={nouvelleFacture.montant}
                  onChange={(e) => setNouvelleFacture({...nouvelleFacture, montant: e.target.value})}
                  className="p-3 border border-gray-300 rounded-lg"
                />
                <select
                  value={nouvelleFacture.statut}
                  onChange={(e) => setNouvelleFacture({...nouvelleFacture, statut: e.target.value})}
                  className="p-3 border border-gray-300 rounded-lg"
                >
                  <option value="en-attente">⏳ En attente</option>
                  <option value="payee">✅ Payée</option>
                  <option value="retard">⚠️ En retard</option>
                  <option value="annulee">❌ Annulée</option>
                </select>
              </div>
              
              <div className="grid grid-cols-2 gap-3">
                <input
                  type="date"
                  placeholder="Date émission"
                  value={nouvelleFacture.dateEmission}
                  onChange={(e) => setNouvelleFacture({...nouvelleFacture, dateEmission: e.target.value})}
                  className="p-3 border border-gray-300 rounded-lg"
                />
                <input
                  type="date"
                  placeholder="Date échéance"
                  value={nouvelleFacture.dateEcheance}
                  onChange={(e) => setNouvelleFacture({...nouvelleFacture, dateEcheance: e.target.value})}
                  className="p-3 border border-gray-300 rounded-lg"
                />
              </div>

              <div className="flex gap-3 pt-4">
                <button
                  onClick={ajouterFacture}
                  className="flex-1 bg-blue-600 text-white py-3 px-4 rounded-lg hover:bg-blue-700"
                >
                  Ajouter Facture
                </button>
                <button
                  onClick={() => setAffichageModal({ ...affichageModal, facture: false })}
                  className="flex-1 bg-gray-300 text-gray-700 py-3 px-4 rounded-lg hover:bg-gray-400"
                >
                  Annuler
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Modal Ajouter Entrée */}
      {affichageModal.entree && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
          <div className="bg-white rounded-xl p-6 w-full max-w-lg max-h-[90vh] overflow-y-auto">
            <h3 className="text-lg font-semibold mb-4">Ajouter une Entrée</h3>
            <div className="space-y-4">
              <input
                type="text"
                placeholder="Description de l'entrée"
                value={nouvelleEntree.description}
                onChange={(e) => setNouvelleEntree({...nouvelleEntree, description: e.target.value})}
                className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500"
              />
              
              <div className="grid grid-cols-2 gap-3">
                <input
                  type="number"
                  step="0.01"
                  placeholder="Montant"
                  value={nouvelleEntree.montant}
                  onChange={(e) => setNouvelleEntree({...nouvelleEntree, montant: e.target.value})}
                  className="p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500"
                />
                <select
                  value={nouvelleEntree.devise}
                  onChange={(e) => setNouvelleEntree({...nouvelleEntree, devise: e.target.value})}
                  className="p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500"
                >
                  {devises.map(devise => (
                    <option key={devise} value={devise}>{devise}</option>
                  ))}
                </select>
              </div>

              <select
                value={nouvelleEntree.categorie}
                onChange={(e) => setNouvelleEntree({...nouvelleEntree, categorie: e.target.value})}
                className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500"
              >
                {Object.entries(categoriesEntrees).map(([cle, cat]) => (
                  <option key={cle} value={cle}>{cat.icone} {cat.nom}</option>
                ))}
              </select>

              <div className="grid grid-cols-2 gap-3">
                <select
                  value={nouvelleEntree.payePar}
                  onChange={(e) => setNouvelleEntree({...nouvelleEntree, payePar: parseInt(e.target.value)})}
                  className="p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500"
                >
                  {membres.map(membre => (
                    <option key={membre.id} value={membre.id}>Reçu par {membre.nom}</option>
                  ))}
                </select>
                
                <select
                  value={nouvelleEntree.methodesPaiement}
                  onChange={(e) => setNouvelleEntree({...nouvelleEntree, methodesPaiement: e.target.value})}
                  className="p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500"
                >
                  <option value="virement">🏦 Virement</option>
                  <option value="especes">💵 Espèces</option>
                  <option value="carte">💳 Carte bancaire</option>
                  <option value="crypto">₿ Crypto</option>
                  <option value="cheque">📝 Chèque</option>
                  <option value="paypal">💻 PayPal</option>
                </select>
              </div>

              {/* Section Répartition Avancée */}
              <div className="border-2 border-gray-200 rounded-lg p-4 bg-gray-50">
                <div className="flex items-center gap-3 mb-4">
                  <Split className="h-5 w-5 text-green-600" />
                  <h4 className="font-semibold text-gray-900">Répartition de l'Entrée</h4>
                </div>

                {/* Type de répartition */}
                <div className="mb-4">
                  <label className="block text-sm font-medium text-gray-700 mb-2">Mode de répartition</label>
                  <div className="flex gap-2">
                    <button
                      type="button"
                      onClick={() => setNouvelleEntree({...nouvelleEntree, typeRepartition: 'egal'})}
                      className={`flex-1 p-3 rounded-lg border-2 text-sm font-medium transition-colors ${
                        nouvelleEntree.typeRepartition === 'egal' 
                          ? 'border-green-500 bg-green-50 text-green-800' 
                          : 'border-gray-300 bg-white text-gray-700 hover:bg-gray-50'
                      }`}
                    >
                      <div className="flex items-center justify-center gap-2">
                        <Split className="h-4 w-4" />
                        Égal
                      </div>
                    </button>
                    <button
                      type="button"
                      onClick={() => setNouvelleEntree({...nouvelleEntree, typeRepartition: 'personnalise'})}
                      className={`flex-1 p-3 rounded-lg border-2 text-sm font-medium transition-colors ${
                        nouvelleEntree.typeRepartition === 'personnalise' 
                          ? 'border-blue-500 bg-blue-50 text-blue-800' 
                          : 'border-gray-300 bg-white text-gray-700 hover:bg-gray-50'
                      }`}
                    >
                      <div className="flex items-center justify-center gap-2">
                        <Calculator className="h-4 w-4" />
                        Personnalisé
                      </div>
                    </button>
                  </div>
                </div>

                {/* Participants avec répartition */}
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-3">
                    Participants et montants
                    {nouvelleEntree.typeRepartition === 'egal' && nouvelleEntree.participants.length > 0 && (
                      <span className="ml-2 text-xs text-gray-500">
                        ({(parseFloat(nouvelleEntree.montant) / nouvelleEntree.participants.length || 0).toFixed(2)}€ chacun)
                      </span>
                    )}
                  </label>
                  
                  <div className="space-y-2">
                    {membres.map(membre => {
                      const isParticipant = nouvelleEntree.participants.includes(membre.id);
                      const montantPersonnalise = nouvelleEntree.repartitionPersonnalisee[membre.id] || 0;
                      const montantEgal = nouvelleEntree.participants.length > 0 
                        ? parseFloat(nouvelleEntree.montant) / nouvelleEntree.participants.length 
                        : 0;
                      
                      return (
                        <div key={membre.id} className={`p-3 rounded-lg border-2 transition-colors ${
                          isParticipant 
                            ? 'border-green-200 bg-green-50' 
                            : 'border-gray-200 bg-white'
                        }`}>
                          <div className="flex items-center gap-3">
                            <input
                              type="checkbox"
                              checked={isParticipant}
                              onChange={(e) => {
                                if (e.target.checked) {
                                  setNouvelleEntree({
                                    ...nouvelleEntree,
                                    participants: [...nouvelleEntree.participants, membre.id]
                                  });
                                } else {
                                  setNouvelleEntree({
                                    ...nouvelleEntree,
                                    participants: nouvelleEntree.participants.filter(id => id !== membre.id),
                                    repartitionPersonnalisee: {
                                      ...nouvelleEntree.repartitionPersonnalisee,
                                      [membre.id]: 0
                                    }
                                  });
                                }
                              }}
                              className="w-4 h-4 text-green-600"
                            />
                            <div 
                              className="w-8 h-8 rounded-full flex items-center justify-center text-white text-sm font-semibold"
                              style={{ backgroundColor: membre.couleur }}
                            >
                              {membre.nom.charAt(0)}
                            </div>
                            <span className="flex-1 font-medium text-gray-900">{membre.nom}</span>
                            
                            {/* Montant pour ce participant */}
                            <div className="flex items-center gap-2">
                              {nouvelleEntree.typeRepartition === 'egal' && isParticipant && (
                                <span className="text-sm font-medium text-green-700">
                                  {montantEgal.toFixed(2)}€
                                </span>
                              )}
                              
                              {nouvelleEntree.typeRepartition === 'personnalise' && isParticipant && (
                                <div className="flex items-center gap-2">
                                  <input
                                    type="number"
                                    step="0.01"
                                    placeholder="0.00"
                                    value={montantPersonnalise}
                                    onChange={(e) => {
                                      const nouveauMontant = parseFloat(e.target.value) || 0;
                                      setNouvelleEntree({
                                        ...nouvelleEntree,
                                        repartitionPersonnalisee: {
                                          ...nouvelleEntree.repartitionPersonnalisee,
                                          [membre.id]: nouveauMontant
                                        }
                                      });
                                    }}
                                    className="w-20 p-2 border border-gray-300 rounded text-sm"
                                  />
                                  <span className="text-sm text-gray-600">€</span>
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                </div>
              </div>

              <div className="flex gap-3 pt-4">
                <button
                  onClick={ajouterEntree}
                  className="flex-1 bg-green-600 text-white py-3 px-4 rounded-lg hover:bg-green-700 font-medium"
                >
                  Ajouter l'Entrée
                </button>
                <button
                  onClick={() => setAffichageModal({ ...affichageModal, entree: false })}
                  className="flex-1 bg-gray-300 text-gray-700 py-3 px-4 rounded-lg hover:bg-gray-400 font-medium"
                >
                  Annuler
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Modal Salaire */}
      {affichageModal.salaire && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
          <div className="bg-white rounded-xl p-6 w-full max-w-md">
            <h3 className="text-lg font-semibold mb-4">Payer un Salaire</h3>
            <div className="space-y-4">
              <select
                value={nouveauSalaire.employeId}
                onChange={(e) => setNouveauSalaire({...nouveauSalaire, employeId: parseInt(e.target.value)})}
                className="w-full p-3 border border-gray-300 rounded-lg"
              >
                {employes.map(employe => (
                  <option key={employe.id} value={employe.id}>
                    {employe.nom} - {employe.poste} ({employe.salaire}€/mois)
                  </option>
                ))}
              </select>
              
              <input
                type="month"
                value={nouveauSalaire.mois}
                onChange={(e) => setNouveauSalaire({...nouveauSalaire, mois: e.target.value})}
                className="w-full p-3 border border-gray-300 rounded-lg"
              />
              
              <input
                type="number"
                step="0.01"
                placeholder="Montant de base"
                value={nouveauSalaire.montant}
                onChange={(e) => setNouveauSalaire({...nouveauSalaire, montant: e.target.value})}
                className="w-full p-3 border border-gray-300 rounded-lg"
              />
              
              <div className="grid grid-cols-2 gap-3">
                <input
                  type="number"
                  step="0.01"
                  placeholder="Bonus"
                  value={nouveauSalaire.bonus}
                  onChange={(e) => setNouveauSalaire({...nouveauSalaire, bonus: e.target.value})}
                  className="p-3 border border-gray-300 rounded-lg"
                />
                <input
                  type="number"
                  step="0.01"
                  placeholder="Déductions"
                  value={nouveauSalaire.deductions}
                  onChange={(e) => setNouveauSalaire({...nouveauSalaire, deductions: e.target.value})}
                  className="p-3 border border-gray-300 rounded-lg"
                />
              </div>

              <div className="flex gap-3 pt-4">
                <button
                  onClick={ajouterSalaire}
                  className="flex-1 bg-purple-600 text-white py-3 px-4 rounded-lg hover:bg-purple-700"
                >
                  Payer Salaire
                </button>
                <button
                  onClick={() => setAffichageModal({ ...affichageModal, salaire: false })}
                  className="flex-1 bg-gray-300 text-gray-700 py-3 px-4 rounded-lg hover:bg-gray-400"
                >
                  Annuler
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Modal Employé */}
      {affichageModal.employe && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
          <div className="bg-white rounded-xl p-6 w-full max-w-md">
            <h3 className="text-lg font-semibold mb-4">Ajouter un Employé</h3>
            <div className="space-y-4">
              <input
                type="text"
                placeholder="Nom complet"
                value={nouvelEmploye.nom}
                onChange={(e) => setNouvelEmploye({...nouvelEmploye, nom: e.target.value})}
                className="w-full p-3 border border-gray-300 rounded-lg"
              />
              <input
                type="text"
                placeholder="Poste"
                value={nouvelEmploye.poste}
                onChange={(e) => setNouvelEmploye({...nouvelEmploye, poste: e.target.value})}
                className="w-full p-3 border border-gray-300 rounded-lg"
              />
              <input
                type="number"
                placeholder="Salaire mensuel"
                value={nouvelEmploye.salaire}
                onChange={(e) => setNouvelEmploye({...nouvelEmploye, salaire: e.target.value})}
                className="w-full p-3 border border-gray-300 rounded-lg"
              />
              <input
                type="email"
                placeholder="Email"
                value={nouvelEmploye.email}
                onChange={(e) => setNouvelEmploye({...nouvelEmploye, email: e.target.value})}
                className="w-full p-3 border border-gray-300 rounded-lg"
              />
              <input
                type="text"
                placeholder="IBAN (optionnel)"
                value={nouvelEmploye.iban}
                onChange={(e) => setNouvelEmploye({...nouvelEmploye, iban: e.target.value})}
                className="w-full p-3 border border-gray-300 rounded-lg"
              />

              <div className="flex gap-3 pt-4">
                <button
                  onClick={ajouterEmploye}
                  className="flex-1 bg-gray-600 text-white py-3 px-4 rounded-lg hover:bg-gray-700"
                >
                  Ajouter Employé
                </button>
                <button
                  onClick={() => setAffichageModal({ ...affichageModal, employe: false })}
                  className="flex-1 bg-gray-300 text-gray-700 py-3 px-4 rounded-lg hover:bg-gray-400"
                >
                  Annuler
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Modal Dépense Récurrente */}
      {affichageModal.recurrente && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
          <div className="bg-white rounded-xl p-6 w-full max-w-md">
            <h3 className="text-lg font-semibold mb-4">Ajouter Dépense Récurrente</h3>
            <div className="space-y-4">
              <input
                type="text"
                placeholder="Description"
                value={nouvelleRecurrente.description}
                onChange={(e) => setNouvelleRecurrente({...nouvelleRecurrente, description: e.target.value})}
                className="w-full p-3 border border-gray-300 rounded-lg"
              />
              <input
                type="number"
                step="0.01"
                placeholder="Montant"
                value={nouvelleRecurrente.montant}
                onChange={(e) => setNouvelleRecurrente({...nouvelleRecurrente, montant: e.target.value})}
                className="w-full p-3 border border-gray-300 rounded-lg"
              />
              <select
                value={nouvelleRecurrente.categorie}
                onChange={(e) => setNouvelleRecurrente({...nouvelleRecurrente, categorie: e.target.value})}
                className="w-full p-3 border border-gray-300 rounded-lg"
              >
                {Object.entries(categories).map(([cle, cat]) => (
                  <option key={cle} value={cle}>{cat.icone} {cat.nom}</option>
                ))}
              </select>
              <select
                value={nouvelleRecurrente.frequence}
                onChange={(e) => setNouvelleRecurrente({...nouvelleRecurrente, frequence: e.target.value})}
                className="w-full p-3 border border-gray-300 rounded-lg"
              >
                <option value="hebdomadaire">📅 Hebdomadaire</option>
                <option value="mensuel">📅 Mensuel</option>
                <option value="trimestriel">📅 Trimestriel</option>
                <option value="annuel">📅 Annuel</option>
              </select>
              <input
                type="date"
                value={nouvelleRecurrente.prochainePaie}
                onChange={(e) => setNouvelleRecurrente({...nouvelleRecurrente, prochainePaie: e.target.value})}
                className="w-full p-3 border border-gray-300 rounded-lg"
              />

              <div className="flex gap-3 pt-4">
                <button
                  onClick={ajouterRecurrente}
                  className="flex-1 bg-yellow-600 text-white py-3 px-4 rounded-lg hover:bg-yellow-700"
                >
                  Ajouter Récurrente
                </button>
                <button
                  onClick={() => setAffichageModal({ ...affichageModal, recurrente: false })}
                  className="flex-1 bg-gray-300 text-gray-700 py-3 px-4 rounded-lg hover:bg-gray-400"
                >
                  Annuler
                </button>
              </div>
            </div>
          </div>
        </div>
              )}

        {/* Modal Crédit */}
        {affichageModal.credit && (
          <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
            <div className="bg-white rounded-lg p-6 w-full max-w-2xl max-h-[90vh] overflow-y-auto">
              <h2 className="text-xl font-bold mb-6 flex items-center gap-2">
                <Banknote className="h-5 w-5 text-green-600" />
                {creditAModifier ? 'Modifier le Crédit' : 'Nouveau Crédit'}
              </h2>
              
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                {/* Informations du crédit */}
                <div className="space-y-4">
                  <h3 className="font-semibold text-gray-900 flex items-center gap-2">
                    <CreditCard className="h-4 w-4" />
                    Informations du Crédit
                  </h3>
                  
                  <input
                    type="text"
                    placeholder="Numéro de crédit"
                    value={creditAModifier ? creditAModifier.numeroCredit : nouveauCredit.numeroCredit}
                    onChange={(e) => {
                      if (creditAModifier) {
                        setCreditAModifier({...creditAModifier, numeroCredit: e.target.value});
                      } else {
                        setNouveauCredit({...nouveauCredit, numeroCredit: e.target.value});
                      }
                    }}
                    className="w-full p-2 border border-gray-300 rounded"
                  />
                  
                  <input
                    type="number"
                    placeholder="Montant du crédit (€)"
                    value={creditAModifier ? creditAModifier.montantCredit : nouveauCredit.montantCredit}
                    onChange={(e) => {
                      if (creditAModifier) {
                        setCreditAModifier({...creditAModifier, montantCredit: e.target.value});
                      } else {
                        setNouveauCredit({...nouveauCredit, montantCredit: e.target.value});
                      }
                    }}
                    className="w-full p-2 border border-gray-300 rounded"
                  />
                  
                  <input
                    type="number"
                    step="0.01"
                    placeholder="Taux d'intérêt (%)"
                    value={creditAModifier ? creditAModifier.tauxInteret : nouveauCredit.tauxInteret}
                    onChange={(e) => {
                      if (creditAModifier) {
                        setCreditAModifier({...creditAModifier, tauxInteret: e.target.value});
                      } else {
                        setNouveauCredit({...nouveauCredit, tauxInteret: e.target.value});
                      }
                    }}
                    className="w-full p-2 border border-gray-300 rounded"
                  />
                  
                  <input
                    type="number"
                    placeholder="Durée (mois)"
                    value={creditAModifier ? creditAModifier.dureeCredit : nouveauCredit.dureeCredit}
                    onChange={(e) => {
                      if (creditAModifier) {
                        setCreditAModifier({...creditAModifier, dureeCredit: e.target.value});
                      } else {
                        setNouveauCredit({...nouveauCredit, dureeCredit: e.target.value});
                      }
                    }}
                    className="w-full p-2 border border-gray-300 rounded"
                  />
                  
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">Banque</label>
                    <select
                      value={creditAModifier ? creditAModifier.banque || '' : nouveauCredit.banque || ''}
                      onChange={(e) => {
                        if (creditAModifier) {
                          setCreditAModifier({...creditAModifier, banque: e.target.value});
                        } else {
                          setNouveauCredit({...nouveauCredit, banque: e.target.value});
                        }
                      }}
                      className="w-full p-2 border border-gray-300 rounded"
                    >
                      <option value="">Sélectionner une banque</option>
                      <option value="KBC">KBC</option>
                      <option value="ING">ING</option>
                      <option value="BNP Paribas Fortis">BNP Paribas Fortis</option>
                      <option value="Belfius">Belfius</option>
                      <option value="CBC">CBC</option>
                      <option value="Argenta">Argenta</option>
                      <option value="Bank J.Van Breda & C°">Bank J.Van Breda & C°</option>
                      <option value="Deutsche Bank">Deutsche Bank</option>
                      <option value="Bank Degroof Petercam">Bank Degroof Petercam</option>
                      <option value="VDK Bank">VDK Bank</option>
                      <option value="Crelan">Crelan</option>
                      <option value="AXA Bank">AXA Bank</option>
                      <option value="Fintro">Fintro</option>
                      <option value="Hello Bank!">Hello Bank!</option>
                      <option value="Keytrade Bank">Keytrade Bank</option>
                      <option value="Santander Consumer Bank">Santander Consumer Bank</option>
                      <option value="CPH Banque">CPH Banque</option>
                      <option value="Triodos Bank">Triodos Bank</option>
                      <option value="NewB">NewB</option>
                    </select>
                  </div>
                  
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">Date de demande</label>
                    <input
                      type="date"
                      value={creditAModifier ? creditAModifier.dateDemande : nouveauCredit.dateDemande}
                      onChange={(e) => {
                        if (creditAModifier) {
                          setCreditAModifier({...creditAModifier, dateDemande: e.target.value});
                        } else {
                          setNouveauCredit({...nouveauCredit, dateDemande: e.target.value});
                        }
                      }}
                      className="w-full p-2 border border-gray-300 rounded"
                    />
                  </div>
                  
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">Début remboursement</label>
                    <input
                      type="date"
                      value={creditAModifier ? creditAModifier.dateDebutRemboursement : nouveauCredit.dateDebutRemboursement}
                      onChange={(e) => {
                        if (creditAModifier) {
                          setCreditAModifier({...creditAModifier, dateDebutRemboursement: e.target.value});
                        } else {
                          setNouveauCredit({...nouveauCredit, dateDebutRemboursement: e.target.value});
                        }
                      }}
                      className="w-full p-2 border border-gray-300 rounded"
                    />
                  </div>
                  
                  <select
                    value={creditAModifier ? creditAModifier.statut : nouveauCredit.statut}
                    onChange={(e) => {
                      if (creditAModifier) {
                        setCreditAModifier({...creditAModifier, statut: e.target.value});
                      } else {
                        setNouveauCredit({...nouveauCredit, statut: e.target.value});
                      }
                    }}
                    className="w-full p-2 border border-gray-300 rounded"
                  >
                    <option value="en_attente">En attente</option>
                    <option value="approuve">Approuvé</option>
                    <option value="actif">Actif</option>
                    <option value="termine">Terminé</option>
                    <option value="annule">Annulé</option>
                  </select>
                  
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">Statut Actif/Inactif</label>
                    <select
                      value={creditAModifier ? (creditAModifier.estActif !== undefined ? creditAModifier.estActif : true) : (nouveauCredit.estActif !== undefined ? nouveauCredit.estActif : true)}
                      onChange={(e) => {
                        const valeur = e.target.value === 'true';
                        if (creditAModifier) {
                          setCreditAModifier({...creditAModifier, estActif: valeur});
                        } else {
                          setNouveauCredit({...nouveauCredit, estActif: valeur});
                        }
                      }}
                      className="w-full p-2 border border-gray-300 rounded"
                    >
                      <option value={true}>Actif</option>
                      <option value={false}>Inactif</option>
                    </select>
                  </div>
                </div>
                
                {/* Informations du client */}
                <div className="space-y-4">
                  <h3 className="font-semibold text-gray-900 flex items-center gap-2">
                    <User className="h-4 w-4" />
                    Informations Client
                  </h3>
                  
                  <input
                    type="text"
                    placeholder="Nom du client"
                    value={creditAModifier ? creditAModifier.nomClient : nouveauCredit.nomClient}
                    onChange={(e) => {
                      if (creditAModifier) {
                        setCreditAModifier({...creditAModifier, nomClient: e.target.value});
                      } else {
                        setNouveauCredit({...nouveauCredit, nomClient: e.target.value});
                      }
                    }}
                    className="w-full p-2 border border-gray-300 rounded"
                  />
                  
                  <input
                    type="text"
                    placeholder="Prénom du client"
                    value={creditAModifier ? creditAModifier.prenomClient : nouveauCredit.prenomClient}
                    onChange={(e) => {
                      if (creditAModifier) {
                        setCreditAModifier({...creditAModifier, prenomClient: e.target.value});
                      } else {
                        setNouveauCredit({...nouveauCredit, prenomClient: e.target.value});
                      }
                    }}
                    className="w-full p-2 border border-gray-300 rounded"
                  />
                  
                  <div className="relative">
                    <Mail className="absolute left-3 top-2.5 h-4 w-4 text-gray-400" />
                    <input
                      type="email"
                      placeholder="Email du client"
                      value={creditAModifier ? creditAModifier.emailClient : nouveauCredit.emailClient}
                      onChange={(e) => {
                        if (creditAModifier) {
                          setCreditAModifier({...creditAModifier, emailClient: e.target.value});
                        } else {
                          setNouveauCredit({...nouveauCredit, emailClient: e.target.value});
                        }
                      }}
                      className="w-full p-2 pl-10 border border-gray-300 rounded"
                    />
                  </div>
                  
                  <div className="relative">
                    <Phone className="absolute left-3 top-2.5 h-4 w-4 text-gray-400" />
                    <input
                      type="tel"
                      placeholder="Téléphone du client"
                      value={creditAModifier ? creditAModifier.telephoneClient : nouveauCredit.telephoneClient}
                      onChange={(e) => {
                        if (creditAModifier) {
                          setCreditAModifier({...creditAModifier, telephoneClient: e.target.value});
                        } else {
                          setNouveauCredit({...nouveauCredit, telephoneClient: e.target.value});
                        }
                      }}
                      className="w-full p-2 pl-10 border border-gray-300 rounded"
                    />
                  </div>
                  
                  <div className="relative">
                    <MapPin className="absolute left-3 top-2.5 h-4 w-4 text-gray-400" />
                    <textarea
                      placeholder="Adresse du client"
                      value={creditAModifier ? creditAModifier.adresseClient : nouveauCredit.adresseClient}
                      onChange={(e) => {
                        if (creditAModifier) {
                          setCreditAModifier({...creditAModifier, adresseClient: e.target.value});
                        } else {
                          setNouveauCredit({...nouveauCredit, adresseClient: e.target.value});
                        }
                      }}
                      className="w-full p-2 pl-10 border border-gray-300 rounded resize-none"
                      rows="3"
                    />
                  </div>
                  
                  <div className="relative">
                    <CreditCard className="absolute left-3 top-2.5 h-4 w-4 text-gray-400" />
                    <input
                      type="text"
                      placeholder="IBAN du client"
                      value={creditAModifier ? creditAModifier.ibanClient : nouveauCredit.ibanClient}
                      onChange={(e) => {
                        if (creditAModifier) {
                          setCreditAModifier({...creditAModifier, ibanClient: e.target.value});
                        } else {
                          setNouveauCredit({...nouveauCredit, ibanClient: e.target.value});
                        }
                      }}
                      className="w-full p-2 pl-10 border border-gray-300 rounded"
                    />
                  </div>
                  
                  {/* Membres rembourseurs */}
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      Membres responsables du remboursement
                    </label>
                    <div className="space-y-2 max-h-32 overflow-y-auto border border-gray-300 rounded p-2">
                      {membres.map(membre => (
                        <label key={membre.id} className="flex items-center gap-2">
                          <input
                            type="checkbox"
                            checked={creditAModifier ? 
                              (creditAModifier.membresRembourseurs || []).includes(membre.id) :
                              nouveauCredit.membresRembourseurs.includes(membre.id)}
                            onChange={(e) => {
                              if (creditAModifier) {
                                const nouveauxMembres = e.target.checked
                                  ? [...(creditAModifier.membresRembourseurs || []), membre.id]
                                  : (creditAModifier.membresRembourseurs || []).filter(id => id !== membre.id);
                                setCreditAModifier({...creditAModifier, membresRembourseurs: nouveauxMembres});
                              } else {
                                const nouveauxMembres = e.target.checked
                                  ? [...nouveauCredit.membresRembourseurs, membre.id]
                                  : nouveauCredit.membresRembourseurs.filter(id => id !== membre.id);
                                setNouveauCredit({...nouveauCredit, membresRembourseurs: nouveauxMembres});
                              }
                            }}
                            className="rounded"
                          />
                          <span className="text-sm">{membre.nom}</span>
                        </label>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
              
              {/* Section Notes */}
              <div className="mt-6 p-4 bg-gray-50 rounded-lg">
                <h3 className="font-semibold text-gray-900 mb-4 flex items-center gap-2">
                  <FileText className="h-4 w-4" />
                  Notes du Crédit
                </h3>
                
                {/* Affichage des notes existantes */}
                <div className="mb-4 max-h-40 overflow-y-auto">
                  {((creditAModifier && creditAModifier.notes) || nouveauCredit.notes || [])
                    .sort((a, b) => new Date(b.date) - new Date(a.date))
                    .map((note, index) => (
                    <div key={index} className="bg-white p-3 rounded border mb-2 group hover:border-gray-300 transition-colors">
                      <div className="flex justify-between items-start mb-1">
                        <span className="text-xs text-gray-500">
                          {new Date(note.date).toLocaleDateString('fr-FR', {
                            year: 'numeric',
                            month: '2-digit',
                            day: '2-digit',
                            hour: '2-digit',
                            minute: '2-digit'
                          })}
                        </span>
                        <button
                          onClick={() => {
                            if (creditAModifier) {
                              const notesExistantes = creditAModifier.notes || [];
                              const nouvellesNotes = notesExistantes.filter((_, i) => i !== index);
                              const creditModifie = {
                                ...creditAModifier,
                                notes: nouvellesNotes
                              };
                              setCreditAModifier(creditModifie);
                              
                              // Sauvegarder automatiquement dans la liste des crédits
                              setCredits(credits.map(c => c.id === creditAModifier.id ? creditModifie : c));
                            } else {
                              const notesExistantes = nouveauCredit.notes || [];
                              const nouvellesNotes = notesExistantes.filter((_, i) => i !== index);
                              setNouveauCredit({
                                ...nouveauCredit,
                                notes: nouvellesNotes
                              });
                            }
                          }}
                          className="text-red-500 hover:text-red-700 opacity-0 group-hover:opacity-100 transition-opacity"
                          title="Supprimer cette note"
                        >
                          <Trash2 className="h-4 w-4" />
                        </button>
                      </div>
                      <p className="text-sm text-gray-700">{note.contenu}</p>
                    </div>
                  ))}
                  {((creditAModifier && creditAModifier.notes) || nouveauCredit.notes || []).length === 0 && (
                    <p className="text-gray-500 text-sm italic">Aucune note pour ce crédit</p>
                  )}
                </div>
                
                {/* Ajout de nouvelle note */}
                <div className="flex gap-2">
                  <textarea
                    placeholder="Ajouter une note..."
                    value={nouvelleNote}
                    onChange={(e) => setNouvelleNote(e.target.value)}
                    className="flex-1 p-2 border border-gray-300 rounded resize-none"
                    rows="2"
                  />
                  <button
                    onClick={() => {
                      if (nouvelleNote.trim()) {
                        const nouvelleDateNote = {
                          date: new Date().toISOString(),
                          contenu: nouvelleNote.trim()
                        };
                        
                        if (creditAModifier) {
                          const notesExistantes = creditAModifier.notes || [];
                          const creditModifie = {
                            ...creditAModifier, 
                            notes: [...notesExistantes, nouvelleDateNote]
                          };
                          setCreditAModifier(creditModifie);
                          
                          // Sauvegarder automatiquement dans la liste des crédits
                          setCredits(credits.map(c => c.id === creditAModifier.id ? creditModifie : c));
                        } else {
                          const notesExistantes = nouveauCredit.notes || [];
                          setNouveauCredit({
                            ...nouveauCredit,
                            notes: [...notesExistantes, nouvelleDateNote]
                          });
                        }
                        setNouvelleNote('');
                      }
                    }}
                    className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700 self-start"
                  >
                    <Plus className="h-4 w-4" />
                  </button>
                </div>
              </div>
              
              <div className="flex gap-2 mt-6">
                <button 
                  onClick={creditAModifier ? modifierCreditConfirmer : ajouterCredit} 
                  className="btn-primary flex-1"
                >
                  {creditAModifier ? 'Modifier' : 'Créer'} le Crédit
                </button>
                <button
                  onClick={() => {
                    setCreditAModifier(null);
                    setNouvelleNote('');
                    setAffichageModal({...affichageModal, credit: false});
                  }}
                  className="px-4 py-2 border border-gray-300 rounded hover:bg-gray-50 flex-1"
                >
                  Annuler
                </button>
              </div>
            </div>
          </div>
        )}

        {/* Modal Remboursement */}
        {affichageModal.remboursement && (
          <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
            <div className="bg-white rounded-lg p-6 w-full max-w-md">
              <h2 className="text-xl font-bold mb-4 flex items-center gap-2">
                <Receipt className="h-5 w-5 text-blue-600" />
                Enregistrer un Remboursement
              </h2>
              <div className="space-y-4">
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">Crédit</label>
                  <select
                    value={nouveauRemboursement.creditId}
                    onChange={(e) => setNouveauRemboursement({...nouveauRemboursement, creditId: e.target.value})}
                    className="w-full p-2 border border-gray-300 rounded"
                  >
                    <option value="">Sélectionner un crédit</option>
                    {credits.filter(c => ['actif', 'approuve'].includes(obtenirStatutCredit(c))).map(credit => (
                      <option key={credit.id} value={credit.id}>
                        {credit.numeroCredit} - {credit.nomClient} {credit.prenomClient}
                      </option>
                    ))}
                  </select>
                </div>
                
                <input
                  type="number"
                  step="0.01"
                  placeholder="Montant remboursé (€)"
                  value={nouveauRemboursement.montant}
                  onChange={(e) => setNouveauRemboursement({...nouveauRemboursement, montant: e.target.value})}
                  className="w-full p-2 border border-gray-300 rounded"
                />
                
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">Date de paiement</label>
                  <input
                    type="date"
                    value={nouveauRemboursement.datePaiement}
                    onChange={(e) => setNouveauRemboursement({...nouveauRemboursement, datePaiement: e.target.value})}
                    className="w-full p-2 border border-gray-300 rounded"
                  />
                </div>
                
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">Payé par</label>
                  <select
                    value={nouveauRemboursement.payePar}
                    onChange={(e) => setNouveauRemboursement({...nouveauRemboursement, payePar: e.target.value})}
                    className="w-full p-2 border border-gray-300 rounded"
                  >
                    <option value="">Sélectionner un membre</option>
                    {membres.map(membre => (
                      <option key={membre.id} value={membre.id}>{membre.nom}</option>
                    ))}
                  </select>
                </div>
                
                <select
                  value={nouveauRemboursement.methodesPaiement}
                  onChange={(e) => setNouveauRemboursement({...nouveauRemboursement, methodesPaiement: e.target.value})}
                  className="w-full p-2 border border-gray-300 rounded"
                >
                  <option value="virement">Virement bancaire</option>
                  <option value="especes">Espèces</option>
                  <option value="carte">Carte bancaire</option>
                  <option value="cheque">Chèque</option>
                </select>
                
                <input
                  type="text"
                  placeholder="Référence / Note (optionnel)"
                  value={nouveauRemboursement.reference}
                  onChange={(e) => setNouveauRemboursement({...nouveauRemboursement, reference: e.target.value})}
                  className="w-full p-2 border border-gray-300 rounded"
                />
              </div>
              <div className="flex gap-2 mt-6">
                <button onClick={ajouterRemboursement} className="btn-primary flex-1">
                  Enregistrer
                </button>
                <button
                  onClick={() => setAffichageModal({...affichageModal, remboursement: false})}
                  className="px-4 py-2 border border-gray-300 rounded hover:bg-gray-50 flex-1"
                >
                  Annuler
                </button>
              </div>
            </div>
          </div>
        )}

        {/* ========================================
             MODALES DU SYSTÈME DE FACTURATION BELGE
             ======================================== */}

        {/* Modal Nouveau Client Belge */}
        {affichageModalBelge.client && (
          <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
            <div className="bg-white rounded-lg p-6 w-full max-w-2xl max-h-[90vh] overflow-y-auto">
              <h2 className="text-xl font-bold mb-4 flex items-center gap-2">
                <UserPlus className="h-5 w-5 text-blue-600" />
                Nouveau Client Belge
              </h2>
              
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">Prénom *</label>
                  <input
                    type="text"
                    value={nouveauClientBelge.prenom}
                    onChange={(e) => setNouveauClientBelge({...nouveauClientBelge, prenom: e.target.value})}
                    className="w-full p-2 border border-gray-300 rounded"
                    placeholder="Jean"
                  />
                </div>
                
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">Nom *</label>
                  <input
                    type="text"
                    value={nouveauClientBelge.nom}
                    onChange={(e) => setNouveauClientBelge({...nouveauClientBelge, nom: e.target.value})}
                    className="w-full p-2 border border-gray-300 rounded"
                    placeholder="Dupont"
                  />
                </div>
                
                <div className="md:col-span-2">
                  <label className="block text-sm font-medium text-gray-700 mb-1">Entreprise</label>
                  <input
                    type="text"
                    value={nouveauClientBelge.entreprise}
                    onChange={(e) => setNouveauClientBelge({...nouveauClientBelge, entreprise: e.target.value})}
                    className="w-full p-2 border border-gray-300 rounded"
                    placeholder="Nom de l'entreprise"
                  />
                </div>
                
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">N° TVA Belge</label>
                  <input
                    type="text"
                    value={nouveauClientBelge.numeroTVA}
                    onChange={(e) => setNouveauClientBelge({...nouveauClientBelge, numeroTVA: e.target.value})}
                    className="w-full p-2 border border-gray-300 rounded"
                    placeholder="BE 0XXX.XXX.XXX"
                  />
                  {nouveauClientBelge.numeroTVA && !validerNumeroTVABelge(nouveauClientBelge.numeroTVA) && (
                    <p className="text-sm text-red-600 mt-1">Format invalide. Utilisez BE 0XXX.XXX.XXX</p>
                  )}
                </div>
                
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">Email *</label>
                  <input
                    type="email"
                    value={nouveauClientBelge.email}
                    onChange={(e) => setNouveauClientBelge({...nouveauClientBelge, email: e.target.value})}
                    className="w-full p-2 border border-gray-300 rounded"
                    placeholder="client@email.com"
                  />
                </div>
                
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">Téléphone</label>
                  <input
                    type="tel"
                    value={nouveauClientBelge.telephone}
                    onChange={(e) => setNouveauClientBelge({...nouveauClientBelge, telephone: e.target.value})}
                    className="w-full p-2 border border-gray-300 rounded"
                    placeholder="+32 XXX XX XX XX"
                  />
                </div>
                
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">Langue</label>
                  <select
                    value={nouveauClientBelge.langue}
                    onChange={(e) => setNouveauClientBelge({...nouveauClientBelge, langue: e.target.value})}
                    className="w-full p-2 border border-gray-300 rounded"
                  >
                    <option value="fr">Français</option>
                    <option value="nl">Néerlandais</option>
                  </select>
                </div>
                
                <div className="md:col-span-2">
                  <label className="block text-sm font-medium text-gray-700 mb-1">Adresse</label>
                  <textarea
                    value={nouveauClientBelge.adresse}
                    onChange={(e) => setNouveauClientBelge({...nouveauClientBelge, adresse: e.target.value})}
                    className="w-full p-2 border border-gray-300 rounded resize-none"
                    rows="2"
                    placeholder="Rue de la Paix 123"
                  />
                </div>
                
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">Code Postal</label>
                  <input
                    type="text"
                    value={nouveauClientBelge.codePostal}
                    onChange={(e) => setNouveauClientBelge({...nouveauClientBelge, codePostal: e.target.value})}
                    className="w-full p-2 border border-gray-300 rounded"
                    placeholder="1000"
                  />
                </div>
                
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">Ville</label>
                  <input
                    type="text"
                    value={nouveauClientBelge.ville}
                    onChange={(e) => setNouveauClientBelge({...nouveauClientBelge, ville: e.target.value})}
                    className="w-full p-2 border border-gray-300 rounded"
                    placeholder="Bruxelles"
                  />
                </div>
                
                <div className="md:col-span-2">
                  <label className="block text-sm font-medium text-gray-700 mb-1">IBAN</label>
                  <input
                    type="text"
                    value={nouveauClientBelge.iban}
                    onChange={(e) => setNouveauClientBelge({...nouveauClientBelge, iban: e.target.value})}
                    className="w-full p-2 border border-gray-300 rounded"
                    placeholder="BE68 5390 0754 7034"
                  />
                </div>
                
                <div className="md:col-span-2">
                  <label className="block text-sm font-medium text-gray-700 mb-1">Notes</label>
                  <textarea
                    value={nouveauClientBelge.notes}
                    onChange={(e) => setNouveauClientBelge({...nouveauClientBelge, notes: e.target.value})}
                    className="w-full p-2 border border-gray-300 rounded resize-none"
                    rows="3"
                    placeholder="Notes additionnelles..."
                  />
                </div>
              </div>
              
              <div className="flex gap-2 mt-6">
                <button onClick={ajouterClientBelge} className="btn-primary flex-1">
                  Ajouter Client
                </button>
                <button
                  onClick={() => setAffichageModalBelge({...affichageModalBelge, client: false})}
                  className="px-4 py-2 border border-gray-300 rounded hover:bg-gray-50 flex-1"
                >
                  Annuler
                </button>
              </div>
            </div>
          </div>
        )}

        {/* Modal Nouveau Produit/Service */}
        {affichageModalBelge.produit && (
          <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
            <div className="bg-white rounded-lg p-6 w-full max-w-2xl">
              <h2 className="text-xl font-bold mb-4 flex items-center gap-2">
                <Plus className="h-5 w-5 text-green-600" />
                Nouveau Produit/Service
              </h2>
              
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div className="md:col-span-2">
                  <label className="block text-sm font-medium text-gray-700 mb-1">Nom *</label>
                  <input
                    type="text"
                    value={nouveauProduitBelge.nom}
                    onChange={(e) => setNouveauProduitBelge({...nouveauProduitBelge, nom: e.target.value})}
                    className="w-full p-2 border border-gray-300 rounded"
                    placeholder="Nom du produit ou service"
                  />
                </div>
                
                <div className="md:col-span-2">
                  <label className="block text-sm font-medium text-gray-700 mb-1">Description</label>
                  <textarea
                    value={nouveauProduitBelge.description}
                    onChange={(e) => setNouveauProduitBelge({...nouveauProduitBelge, description: e.target.value})}
                    className="w-full p-2 border border-gray-300 rounded resize-none"
                    rows="3"
                    placeholder="Description détaillée..."
                  />
                </div>
                
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">Prix HT (€) *</label>
                  <input
                    type="number"
                    step="0.01"
                    value={nouveauProduitBelge.prix}
                    onChange={(e) => setNouveauProduitBelge({...nouveauProduitBelge, prix: e.target.value})}
                    className="w-full p-2 border border-gray-300 rounded"
                    placeholder="100.00"
                  />
                </div>
                
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">Taux TVA</label>
                  <select
                    value={nouveauProduitBelge.tauxTVA}
                    onChange={(e) => setNouveauProduitBelge({...nouveauProduitBelge, tauxTVA: e.target.value})}
                    className="w-full p-2 border border-gray-300 rounded"
                  >
                    {Object.entries(tauxTVABelges).map(([taux, info]) => (
                      <option key={taux} value={taux}>{info.nom}</option>
                    ))}
                  </select>
                </div>
                
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">Unité</label>
                  <select
                    value={nouveauProduitBelge.unite}
                    onChange={(e) => setNouveauProduitBelge({...nouveauProduitBelge, unite: e.target.value})}
                    className="w-full p-2 border border-gray-300 rounded"
                  >
                    {unitesMesure.map(unite => (
                      <option key={unite} value={unite}>{unite}</option>
                    ))}
                  </select>
                </div>
                
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">Catégorie</label>
                  <select
                    value={nouveauProduitBelge.categorie}
                    onChange={(e) => setNouveauProduitBelge({...nouveauProduitBelge, categorie: e.target.value})}
                    className="w-full p-2 border border-gray-300 rounded"
                  >
                    {Object.entries(categoriesProduits).map(([key, cat]) => (
                      <option key={key} value={key}>{cat.icone} {cat.nom}</option>
                    ))}
                  </select>
                </div>
                
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">Code produit</label>
                  <input
                    type="text"
                    value={nouveauProduitBelge.code}
                    onChange={(e) => setNouveauProduitBelge({...nouveauProduitBelge, code: e.target.value})}
                    className="w-full p-2 border border-gray-300 rounded"
                    placeholder="SKU-001"
                  />
                </div>
                
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">Stock</label>
                  <input
                    type="number"
                    value={nouveauProduitBelge.stock}
                    onChange={(e) => setNouveauProduitBelge({...nouveauProduitBelge, stock: e.target.value})}
                    className="w-full p-2 border border-gray-300 rounded"
                    placeholder="100"
                  />
                </div>
              </div>
              
              {/* Aperçu prix */}
              {nouveauProduitBelge.prix && (
                <div className="mt-4 p-3 bg-gray-50 rounded">
                  <div className="text-sm text-gray-600">
                    Prix TTC: <span className="font-semibold">
                      {(parseFloat(nouveauProduitBelge.prix || 0) * (1 + tauxTVABelges[nouveauProduitBelge.tauxTVA].taux / 100)).toFixed(2)}€
                    </span>
                    {' '}(TVA {tauxTVABelges[nouveauProduitBelge.tauxTVA].taux}%: {' '}
                    {(parseFloat(nouveauProduitBelge.prix || 0) * (tauxTVABelges[nouveauProduitBelge.tauxTVA].taux / 100)).toFixed(2)}€)
                  </div>
                </div>
              )}
              
              <div className="flex gap-2 mt-6">
                <button onClick={ajouterProduitBelge} className="btn-success flex-1">
                  Ajouter Produit/Service
                </button>
                <button
                  onClick={() => setAffichageModalBelge({...affichageModalBelge, produit: false})}
                  className="px-4 py-2 border border-gray-300 rounded hover:bg-gray-50 flex-1"
                >
                  Annuler
                </button>
              </div>
            </div>
          </div>
        )}

        {/* Modal Nouvelle Facture */}
        {affichageModalBelge.facture && (
          <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
            <div className="bg-white rounded-lg p-6 w-full max-w-4xl max-h-[90vh] overflow-y-auto">
              <h2 className="text-xl font-bold mb-4 flex items-center gap-2">
                <FileText className="h-5 w-5 text-purple-600" />
                Nouvelle Facture Belge
              </h2>
              
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                {/* Informations générales */}
                <div className="space-y-4">
                  <h3 className="font-semibold text-gray-900">Informations générales</h3>
                  
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">N° Facture</label>
                    <input
                      type="text"
                      value={nouvelleFactureBelge.numero}
                      onChange={(e) => setNouvelleFactureBelge({...nouvelleFactureBelge, numero: e.target.value})}
                      className="w-full p-2 border border-gray-300 rounded"
                      placeholder={genererNumeroFacture()}
                    />
                  </div>
                  
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">Client *</label>
                    <select
                      value={nouvelleFactureBelge.clientId}
                      onChange={(e) => setNouvelleFactureBelge({...nouvelleFactureBelge, clientId: e.target.value})}
                      className="w-full p-2 border border-gray-300 rounded"
                    >
                      <option value="">Sélectionner un client</option>
                      {clientsBelges.map(client => (
                        <option key={client.id} value={client.id}>
                          {client.prenom} {client.nom} {client.entreprise ? `(${client.entreprise})` : ''}
                        </option>
                      ))}
                    </select>
                  </div>
                  
                  <div className="grid grid-cols-2 gap-4">
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-1">Date émission</label>
                      <input
                        type="date"
                        value={nouvelleFactureBelge.dateEmission}
                        onChange={(e) => setNouvelleFactureBelge({...nouvelleFactureBelge, dateEmission: e.target.value})}
                        className="w-full p-2 border border-gray-300 rounded"
                      />
                    </div>
                    
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-1">Date échéance</label>
                      <input
                        type="date"
                        value={nouvelleFactureBelge.dateEcheance}
                        onChange={(e) => setNouvelleFactureBelge({...nouvelleFactureBelge, dateEcheance: e.target.value})}
                        className="w-full p-2 border border-gray-300 rounded"
                      />
                    </div>
                  </div>
                  
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">Conditions de paiement</label>
                    <select
                      value={nouvelleFactureBelge.conditionsPaiement}
                      onChange={(e) => setNouvelleFactureBelge({...nouvelleFactureBelge, conditionsPaiement: e.target.value})}
                      className="w-full p-2 border border-gray-300 rounded"
                    >
                      <option value="virement">Virement bancaire</option>
                      <option value="bancontact">Bancontact</option>
                      <option value="especes">Espèces</option>
                      <option value="cheque">Chèque</option>
                    </select>
                  </div>
                </div>
                
                {/* Produits/Services */}
                <div className="space-y-4">
                  <h3 className="font-semibold text-gray-900">Ajouter des produits/services</h3>
                  
                  <div className="max-h-40 overflow-y-auto border rounded p-3">
                    {produitsBelges.length === 0 ? (
                      <p className="text-gray-500 text-sm">Aucun produit disponible</p>
                    ) : (
                      produitsBelges.map(produit => (
                        <div key={produit.id} className="flex items-center justify-between py-2 border-b last:border-b-0">
                          <div className="flex-1">
                            <div className="font-medium text-sm">{produit.nom}</div>
                            <div className="text-xs text-gray-500">{produit.prix.toFixed(2)}€ HT</div>
                          </div>
                          <button
                            onClick={() => ajouterProduitAFacture(produit.id)}
                            className="bg-purple-600 text-white px-2 py-1 rounded text-xs hover:bg-purple-700"
                          >
                            Ajouter
                          </button>
                        </div>
                      ))
                    )}
                  </div>
                </div>
              </div>
              
              {/* Liste des items de la facture */}
              {nouvelleFactureBelge.items.length > 0 && (
                <div className="mt-6">
                  <h3 className="font-semibold text-gray-900 mb-3">Items de la facture</h3>
                  <div className="overflow-x-auto">
                    <table className="w-full border rounded">
                      <thead className="bg-gray-50">
                        <tr>
                          <th className="text-left p-2 text-sm font-medium">Produit</th>
                          <th className="text-left p-2 text-sm font-medium">Qté</th>
                          <th className="text-left p-2 text-sm font-medium">Prix HT</th>
                          <th className="text-left p-2 text-sm font-medium">TVA</th>
                          <th className="text-left p-2 text-sm font-medium">Total</th>
                          <th className="text-left p-2 text-sm font-medium">Actions</th>
                        </tr>
                      </thead>
                      <tbody>
                        {nouvelleFactureBelge.items.map((item, index) => (
                          <tr key={index} className="border-t">
                            <td className="p-2 text-sm">{item.nom}</td>
                            <td className="p-2">
                              <input
                                type="number"
                                value={item.quantite}
                                onChange={(e) => {
                                  const newItems = [...nouvelleFactureBelge.items];
                                  newItems[index].quantite = parseFloat(e.target.value) || 1;
                                  setNouvelleFactureBelge({...nouvelleFactureBelge, items: newItems});
                                }}
                                className="w-16 p-1 border rounded text-sm"
                                min="1"
                              />
                            </td>
                            <td className="p-2 text-sm">{item.prixUnitaire.toFixed(2)}€</td>
                            <td className="p-2 text-sm">{tauxTVABelges[item.tauxTVA].taux}%</td>
                            <td className="p-2 text-sm font-medium">
                              {(item.quantite * item.prixUnitaire).toFixed(2)}€
                            </td>
                            <td className="p-2">
                              <button
                                onClick={() => {
                                  const newItems = nouvelleFactureBelge.items.filter((_, i) => i !== index);
                                  setNouvelleFactureBelge({...nouvelleFactureBelge, items: newItems});
                                }}
                                className="text-red-500 hover:text-red-700"
                              >
                                <Trash2 className="h-4 w-4" />
                              </button>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              )}
              
              <div className="flex gap-2 mt-6">
                <button onClick={ajouterFactureBelge} className="bg-purple-600 text-white px-6 py-2 rounded hover:bg-purple-700 flex-1">
                  Créer Facture
                </button>
                <button
                  onClick={() => setAffichageModalBelge({...affichageModalBelge, facture: false})}
                  className="px-4 py-2 border border-gray-300 rounded hover:bg-gray-50 flex-1"
                >
                  Annuler
                </button>
              </div>
            </div>
          </div>
        )}

      {/* Floating Action Button */}
      <button
        onClick={() => setAffichageModal({ ...affichageModal, depense: true })}
        className="fab"
        title="Ajouter une dépense rapide"
      >
        <Plus className="h-6 w-6" />
      </button>
    </div>
  );
};

export default MonarchTradeGroup; 